var nscs;
(function (nscs) {
    class App extends Phaser.Game {
        constructor() {
            let config = {
                type: nscs.util.Functions.DetectPhaserRenderMode(),
                width: App.CANVAS_WIDTH,
                height: App.CANVAS_HEIGHT,
                physics: {
                    default: 'arcade',
                    arcade: {
                        gravity: { y: nscs.gameplay.Gameplay.gravity0 },
                    }
                },
                scale: {
                    mode: FitScaleManager.detectBestScaleMode(),
                    autoCenter: Phaser.Scale.CENTER_BOTH
                },
                transparent: false,
                backgroundColor: "0x323232",
                scene: {
                    create: () => {
                        this.scene.add('Boot', nscs.scene.Boot, true);
                    }
                }
            };
            super(config);
        }
    }
    App.CANVAS_WIDTH = 480;
    App.CANVAS_HEIGHT = 320;
    nscs.App = App;
})(nscs || (nscs = {}));
function toGlobal(object, point) {
    let pos = point ? { x: point.x, y: point.y } : { x: 0, y: 0 };
    let parentContainer = object;
    while (parentContainer) {
        pos.x *= parentContainer.scaleX;
        pos.y *= parentContainer.scaleY;
        pos.x += parentContainer.x;
        pos.y += parentContainer.y;
        parentContainer = parentContainer.parentContainer;
    }
    return pos;
}
let game;
window.onload = () => {
    nscs.util.Functions.rewriteWordWrapping();
    game = new nscs.App();
};
/**
 * @author Roman Parada
 * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
 * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
 *
 * How to use:
 * Just call the code line below in Boot scene's init() method of your project:
 * new FitScaleManager(this.game).setup();
 */
class FitScaleManager {
    constructor(game) {
        this.doResize = () => {
            let scale = this.calculateScale();
            let newCanvasWidth = this.phaserScaleManager.width * scale;
            let newCanvasHeight = this.phaserScaleManager.height * scale;
            this.canvasStyle.width = newCanvasWidth + 'px';
            this.canvasStyle.height = newCanvasHeight + 'px';
            this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
            this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
        };
        this.game = game;
        this.canvasStyle = this.game.canvas.style;
        this.phaserScaleManager = this.game.scale;
    }
    static detectBestScaleMode() {
        let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
        let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
        return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
    }
    ;
    /**
     * Just call this method once in Boot scene's init() method
     */
    setup() {
        this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
        this.overridePhaserTransformMethods();
        this.onResize();
    }
    calculateScale() {
        if (game.scale.scaleMode == Phaser.Scale.NONE)
            return 1;
        return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
    }
    overridePhaserTransformMethods() {
        this.game.scale.transformX = (pageX) => {
            return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
        };
        this.game.scale.transformY = (pageY) => {
            return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
        };
    }
    onResize() {
        setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
    }
}
FitScaleManager.RESIZE_DELAY = 500;
var nscs;
(function (nscs) {
    var character;
    (function (character) {
        class Boss extends Phaser.GameObjects.Container {
            constructor(scene) {
                super(scene, 0, 0);
                this.lives = 4;
                this.reset = () => {
                    this.setAction(null);
                    this.playDefAnimations();
                };
                this.player = null;
                this.currAction = null;
                this.tryCatchSpeedY = 1;
                this.followSpeedX = 1;
                this.activationTryCatchDist = 40;
                this.playerBossDy = 110;
                this.ticker = 0;
                this.chains = nscs.scene.MainScene.instance.add.sprite(0, -150, 'boss-atlas', 'chains' + '0000');
                this.chains.setOrigin(0.5, 0);
                this.chainsMak = new Phaser.GameObjects.Graphics(this.scene);
                this.chains.mask = this.chainsMak.createGeometryMask();
                this.updateChains();
                this.claw1_mc = nscs.scene.MainScene.instance.physics.add.sprite(-13, 109, 'boss-atlas', 'claw_mc' + '0000');
                this.claw1_mc.setOrigin(47 / 71, 20 / 80);
                this.claw1_mc.setBounce(0);
                this.claw1_mc.setCollideWorldBounds(false);
                this.claw1_mc.setImmovable(true);
                this.claw1_mc.body["setAllowGravity"](false);
                this.claw1_mc.body.setSize(47, 30);
                this.claw1_mc.body.setOffset(13, 15);
                this.claw2_mc = nscs.scene.MainScene.instance.physics.add.sprite(13, 109, 'boss-atlas', 'claw_mc' + '0000');
                this.claw2_mc.setOrigin(47 / 71, 20 / 80);
                this.claw2_mc.setBounce(0);
                this.claw2_mc.setCollideWorldBounds(false);
                this.claw2_mc.setImmovable(true);
                this.claw2_mc.body["setAllowGravity"](false);
                this.claw2_mc.body.setSize(47, 30);
                this.claw2_mc.body.setOffset(37, 15);
                this.claw2_mc.scaleX = -1;
                this.colonel_mc = nscs.scene.MainScene.instance.physics.add.sprite(0, 0, 'boss-atlas', 'colonel_mc' + '0000');
                this.colonel_mc.setOrigin(56 / 109, 18 / 133);
                this.colonel_mc.setBounce(0);
                this.colonel_mc.setCollideWorldBounds(false);
                this.colonel_mc.setImmovable(true);
                this.colonel_mc.body["setAllowGravity"](false);
                this.colonel_mc.body.setSize(80, 50);
                this.colonel_mc.body.setOffset(14, 60);
                this.rotor1_mc = nscs.scene.MainScene.instance.physics.add.sprite(-62, 49, 'boss-atlas', 'rotor_mc' + '0000');
                this.rotor1_mc.setOrigin(16 / 32, 5 / 33);
                this.rotor1_mc.setBounce(0);
                this.rotor1_mc.setCollideWorldBounds(false);
                this.rotor1_mc.setImmovable(true);
                this.rotor1_mc.body["setAllowGravity"](false);
                this.rotor1_mc.body.setSize(25, 25);
                this.rotor1_mc.body.setOffset(5, 5);
                this.rotor2_mc = nscs.scene.MainScene.instance.physics.add.sprite(58, 49, 'boss-atlas', 'rotor_mc' + '0000');
                this.rotor2_mc.setOrigin(16 / 32, 5 / 33);
                this.rotor2_mc.setBounce(0);
                this.rotor2_mc.setCollideWorldBounds(false);
                this.rotor2_mc.setImmovable(true);
                this.rotor2_mc.body["setAllowGravity"](false);
                this.rotor2_mc.body.setSize(25, 25);
                this.rotor2_mc.body.setOffset(5, 5);
                this.rotor2_mc.setFlipX(true);
                this.bowsermask_mc = nscs.scene.MainScene.instance.physics.add.sprite(0, -7, 'boss-atlas', 'bowsermask_mc' + '0000');
                this.bowsermask_mc.setOrigin(31 / 100, 6 / 398);
                this.bowsermask_mc.setBounce(0);
                this.bowsermask_mc.setCollideWorldBounds(false);
                this.bowsermask_mc.setImmovable(true);
                this.bowsermask_mc.body["setAllowGravity"](false);
                this.bowsermask_mc.body.setSize(54, 30);
                this.bowsermask_mc.body.setOffset(0, 15);
                this.add(this.chainsMak);
                this.add(this.chains);
                this.add(this.claw1_mc);
                this.add(this.claw2_mc);
                this.add(this.colonel_mc);
                this.add(this.rotor1_mc);
                this.add(this.rotor2_mc);
                this.add(this.bowsermask_mc);
                this.claw1_mc.body.checkCollision.left = this.claw1_mc.body.checkCollision.right = this.claw1_mc.body.checkCollision.up = false;
                this.claw2_mc.body.checkCollision.left = this.claw2_mc.body.checkCollision.right = this.claw2_mc.body.checkCollision.up = false;
                this.colonel_mc.body.checkCollision.down = this.colonel_mc.body.checkCollision.left = this.colonel_mc.body.checkCollision.right = false;
                this.createAnimations();
                this.reset();
            }
            playDefAnimations() {
                this.colonel_mc.play(nscs.gameplay.Factory.createAnimName('normal', 'colonel_mc'));
                this.rotor1_mc.play(nscs.gameplay.Factory.createAnimName('idle', 'rotor_mc'));
                this.rotor2_mc.play(nscs.gameplay.Factory.createAnimName('idle', 'rotor_mc'));
                this.claw1_mc.play(nscs.gameplay.Factory.createAnimName('idle', 'claw_mc'));
                this.claw2_mc.play(nscs.gameplay.Factory.createAnimName('idle', 'claw_mc'));
            }
            createAnimations() {
                let config = {
                    'bowsermask_mc': {
                        'idle': { 'start': 0, 'end': 39, repeat: -1, frameRate: 60 },
                        'fall': { 'start': 40, 'end': 101, repeat: 0, frameRate: 60 }
                    },
                    'colonel_mc': {
                        'normal': { 'start': 0, 'end': 39, repeat: -1, frameRate: 60 },
                        'angry': { 'start': 40, 'end': 64, repeat: -1, frameRate: 60 },
                    },
                    'rotor_mc': {
                        'idle': { 'start': 0, 'end': 4, repeat: -1, frameRate: 60 }
                    },
                    'claw_mc': {
                        'idle': { 'start': 0, 'end': 29, repeat: -1, frameRate: 60 },
                        'grab': { 'start': 30, 'end': 40, repeat: 0, frameRate: 60 },
                        'ungrab': { 'start': 41, 'end': 59, repeat: 0, frameRate: 60 }
                    }
                };
                for (let name in config) {
                    let animations = config[name];
                    for (let k in animations) {
                        let anim = nscs.gameplay.Factory.createAnimName(k, name);
                        if (!this.scene.anims.exists(anim)) {
                            this.scene.anims.create({
                                key: anim,
                                frames: this.scene.anims.generateFrameNames('boss-atlas', {
                                    start: animations[k]['start'], end: animations[k]['end'], zeroPad: 4,
                                    prefix: name, suffix: ''
                                }),
                                repeat: animations[k]['repeat'],
                                frameRate: animations[k]['frameRate']
                            });
                        }
                    }
                }
            }
            setup(player, minX, maxX, topY, bottomY, dropX, topYCatching, onDieCallback, onAttackCallback) {
                this.player = player;
                this.minX = minX;
                this.maxX = maxX;
                this.topY = topY;
                this.bottomY = bottomY;
                this.dropX = dropX;
                this.topYCatching = topYCatching;
                this.onDieCallback = onDieCallback;
                this.onAttackCallback = onAttackCallback;
            }
            setAction(action) {
                this.currAction = action;
            }
            hit() {
                if (this.lives <= 0)
                    return;
                this.lives--;
                if (this.lives == 0) {
                    this.setAction('die');
                    this.onDieCallback();
                    nscs.sound.SoundManager.getInstance().playSound('coloneldieSND');
                }
                else {
                    this.setAction('hit');
                    nscs.sound.SoundManager.getInstance().playSound('colonelhitSND');
                }
            }
            updateAction() {
                let dx = this.x - this.player.sprite.x;
                if (Math.abs(dx) > this.activationTryCatchDist) {
                    this.setAction('follow-player');
                    this.colonel_mc.flipX = dx < 0;
                }
                else {
                    this.setAction('try-catch-player');
                }
            }
            followXStep() {
                let speedX = 0;
                if (this.x < this.player.sprite.x) {
                    speedX = this.followSpeedX;
                }
                else if (this.x > this.player.sprite.x) {
                    speedX = -this.followSpeedX;
                }
                this.x += speedX;
            }
            updateAnimation() {
                if (this.currAction == 'try-catch-player') {
                    this.bowsermask_mc.play(nscs.gameplay.Factory.createAnimName('idle', 'bowsermask_mc'));
                    let dy = Math.abs(this.y - this.player.sprite.y);
                    if (dy < 150) {
                        let grabAnim = nscs.gameplay.Factory.createAnimName('grab', 'claw_mc');
                        let ungrabAnim = nscs.gameplay.Factory.createAnimName('ungrab', 'claw_mc');
                        let fn = (claw_mc) => {
                            if (claw_mc.anims.currentAnim && claw_mc.anims.currentAnim.key != grabAnim && claw_mc.anims.currentAnim.key != ungrabAnim) {
                                claw_mc.play(grabAnim, true);
                                claw_mc.once('animationcomplete', () => {
                                    if (this.currAction != 'catch-player') {
                                        claw_mc.play(ungrabAnim);
                                        claw_mc.once('animationcomplete', () => {
                                            claw_mc.play(nscs.gameplay.Factory.createAnimName('idle', 'claw_mc'));
                                        });
                                    }
                                });
                                nscs.sound.SoundManager.getInstance().playSound('colonelpincerSND');
                            }
                        };
                        fn(this.claw1_mc);
                        fn(this.claw2_mc);
                    }
                }
                else if (this.currAction == 'catch-player') {
                    this.bowsermask_mc.play(nscs.gameplay.Factory.createAnimName('idle', 'bowsermask_mc'));
                    this.claw1_mc.play(nscs.gameplay.Factory.createAnimName('grab', 'claw_mc'));
                    this.claw2_mc.play(nscs.gameplay.Factory.createAnimName('grab', 'claw_mc'));
                }
                else if (this.currAction == 'drop-player') {
                    this.bowsermask_mc.play(nscs.gameplay.Factory.createAnimName('idle', 'bowsermask_mc'));
                    this.claw1_mc.play(nscs.gameplay.Factory.createAnimName('ungrab', 'claw_mc'));
                    this.claw2_mc.play(nscs.gameplay.Factory.createAnimName('ungrab', 'claw_mc'));
                }
                else if (this.currAction == 'follow-player') {
                    this.bowsermask_mc.play(nscs.gameplay.Factory.createAnimName('idle', 'bowsermask_mc'));
                }
                else if (this.currAction == 'hit') {
                    this.colonel_mc.play(nscs.gameplay.Factory.createAnimName('angry', 'colonel_mc'));
                    if (!this.bowsermask_mc["fallen"]) {
                        this.bowsermask_mc["fallen"] = true;
                        this.bowsermask_mc.play(nscs.gameplay.Factory.createAnimName('fall', 'bowsermask_mc'));
                        this.bowsermask_mc.once('animationcomplete', () => {
                            this.bowsermask_mc.visible = false;
                        });
                    }
                    else {
                    }
                    let d = 1500;
                    this.blinkRedTint(d, this.claw1_mc, this.claw2_mc, this.colonel_mc, this.rotor1_mc, this.rotor2_mc, this.bowsermask_mc);
                    nscs.util.Functions.delayedCall(d, () => {
                        this.setAction(null);
                        this.colonel_mc.play(nscs.gameplay.Factory.createAnimName('normal', 'colonel_mc'));
                    });
                }
                else if (this.currAction == 'die') {
                    this.colonel_mc.play(nscs.gameplay.Factory.createAnimName('normal', 'colonel_mc'));
                    this.playDieAnimation();
                }
            }
            blinkRedTint(duration, ...sprites) {
                let n = 10;
                let d = duration / n;
                for (let i = 0; i < n; i++) {
                    nscs.util.Functions.delayedCall(i * d, () => {
                        for (let s of sprites) {
                            s.setTint(i % 2 == 0 ? 0xFF0022 : 0xFFFFFF);
                        }
                    });
                }
            }
            playDieAnimation() {
                this.chains.visible = false;
                this.scene.tweens.add({
                    targets: this.claw1_mc,
                    x: this.claw1_mc.x - 300,
                    y: this.claw1_mc.y - 70,
                    angle: -195,
                    alpha: 0,
                    duration: 1000
                });
                this.scene.tweens.add({
                    targets: this.claw2_mc,
                    x: this.claw2_mc.x + 250,
                    y: this.claw2_mc.y + 85,
                    angle: 155,
                    alpha: 0,
                    duration: 1000
                });
                this.scene.tweens.add({
                    targets: this.rotor1_mc,
                    y: this.rotor1_mc.y + 500,
                    duration: 1500
                });
                this.scene.tweens.add({
                    targets: this.rotor2_mc,
                    y: this.rotor2_mc.y + 500,
                    duration: 1500
                });
                this.scene.tweens.add({
                    targets: this.colonel_mc,
                    y: this.colonel_mc.y + 500,
                    duration: 1000,
                    ease: Phaser.Math.Easing.Back.In
                });
            }
            applyAction() {
                if (this.currAction == 'try-catch-player') {
                    this.followXStep();
                    this.y += this.tryCatchSpeedY;
                    // if (this.y > this.player.sprite.y - this.playerBossDy) this.y = this.player.sprite.y - this.playerBossDy;
                    if (this.y > this.bottomY)
                        this.y = this.bottomY;
                }
                else if (this.currAction == 'catch-player') {
                    this.player.sprite.body["setAllowGravity"](false);
                    let _syncPos = () => {
                        this.player.sprite.x = this.x;
                        this.player.sprite.y = this.y + this.claw1_mc.y;
                        this.player.sprite.setVelocity(0, 0);
                    };
                    this.scene.tweens.add({
                        targets: this,
                        y: this.topYCatching,
                        delay: 350,
                        duration: Math.abs(this.y - this.topYCatching) / this.tryCatchSpeedY * 1000 / 60,
                        ease: Phaser.Math.Easing.Linear,
                        onUpdate: _syncPos,
                        onComplete: () => {
                            this.scene.tweens.add({
                                targets: this,
                                x: this.dropX,
                                duration: Math.abs(this.dropX - this.x) / this.followSpeedX * 1000 / 60,
                                ease: Phaser.Math.Easing.Linear,
                                onUpdate: _syncPos,
                                onComplete: () => {
                                    this.setAction('drop-player');
                                    this.updateAnimation();
                                }
                            });
                        }
                    });
                }
                else if (this.currAction == 'drop-player') {
                    this.player.onRespawn = this.reset;
                    this.player.sprite.x = this.x;
                    this.player.sprite.body["setAllowGravity"](true);
                    this.player.doJump(-0.4);
                }
                else if (this.currAction == 'follow-player') {
                    this.followXStep();
                    this.y -= this.tryCatchSpeedY;
                    if (this.y < this.topY)
                        this.y = this.topY;
                }
                else if (this.currAction == 'hit') {
                }
                else if (this.currAction == 'die') {
                }
            }
            checkCollisions() {
                let dy = this.player.sprite.y - this.y;
                let dx = Math.abs(this.player.sprite.x - this.x);
                if (this.currAction == 'try-catch-player' && dy < this.playerBossDy + 5 && dy > this.playerBossDy - 5 && dx < 5) {
                    this.setAction('catch-player');
                    return;
                }
                if (this.scene.physics.world.collide(this.player.sprite, this.rotor1_mc) || this.scene.physics.world.collide(this.player.sprite, this.rotor2_mc)) {
                    this.player.onRespawn = this.reset;
                    this.onAttackCallback();
                    return;
                }
                let overlaps = this.scene.physics.world.overlap(this.player.sprite, this.colonel_mc);
                if (overlaps) {
                    if (this.colonel_mc.body.touching.up) {
                        if (this.currAction != 'hit') {
                            this.hit();
                        }
                    }
                }
            }
            updateChains() {
                let offsetY = 65;
                this.chains.y = -(this.y - this.topY) - offsetY;
                this.chainsMak.clear();
                this.chainsMak.fillStyle(0, 0).fillRect(-this.chains.width / 2, 0, this.chains.width, this.y - this.topY + offsetY);
                if (this.parentContainer) {
                    let ind = this.parentContainer.getIndex(this);
                    this.parentContainer.addAt(this.chains, ind - 1);
                    this.parentContainer.addAt(this.chainsMak, ind - 1);
                }
                this.chains.setPosition(this.x, this.y - offsetY - (this.y - this.topY));
                this.chainsMak.setPosition(this.chains.x, this.chains.y);
            }
            updateBoss() {
                this.updateChains();
                if (this.currAction == 'catch-player') {
                    return;
                }
                if (this.currAction != 'drop-player' && this.currAction != 'hit' && this.currAction != 'die') {
                    this.updateAction();
                    this.checkCollisions();
                    this.updateAnimation();
                }
                this.applyAction();
                this.ticker++;
            }
            destroy(fromScene) {
                super.destroy(fromScene);
                if (this.chains.parentContainer)
                    this.chains.parentContainer.add(this.chains);
                if (this.chainsMak.parentContainer)
                    this.chainsMak.parentContainer.add(this.chainsMak);
            }
        }
        character.Boss = Boss;
    })(character = nscs.character || (nscs.character = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var character;
    (function (character) {
        class Player {
            constructor() {
                this.frameName = null;
                this.immortalBlinkingTicker = 0;
                this.pounceLanding = false;
                this.isFlagReached = false;
                this.offsetsData = {
                    "flipped": {
                        'chickette_small': { x: 16, y: 7 },
                        'chickette_big': { x: 14, y: 4 },
                        'nugget_small': { x: 18, y: 7 },
                        'nugget_big': { x: 16, y: 4 },
                        'pam_small': { x: 17, y: 7 },
                        'pam_big': { x: 17, y: 4 }
                    },
                    "normal": {
                        'chickette_small': { x: 16, y: 33 },
                        'chickette_big': { x: 14, y: 16 },
                        'nugget_small': { x: 18, y: 32 },
                        'nugget_big': { x: 16, y: 18 },
                        'pam_small': { x: 17, y: 36 },
                        'pam_big': { x: 17, y: 12 }
                    }
                };
                this.tempDead = false;
                this.onRespawn = null;
                this.topPriorityAnimations = ['grow', 'seaKittenise', 'pounceLand'];
                this.currAnimComplete = true;
                this.currAnim = null;
                this.sideJumpTicker = 0;
                this.notContactingDownTicker = 0;
                this.fallenBelowTheWorld = false;
                this.contactLeftWithStaticObject = false;
                this.contactRightWithStaticObject = false;
                this.contactDownWithStaticObject = false;
                this.pipeGoing = false;
                this.isPlayerLadding = false;
                this.fanUp = false;
                this.fanDown = false;
                this.fanLeft = false;
                this.fanRight = false;
                this.spaceDownTicker = 0;
                this.jumpForceTicker = 10;
                this.xVelocityOnJumpMoment = 0;
                this.isNotPlayerLaddingTicker = Number.MAX_VALUE;
                this.isOnMovingPlatform = false;
                this.sideJumpVelocity = 0;
                this.doingBounceJumpTicker = 0;
                this.gameplay = nscs.scene.MainScene.instance.gameplay;
                this.sprite = nscs.scene.MainScene.instance.physics.add.sprite(0, 0, 'objects-atlas');
                this.sprite.setOrigin(0.5, 0);
                this.sprite.setBounce(0);
                this.sprite.setCollideWorldBounds(true);
                this.sprite.on('animationcomplete', () => { this.currAnimComplete = true; });
                this.setup();
            }
            setup() {
                this.setCharSize(this.gameplay.charSize);
                this.setSeaKittenise(this.gameplay.seaKitten);
            }
            remakeFrameName() {
                this.frameName = this.gameplay.character + "_" + this.gameplay.charSize;
            }
            updateBodySize() {
                let bodySizes = {
                    'chickette_small': { w: 17, h: 30 },
                    'chickette_big': { w: 21, h: 56 },
                    'nugget_small': { w: 17, h: 30 },
                    'nugget_big': { w: 20, h: 52 },
                    'pam_small': { w: 16, h: 30 },
                    'pam_big': { w: 16, h: 60 }
                };
                this.sprite.body.setSize(bodySizes[this.frameName].w, bodySizes[this.frameName].h);
            }
            updateBodyFlipY() {
                this.sprite.flipY = this.gameplay.isGravityFlipped();
                this.sprite.y += (this.offsetsData["flipped"][this.frameName].y - this.offsetsData["normal"][this.frameName].y) * this.gameplay.gravityDir;
            }
            updateBodyOffset() {
                let offsets = this.offsetsData[this.gameplay.isGravityFlipped() ? "flipped" : "normal"];
                this.sprite.body.setOffset(offsets[this.frameName].x, offsets[this.frameName].y);
            }
            setCharSize(charSize, playAnimation = true) {
                let prevCharSize = this.gameplay.charSize;
                this.gameplay.charSize = charSize;
                this.remakeFrameName();
                if (this.gameplay.charSize == "small") {
                    this.setSeaKittenise(false);
                }
                this.updateBodyFlipY();
                this.updateBodySize();
                this.updateBodyOffset();
                if (playAnimation) {
                    if (prevCharSize != this.gameplay.charSize) {
                        this.playGrowAnimation();
                    }
                    else {
                        this.playIdleAnimation();
                    }
                }
            }
            fullyActive() {
                return this.immortalBlinkingTicker == 0 && !this.tempDead && !this.isFlagReached;
            }
            playPounceAnimation() {
                this.playAnimation('pounce');
                nscs.sound.SoundManager.getInstance().playSound('whiskSND');
            }
            playPounceLandAnimation() {
                if (this.fallenBelowTheWorld)
                    return;
                this.playAnimation('pounceLand');
                nscs.scene.MainScene.instance.gameplay.gameScreen.showDustMC(this.sprite.x, this.getFootsWorldY(), this.gameplay.charSize == "big" ? 0.7 : 0.4, this.gameplay.isGravityFlipped() ? 180 : 0);
                nscs.sound.SoundManager.getInstance().playSound('stompThudSND');
            }
            playWalkAnimation() {
                this.playAnimation('walk');
            }
            playIdleAnimation() {
                this.playAnimation('idle');
            }
            playFlyAnimation() {
                this.playAnimation('fly');
            }
            playForcedFlyAnimation() {
                this.playAnimation('fly', true);
            }
            playClimbingAnimation() {
                this.playAnimation('climbing');
            }
            playDeathAnimation(sizeWhenOnDeath) {
                if (sizeWhenOnDeath == 'small') {
                    this.playForcedFlyAnimation();
                }
                else {
                    this.playGrowAnimation();
                }
            }
            playGrowAnimation() {
                this.playAnimation('grow');
            }
            setSeaKittenise(active) {
                this.gameplay.setSeaKitten(active);
                if (this.gameplay.seaKitten) {
                    this.playAnimation('seaKittenise');
                }
            }
            setTempDead(tempDead) {
                this.tempDead = tempDead;
                this.sprite.body.enable = !tempDead;
                this.sprite.setVelocity(0, 0);
            }
            resetVariables() {
                this.sideJumpTicker = 0;
                this.pounceLanding = false;
                this.notContactingDownTicker = 0;
                this.fallenBelowTheWorld = false;
                this.contactLeftWithStaticObject = false;
                this.contactRightWithStaticObject = false;
                this.contactDownWithStaticObject = false;
                this.isPlayerLadding = false;
                this.isNotPlayerLaddingTicker = Number.MAX_VALUE;
                this.onRespawn = null;
                this.resetFans();
            }
            minusOneLife() {
                let prevCharSize = this.gameplay.charSize;
                this.setCharSize("small", false);
                this.playDeathAnimation(prevCharSize);
                this.setTempDead(true);
                this.resetVariables();
            }
            getFootsWorldY() {
                return this.gameplay.isGravityFlipped() ? this.sprite.y : this.sprite.y + this.sprite.height;
            }
            setWorldPosition(worldX, worldY) {
                this.sprite.setPosition(worldX, worldY - this.sprite.height);
            }
            respawn(atX, atY) {
                this.setWorldPosition(atX, atY);
                this.setTempDead(false);
                this.setImmortalBlinking();
                if (this.onRespawn) {
                    this.onRespawn();
                    this.onRespawn = null;
                }
            }
            playAnimation(anim, forced = false) {
                if (!forced) {
                    if (!this.currAnimComplete) {
                        if (this.topPriorityAnimations.indexOf(this.currAnim) >= 0 || this.topPriorityAnimations.indexOf(anim) >= 0)
                            return;
                    }
                }
                if (anim != this.currAnim) {
                    this.sprite.anims.stop();
                }
                this.currAnim = anim;
                this.currAnimComplete = false;
                this.sprite.anims.play(nscs.gameplay.Factory.createAnimName(anim, this.frameName), true);
            }
            setImmortalBlinking() {
                this.immortalBlinkingTicker = 125;
            }
            goInOutPipe(direction, dSize, onComplete) {
                let dx = 0;
                let dy = 0;
                if (direction == "left")
                    dx = -dSize;
                else if (direction == "right")
                    dx = dSize;
                else if (direction == "down")
                    dy = dSize;
                else if (direction == "up")
                    dy = -dSize;
                this.pipeGoing = true;
                this.sprite.body.enable = false;
                this.sprite.setVelocity(0, 0);
                this.sprite.flipX = direction == "left";
                nscs.scene.MainScene.instance.tweens.add({
                    targets: this.sprite,
                    x: this.sprite.x + dx,
                    y: this.sprite.y + dy,
                    duration: 500,
                    onComplete: () => {
                        if (onComplete)
                            onComplete();
                    }
                });
                if (direction == "left" || direction == "right")
                    this.playWalkAnimation();
                else if (direction == "down" || direction == "up")
                    this.playIdleAnimation();
            }
            resetPipeGoing() {
                this.pipeGoing = false;
                this.sprite.body.enable = true;
            }
            resetFans() {
                this.fanUp = this.fanDown = this.fanRight = this.fanLeft = false;
            }
            update() {
                if (this.pipeGoing) {
                    return;
                }
                this.fallenBelowTheWorld = this.sprite.y + this.sprite.height >= nscs.scene.MainScene.instance.gameplay.worldHeight;
                if (this.immortalBlinkingTicker > 0) {
                    this.immortalBlinkingTicker--;
                    this.sprite.alpha = 1 - (this.immortalBlinkingTicker % 25) / 25;
                }
                let inputController = nscs.scene.MainScene.instance.inputController;
                let contactDownAnything = this.gameplay.isGravityFlipped() ?
                    this.sprite.body.blocked.up || this.sprite.body.touching.up :
                    this.sprite.body.blocked.down || this.sprite.body.touching.down;
                let contactDown = contactDownAnything && this.contactDownWithStaticObject;
                let contactLeft = (this.sprite.body.blocked.left || this.sprite.body.touching.left) && this.contactLeftWithStaticObject;
                let contactRight = (this.sprite.body.blocked.right || this.sprite.body.touching.right) && this.contactRightWithStaticObject;
                if (contactDown) {
                    this.notContactingDownTicker = 0;
                }
                else {
                    this.notContactingDownTicker++;
                }
                let antiGravitySpeedY = -18 * this.gameplay.gravityDir;
                if (this.doingBounceJumpTicker > 0) {
                    if (this.doingBounceJumpTicker > 1 && contactDownAnything) {
                        this.doingBounceJumpTicker = 0;
                    }
                    else {
                        this.doingBounceJumpTicker++;
                    }
                }
                if (this.sideJumpTicker == 0) {
                    let speedX = 0;
                    if (contactDown) {
                        let c = 8;
                        if ((inputController.cursorKeys.left.isDown || nscs.input.InputManager.instance.isDown('LEFT'))
                            || (inputController.cursorKeys.right.isDown || nscs.input.InputManager.instance.isDown('RIGHT'))) {
                            let targetSpeedX = 0;
                            if (this.isOnMovingPlatform) {
                                this.isOnMovingPlatform = false;
                                targetSpeedX += this.gameplay.movingPlatformSpeed;
                            }
                            if (inputController.cursorKeys.left.isDown || nscs.input.InputManager.instance.isDown('LEFT')) {
                                targetSpeedX += -this.gameplay.xSpeed;
                                this.sprite.flipX = true; // flip the sprite to the left
                            }
                            else if (inputController.cursorKeys.right.isDown || nscs.input.InputManager.instance.isDown('RIGHT')) {
                                targetSpeedX += this.gameplay.xSpeed;
                                this.sprite.flipX = false; // use the original sprite looking to the right
                            }
                            speedX = this.sprite.body.velocity.x + (targetSpeedX - this.sprite.body.velocity.x) / c;
                        }
                        else {
                            if (this.isOnMovingPlatform) {
                                this.isOnMovingPlatform = false;
                                speedX = this.gameplay.movingPlatformSpeed;
                            }
                            else {
                                speedX = this.sprite.body.velocity.x * 0.9;
                                if (speedX < 1 && speedX > -1)
                                    speedX = 0;
                            }
                        }
                    }
                    else {
                        let newSpd = 0;
                        if (!this.pounceLanding) {
                            newSpd = this.sprite.body.velocity.x;
                            let vx = this.sprite.body.velocity.x;
                            let targetVxModule = Math.abs(this.xVelocityOnJumpMoment) < this.gameplay.xSpeed * 0.75 ? this.gameplay.xSpeed * 0.75 : Math.abs(this.xVelocityOnJumpMoment);
                            if (this.doingBounceJumpTicker > 1) {
                                targetVxModule = this.gameplay.xSpeed * 1.37;
                            }
                            let div = 20;
                            if (inputController.cursorKeys.left.isDown || nscs.input.InputManager.instance.isDown('LEFT')) {
                                speedX = vx + (-targetVxModule - vx) / div;
                                this.sprite.flipX = true; // flip the sprite to the left
                            }
                            else if (inputController.cursorKeys.right.isDown || nscs.input.InputManager.instance.isDown('RIGHT')) {
                                speedX = vx + (targetVxModule - vx) / div;
                                this.sprite.flipX = false; // use the original sprite looking to the right
                            }
                            else {
                                speedX = newSpd * 0.95;
                            }
                        }
                    }
                    this.sprite.setVelocityX(speedX);
                }
                else {
                    this.sideJumpTicker--;
                    this.sprite.setVelocityX(this.sprite.body.velocity.x * 0.99);
                }
                if (this.isPlayerLadding) {
                    if (inputController.cursorKeys.up.isDown || nscs.input.InputManager.instance.isDown('UP')) {
                        this.sprite.setVelocityY(-this.gameplay.ladderSpeed);
                        this.playClimbingAnimation();
                        this.sprite.setVelocityX(this.sprite.body.velocity.x * 0.5);
                    }
                    else if (inputController.cursorKeys.down.isDown || nscs.input.InputManager.instance.isDown('DOWN')) {
                        this.sprite.setVelocityY(this.gameplay.ladderSpeed);
                        this.playClimbingAnimation();
                        this.sprite.setVelocityX(this.sprite.body.velocity.x * 0.5);
                    }
                    else {
                        this.sprite.setVelocityY(antiGravitySpeedY);
                        this.sprite.setVelocityX(this.sprite.body.velocity.x * 1.1);
                    }
                    // return;
                }
                if (!this.isPlayerLadding) {
                    if (this.isNotPlayerLaddingTicker == Number.MAX_VALUE) {
                        this.isNotPlayerLaddingTicker = 0;
                    }
                    else {
                        this.isNotPlayerLaddingTicker++;
                    }
                }
                else {
                    this.isNotPlayerLaddingTicker = Number.MAX_VALUE;
                }
                if (inputController.cursorKeys.up.isDown || nscs.input.InputManager.instance.isDown('UP')) {
                    if (this.spaceDownTicker != 0 && this.spaceDownTicker < this.jumpForceTicker * 0.5) {
                        this.doJump(Math.min((this.spaceDownTicker + this.jumpForceTicker * 0.5) / this.jumpForceTicker, 1));
                        this.spaceDownTicker++;
                    }
                    else {
                        this.spaceDownTicker = 0;
                    }
                    if (!this.isPlayerLadding && this.isNotPlayerLaddingTicker > 5 && this.isNotPlayerLaddingTicker < 10) {
                        this.isNotPlayerLaddingTicker = 10;
                        nscs.sound.SoundManager.getInstance().playSound(this.gameplay.inWater ? 'waterjumpSND' : 'jumpSND');
                        this.xVelocityOnJumpMoment = this.sprite.body.velocity.x;
                        this.doJump(1);
                    }
                    if ((inputController.upPressedDownAndReleased() || nscs.input.InputManager.instance.upPressedDownAndReleased()) && contactDown) {
                        inputController.upPressUsed();
                        nscs.input.InputManager.instance.upPressUsed();
                        this.spaceDownTicker = 1;
                        nscs.sound.SoundManager.getInstance().playSound(this.gameplay.inWater ? 'waterjumpSND' : 'jumpSND');
                        this.xVelocityOnJumpMoment = this.sprite.body.velocity.x;
                    }
                }
                else {
                    this.spaceDownTicker = 0;
                }
                if (this.isPlayerLadding)
                    return;
                // jump
                if (inputController.upPressedDownAndReleased() || nscs.input.InputManager.instance.upPressedDownAndReleased()) {
                    if (this.gameplay.seaKitten && this.gameplay.inWater && (this.gameplay.isGravityFlipped() ? this.sprite.body.velocity.y < 0 : this.sprite.body.velocity.y > 0)) {
                        this.doJump(0.5);
                        inputController.upPressUsed();
                        nscs.input.InputManager.instance.upPressUsed();
                        nscs.sound.SoundManager.getInstance().playSound('waterjumpSND');
                    }
                }
                if (contactDown) {
                    if (this.pounceLanding || this.currAnim == 'pounce') {
                        this.playPounceLandAnimation();
                        this.pounceLanding = false;
                    }
                    if (Math.abs(this.sprite.body.velocity.x) < this.gameplay.xSpeed0 * 0.1) {
                        this.playIdleAnimation();
                    }
                    else {
                        if ((inputController.cursorKeys.left.isDown || nscs.input.InputManager.instance.isDown('LEFT'))
                            || (inputController.cursorKeys.right.isDown || nscs.input.InputManager.instance.isDown('RIGHT'))) {
                            this.playWalkAnimation();
                        }
                    }
                }
                else {
                    if (!contactDownAnything) {
                        if (!this.pounceLanding) {
                            if (!this.gameplay.isGravityFlipped() && this.sprite.body.velocity.y > 0 ||
                                this.gameplay.isGravityFlipped() && this.sprite.body.velocity.y < 0) {
                                if (Math.abs(this.sprite.body.velocity.x) < this.gameplay.xSpeed0 * 0.1) {
                                    this.playAnimation('idle', true);
                                }
                                else {
                                    this.playAnimation('walk', true);
                                }
                            }
                            else {
                                this.playFlyAnimation();
                            }
                        }
                    }
                }
                if (this.currAnim == 'pounceLand' || this.currAnim == 'pounce') {
                    this.sprite.setVelocityX(0);
                }
                if (Math.abs(this.sideJumpVelocity) > 1) {
                    this.sprite.setVelocityX(this.sideJumpVelocity);
                    this.sideJumpVelocity += (0 - this.sideJumpVelocity) / 10;
                }
                else {
                    this.sideJumpVelocity = 0;
                }
                if (this.fanUp) {
                    if (this.pounceLanding) {
                        this.sprite.setVelocityY(this.sprite.body.velocity.y);
                    }
                    else {
                        let spdY = (-200 * this.gameplay.gravityDir) * this.gameplay.getFanWaterCoefficient();
                        if (this.gameplay.isGravityFlipped() ?
                            this.sprite.body.velocity.y < antiGravitySpeedY && this.sprite.body.velocity.y < spdY :
                            this.sprite.body.velocity.y > antiGravitySpeedY && this.sprite.body.velocity.y > spdY) {
                            this.sprite.setVelocityY(this.sprite.body.velocity.y + (spdY - this.sprite.body.velocity.y) * 0.1);
                        }
                    }
                }
                if (this.fanLeft || this.fanRight) {
                    let fanCoef = this.contactDownWithStaticObject ? 0.1 : 2;
                    if ((inputController.cursorKeys.left.isDown || nscs.input.InputManager.instance.isDown('LEFT'))
                        || inputController.cursorKeys.right.isDown || nscs.input.InputManager.instance.isDown('RIGHT'))
                        fanCoef = 0.01;
                    if (this.fanLeft) {
                        if (!this.pounceLanding) {
                            let spdX = -this.gameplay.xSpeed * fanCoef * this.gameplay.getFanWaterCoefficient();
                            if (this.sprite.body.velocity.x > spdX) {
                                this.sprite.setVelocityX(this.sprite.body.velocity.x + (spdX - this.sprite.body.velocity.x) * 0.65);
                            }
                        }
                    }
                    if (this.fanRight) {
                        if (!this.pounceLanding) {
                            let spdX = this.gameplay.xSpeed * fanCoef * this.gameplay.getFanWaterCoefficient();
                            if (this.sprite.body.velocity.x < spdX) {
                                this.sprite.setVelocityX(this.sprite.body.velocity.x + (spdX - this.sprite.body.velocity.x) * 0.65);
                            }
                        }
                    }
                    if (!this.contactDownWithStaticObject && this.sprite.body.velocity.y > 0)
                        this.sprite.body.velocity.y *= 0.9;
                }
                this.resetFans();
                this.contactLeftWithStaticObject = this.contactRightWithStaticObject = this.contactDownWithStaticObject = false;
            }
            setMovingPlatformForThisUpdate() {
                this.isOnMovingPlatform = true;
            }
            doJump(powerCoef = 1) {
                this.sprite.setVelocityY(-this.gameplay.jumpHeight * powerCoef * this.gameplay.gravityDir);
            }
            doSideJump(powerCoef = 1) {
                this.sideJumpVelocity = this.gameplay.xSpeed * powerCoef;
            }
            doAfterJumpOverEnemy() {
                this.pounceLanding = false;
                this.doJump(1);
            }
            doBounceJump() {
                this.doingBounceJumpTicker = 1;
                this.pounceLanding = false;
                this.doJump(1.55);
            }
        }
        character.Player = Player;
    })(character = nscs.character || (nscs.character = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var gameplay;
    (function (gameplay) {
        class Factory {
            constructor(scene) {
                this.scene = scene;
                this.createAnimations();
            }
            createAnimations() {
                for (let k in Factory.ANIM) {
                    let textureAtlas = 'objects-atlas';
                    let data = Factory.ANIM[k];
                    for (let animKey in data) {
                        let anim = Factory.createAnimName(animKey, k);
                        if (!this.scene.anims.exists(anim)) {
                            let animData = data[animKey];
                            let frames;
                            let genFrm = (_data) => {
                                return this.scene.anims.generateFrameNames(textureAtlas, {
                                    start: _data['start'], end: _data['end'], zeroPad: 4,
                                    prefix: k, suffix: ''
                                });
                            };
                            if (animData.hasOwnProperty("length")) {
                                frames = [];
                                for (let ad of animData) {
                                    let _frames = genFrm(ad);
                                    frames = frames.concat(_frames);
                                }
                            }
                            else {
                                frames = genFrm(animData);
                            }
                            this.scene.anims.create({
                                key: anim,
                                frames: frames,
                                frameRate: 60
                            });
                        }
                    }
                }
            }
            static createAnimName(animKey, frameName) {
                return animKey + "_" + frameName;
            }
            createDecorSprite(libId) {
                let mapOrigins = {
                    'decor2MC': { 'x': 53 / 83, 'y': 85 / 85 },
                    'decor3MC': { 'x': 112 / 224, 'y': 174 / 176 },
                    'decor24MC': { 'x': 39.5 / 81, 'y': 83 / 83 },
                    'decor1MC': { 'x': 68 / 93, 'y': 72 / 72 },
                    'decor12MC': { 'x': 56 / 79, 'y': 69 / 63 },
                    'decor18MC': { 'x': 8 / 58, 'y': 7 / 79 },
                    'decor16MC': { 'x': 56 / 79, 'y': 69 / 63 },
                    'decor19MC': { 'x': 49 / 58, 'y': 7 / 79 },
                    'decor17MC': { 'x': 56 / 79, 'y': 10 / 58 },
                    'decor14MC': { 'x': 8 / 58, 'y': 7 / 79 },
                    'decor15MC': { 'x': 56 / 79, 'y': 10 / 58 },
                    'decor44MC': { 'x': 49 / 98, 'y': 0.87 },
                    'decor11MC': { 'x': 16 / 32, 'y': 32 / 32 },
                    'decor27MC': { 'x': 16 / 32, 'y': 32 / 32 },
                    'decor6MC': { 'x': 56 / 112, 'y': 72 / 74 },
                    'decor10MC': { 'x': 48 / 96, 'y': 54 / 54 },
                    'decor26MC': { 'x': 48 / 96, 'y': 54 / 54 },
                    'decor60MC': { 'x': 16 / 96, 'y': 32 / 64 },
                    'decor61MC': { 'x': 16 / 96, 'y': 32 / 64 },
                    'decor13MC': { 'x': 50 / 58, 'y': 7 / 79 },
                    'decor47MC': { 'x': 1, 'y': 1 },
                    'decor4MC': { 'x': 70 / 115, 'y': 240 / 241 },
                    'decor21MC': { 'x': 56 / 113, 'y': 164 / 164 },
                    'decor23MC': { 'x': 56 / 113, 'y': 164 / 164 },
                    'decor46MC': { 'x': 0 / 37, 'y': 60 / 89 },
                    'decor22MC': { 'x': 40 / 81, 'y': 40 / 40 },
                    'decor31MC': { 'x': 23 / 46, 'y': 21 / 25 },
                    'decor32MC': { 'x': 23 / 46, 'y': 21 / 25 },
                    'decor45MC': { 'x': 23 / 46, 'y': 21 / 25 },
                    'decor9MC': { 'x': 33 / 34, 'y': 47 / 47 },
                    'decor8MC': { 'x': 33 / 34, 'y': 47 / 47 },
                    'decor25MC': { 'x': 42 / 88, 'y': 42 / 42 },
                    'decor58MC': { 'x': 53 / 83, 'y': 85 / 86 },
                    'decor7MC': { 'x': 96 / 186, 'y': 70 / 72 },
                    'decor5MC': { 'x': 174 / 348, 'y': 315 / 315 },
                    'decor20MC': { 'x': 54 / 76, 'y': 38 / 76 },
                    'decor38MC': { 'x': 10 / 53, 'y': 40 / 53 },
                    'decor41MC': { 'x': 10 / 53, 'y': 53 / 53 },
                    'decor57MC': { 'x': 47 / 95, 'y': 48 / 49 },
                    'decor53MC': { 'x': 40 / 81, 'y': 35 / 35 },
                    'decor50MC': { 'x': 37 / 81, 'y': 31 / 33 },
                    'decor52MC': { 'x': 40 / 81, 'y': 35 / 36 },
                    'decor51MC': { 'x': 40 / 81, 'y': 35 / 37 },
                    'decor48MC': { 'x': 37 / 81, 'y': 31 / 33 },
                    'decor49MC': { 'x': 37 / 84, 'y': 31 / 33 },
                    'decor36MC': { 'x': 33 / 66, 'y': 46 / 46 },
                    'decor37MC': { 'x': 18 / 36, 'y': 36 / 36 },
                    'decor56MC': { 'x': 40 / 81, 'y': 32 / 33 },
                    'decor54MC': { 'x': 40 / 81, 'y': 32 / 33 },
                    'decor55MC': { 'x': 40 / 81, 'y': 32 / 33 },
                    'decor33MC': { 'x': 16 / 32, 'y': 32 / 36 },
                    'decor28MC': { 'x': 16 / 32, 'y': 32 / 36 },
                    'decor35MC': { 'x': 16 / 32, 'y': 32 / 36 },
                    'decor30MC': { 'x': 16 / 32, 'y': 32 / 36 },
                    'decor29MC': { 'x': 16 / 32, 'y': 32 / 36 },
                    'decor34MC': { 'x': 16 / 32, 'y': 32 / 36 },
                    'decor43MC': { 'x': -5.5, 'y': 48 / 96 },
                    'decor42MC': { 'x': -4.5, 'y': 48 / 96 },
                    'decor40MC': { 'x': 48 / 96, 'y': 1 / 10 },
                    'decor39MC': { 'x': 48 / 96, 'y': 1 / 10 },
                    'decor59MC': { 'x': 0, 'y': 0 },
                };
                let animations = {
                    'decor95MC': { 'start': 0, 'end': 93, 'autoplay': true },
                    'decor94MC': { 'start': 0, 'end': 93, 'autoplay': true },
                    'decor93MC': { 'start': 0, 'end': 93, 'autoplay': true },
                    'decor37MC': { 'start': 0, 'end': 82, 'autoplay': true },
                    'decor36MC': { 'start': 0, 'end': 82, 'autoplay': true },
                    'decor71MC': { 'start': 0, 'end': 29, 'autoplay': true },
                    'decor70MC': { 'start': 0, 'end': 29, 'autoplay': true },
                    'decor110MC': { 'start': 0, 'end': 21, 'autoplay': false },
                    'decor31MC': { 'start': 0, 'end': 21, 'autoplay': false },
                    'decor32MC': { 'start': 0, 'end': 21, 'autoplay': false },
                    'decor45MC': { 'start': 0, 'end': 21, 'autoplay': false },
                    'decor99MC': { 'start': 0, 'end': 73, 'autoplay': true },
                    'decor98MC': { 'start': 0, 'end': 53, 'autoplay': true },
                    'decor96MC': { 'start': 0, 'end': 59, 'autoplay': true },
                    'decor97MC': { 'start': 0, 'end': 73, 'autoplay': true },
                    'decor26MC': { 'start': 0, 'end': 89, 'autoplay': true },
                    'decor10MC': { 'start': 0, 'end': 89, 'autoplay': true },
                    'decor49MC': { 'start': 0, 'end': 88, 'autoplay': true },
                    'decor48MC': { 'start': 0, 'end': 88, 'autoplay': true },
                    'decor54MC': { 'start': 0, 'end': 88, 'autoplay': true },
                    'decor56MC': { 'start': 0, 'end': 88, 'autoplay': true },
                    'decor55MC': { 'start': 0, 'end': 88, 'autoplay': true },
                    'decor51MC': { 'start': 0, 'end': 88, 'autoplay': true },
                    'decor52MC': { 'start': 0, 'end': 88, 'autoplay': true },
                    'decor50MC': { 'start': 0, 'end': 88, 'autoplay': true },
                    'decor53MC': { 'start': 0, 'end': 88, 'autoplay': true },
                    'decor57MC': { 'start': 0, 'end': 88, 'autoplay': true },
                    'decor41MC': { 'start': 0, 'end': 12, 'autoplay': true },
                    'decor38MC': { 'start': 0, 'end': 12, 'autoplay': true },
                    'decor1MC': { 'start': 0, 'end': 12, 'autoplay': true },
                    'decor6MC': { 'start': 0, 'end': 12, 'autoplay': true },
                    'decor7MC': { 'start': 0, 'end': 12, 'autoplay': true },
                    'decor46MC': { 'start': 0, 'end': 11, 'autoplay': true },
                    'decor47MC': { 'start': 0, 'end': 11, 'autoplay': true },
                    'decor43MC': { 'start': 0, 'end': 25, 'autoplay': true },
                    'decor42MC': { 'start': 0, 'end': 25, 'autoplay': true },
                    'decor40MC': { 'start': 0, 'end': 25, 'autoplay': true },
                    'decor39MC': { 'start': 0, 'end': 25, 'autoplay': true },
                };
                let bodySize = {
                    'decor95MC': { x: 0, y: 55, yFlipped: 6, w: 110, h: 46 },
                    'decor94MC': { x: 0, y: 55, yFlipped: 6, w: 110, h: 46 },
                    'decor93MC': { x: 0, y: 55, yFlipped: 6, w: 110, h: 46 },
                    'decor71MC': { x: 12, y: -17, w: 59, h: 56 },
                    'decor70MC': { x: 12, y: 41, w: 59, h: 56 },
                    'decor110MC': { x: 0, y: 0, w: 44, h: 10 },
                    'decor31MC': { x: 0, y: 11, w: 44, h: 12 },
                    'decor32MC': { x: 0, y: 11, w: 44, h: 12 },
                    'decor45MC': { x: 0, y: 11, w: 44, h: 12 },
                    'decor107MC': { x: 0, y: 31, w: 154, h: 78 },
                    'decor109MC': { x: 0, y: 31, w: 154, h: 78 },
                    'decor104MC': { x: 0, y: 31, w: 142, h: 78 },
                    'decor105MC': { x: 0, y: 31, w: 148, h: 78 },
                    'decor106MC': { x: 0, y: 31, w: 160, h: 78 },
                    'decor103MC': { x: 0, y: 31, w: 150, h: 78 },
                    'decor102MC': { x: 0, y: 31, w: 150, h: 78 },
                    'decor108MC': { x: 0, y: 31, w: 150, h: 78 },
                    'decor99MC': { x: 30, y: 10, w: 57, h: 37 },
                    'decor97MC': { x: 35, y: 20, w: 57, h: 37 },
                    'decor98MC': { x: 20, y: 10, w: 57, h: 37 },
                    'decor12MC': { x: 23, y: 0, w: 36, h: 64 },
                    'decor15MC': { x: 23, y: 0, w: 36, h: 64 },
                    'decor16MC': { x: 45, y: 246, w: 38, h: 62 },
                    'decor17MC': { x: 28, y: 6, w: 38, h: 64 },
                    'decor18MC': { x: -10, y: 22, w: 73, h: 38 },
                    'decor14MC': { x: -9, y: 22, w: 73, h: 38 },
                    'decor13MC': { x: -4, y: 22, w: 50, h: 38 },
                    'decor19MC': { x: -4, y: 45, w: 58, h: 38 },
                    'decor100MC': { x: 0, y: 50, w: 135, h: 329 },
                    'decor47MC': { x: -234, y: -5, w: 245, h: 95 },
                    'decor46MC': { x: 25, y: -5, w: 245, h: 95 },
                    'decor101MC': { x: 1, y: 10, w: 178, h: 78 },
                    'decor59MC': { x: 0, y: 0, w: 23, h: 63 },
                    'decor44MC': { x: 0, y: 0, w: 98, h: 97 },
                    'decor40MC': { x: 0, y: 0, w: 32, h: 5 },
                    'decor57MC': { x: 0, y: 0, w: 95, h: 49 },
                    'decor49MC': { x: 0, y: 0, w: 84, h: 33 },
                    'decor7MC': { x: 0, y: 0, w: 186, h: 72 },
                    'decor53MC': { x: 0, y: 0, w: 81, h: 35 },
                    'decor50MC': { x: 0, y: 0, w: 81, h: 33 },
                    'decor52MC': { x: 0, y: 0, w: 81, h: 36 },
                    'decor48MC': { x: 0, y: 0, w: 81, h: 33 },
                    'decor6MC': { x: 0, y: 0, w: 112, h: 74 },
                    'decor1MC': { x: 0, y: 0, w: 93, h: 72 },
                    'decor51MC': { x: 0, y: 0, w: 81, h: 37 },
                    'decor56MC': { x: 0, y: 0, w: 81, h: 33 },
                    'decor55MC': { x: 0, y: 0, w: 81, h: 35 },
                    'decor54MC': { x: 0, y: 0, w: 81, h: 33 },
                };
                let mapLookingLeft = {
                    'decor99MC': false,
                    'decor98MC': false,
                    'decor96MC': false,
                    'decor97MC': false,
                    'decor108MC': true,
                    'decor105MC': true,
                    'decor106MC': true,
                    'decor102MC': true,
                    'decor103MC': true
                };
                let decor;
                if (bodySize.hasOwnProperty(libId)) {
                    decor = this.scene.physics.add.sprite(0, 0, 'decor-atlas', libId + '0000');
                    decor.setCollideWorldBounds(false);
                    decor.body.setSize(bodySize[libId]['w'], bodySize[libId]['h']);
                    decor.body.setOffset(bodySize[libId]['x'], bodySize[libId]['y']);
                    if (bodySize[libId].hasOwnProperty('yFlipped')) {
                        decor.body.offset['-y-'] = bodySize[libId]['y'];
                        decor.body.offset['-yFlipped-'] = bodySize[libId]['yFlipped'];
                    }
                    else {
                        decor.setImmovable(true);
                    }
                    decor.body["setAllowGravity"](false);
                }
                else {
                    let frame = libId + '0000';
                    decor = this.scene.add.sprite(0, 0, 'decor-atlas', frame);
                    if (!decor.texture.frames.hasOwnProperty(frame)) {
                        decor.visible = false;
                    }
                }
                if (mapLookingLeft.hasOwnProperty(libId)) {
                    decor['lookingLeft'] = mapLookingLeft[libId];
                }
                if (mapOrigins[libId]) {
                    decor.setOrigin(mapOrigins[libId]['x'], mapOrigins[libId]['y']);
                }
                else {
                    decor.setOrigin(0.5, 0.5);
                }
                if (animations[libId]) {
                    let anim = libId + "_" + "playingAnimName";
                    decor["playingAnimName"] = anim;
                    if (!this.scene.anims.exists(anim)) {
                        this.scene.anims.create({
                            key: anim,
                            frames: this.scene.anims.generateFrameNames(decor.texture.key, {
                                start: animations[libId]['start'], end: animations[libId]['end'], zeroPad: 4,
                                prefix: libId, suffix: ''
                            }),
                            frameRate: 60,
                            repeat: animations[libId]['autoplay'] ? -1 : 0
                        });
                    }
                    if (animations[libId]['autoplay']) {
                        decor.play(decor["playingAnimName"]);
                    }
                }
                return decor;
            }
            createEnemySprite(libId) {
                let mapOrigins = {
                    'enemy1MC': { 'x': 45 / 91, 'y': 28 / 47 },
                    'enemy2MC': { 'x': 35 / 68, 'y': 0.1 },
                    'hazard1MC': { 'x': 50 / 100, 'y': 95 / 95 },
                    'hazard2MC': { 'x': 50 / 100, 'y': 63 / 63 }
                };
                let animations = {
                    'enemy1MC': {
                        'move': { 'start': 0, 'end': 35, 'repeat': -1 },
                        'attack': { 'start': 0, 'end': 35, 'repeat': -1 },
                        'die': { 'start': 36, 'end': 91, 'repeat': 0 }
                    },
                    'enemy2MC': {
                        'idle': { 'start': 0, 'end': 0, 'repeat': 0 },
                        'drop': { 'start': 0, 'end': 0, 'repeat': 0 },
                        'pull': { 'start': 1, 'end': 1, 'repeat': 0 },
                        'attack': { 'start': 1, 'end': 1, 'repeat': 0 }
                    }
                };
                let bodySize = {
                    'enemy1MC': { x: 10, y: 10, yFlipped: 0, w: 70, h: 20 },
                    'enemy2MC': { x: 0, y: 10, yFlipped: 0, w: 70, h: 30 },
                    'hazard1MC': { x: 0, y: 0, w: 101, h: 50 },
                    'hazard2MC': { x: 0, y: 0, w: 101, h: 80 }
                };
                let enemy = this.scene.physics.add.sprite(0, 0, 'objects-atlas', libId + '0000');
                enemy.setOrigin(mapOrigins[libId]['x'], mapOrigins[libId]['y']);
                enemy.setCollideWorldBounds(false);
                enemy.body.setSize(bodySize[libId]['w'], bodySize[libId]['h']);
                enemy.body.setOffset(bodySize[libId]['x'], bodySize[libId]['y']);
                if (bodySize[libId].hasOwnProperty('yFlipped')) {
                    enemy.body.offset['-y-'] = bodySize[libId]['y'];
                    enemy.body.offset['-yFlipped-'] = bodySize[libId]['yFlipped'];
                }
                else {
                    enemy.setImmovable(true);
                }
                enemy.body["setAllowGravity"](false);
                if (animations[libId]) {
                    for (let k in animations[libId]) {
                        let anim = libId + "_" + k;
                        if (!this.scene.anims.exists(anim)) {
                            this.scene.anims.create({
                                key: anim,
                                frames: this.scene.anims.generateFrameNames(enemy.texture.key, {
                                    start: animations[libId][k]['start'], end: animations[libId][k]['end'], zeroPad: 4,
                                    prefix: libId, suffix: ''
                                }),
                                frameRate: 60,
                                repeat: animations[libId][k]['repeat']
                            });
                        }
                    }
                }
                if (libId == "hazard1MC" || libId == "hazard2MC") {
                    let waves = this.scene.add.container(0, 0);
                    let n = 6;
                    for (let i = 0; i < n; i++) {
                        let miniwave = this.scene.add.sprite(enemy.width / 2 + (16 * (i - (n % 2 == 0 ? (n / 2 - 0.5) : (n - 1) / 2) - 2)), -enemy.height + 5, 'objects-atlas', 'miniwave0000');
                        miniwave.setOrigin(0.5, 1);
                        miniwave.x -= miniwave.width;
                        if (i % 2 == 0)
                            miniwave.scaleX = -1;
                        let miniwave_anim = 'miniwave-anim';
                        if (!this.scene.anims.exists(miniwave_anim)) {
                            this.scene.anims.create({
                                key: miniwave_anim,
                                frames: this.scene.anims.generateFrameNames('objects-atlas', {
                                    start: 0, end: 34, zeroPad: 4,
                                    prefix: 'miniwave', suffix: ''
                                }),
                                frameRate: 60,
                                repeat: -1
                            });
                        }
                        miniwave.play(miniwave_anim);
                        waves.add(miniwave);
                    }
                    enemy["-attachedSprite-"] = waves;
                }
                return enemy;
            }
            createOtherSprite(libId) {
                let mapOrigins = {
                    'bblock1MC': { 'x': 0.5, 'y': 1 }
                };
                if (!mapOrigins.hasOwnProperty(libId))
                    return null;
                let bodySize = {
                    'bblock1MC': { x: 0, y: 32 / 2 - 4, w: 32, h: 32 }
                };
                let animations = {
                    'bblock1MC': {
                        'mask': { 'start': 7, 'end': 7, 'repeat': 0 },
                        'masked': { 'start': 7, 'end': 7, 'repeat': 0 },
                        'wobble': { 'start': 55, 'end': 72, 'repeat': 0 },
                        'question-wobble': { 'start': 74, 'end': 91, 'repeat': 0 },
                        'break': { 'start': 93, 'end': 98, 'repeat': 0 },
                        'hidden': { 'start': 100, 'end': 107, 'repeat': 0 },
                        'makeSolid': { 'start': 108, 'end': 124, 'repeat': 0 },
                        'maskToSolid': { 'start': 125, 'end': 141, 'repeat': 0 },
                        'hiddenToSolid': { 'start': 143, 'end': 158, 'repeat': 0 },
                        'solid': { 'start': 159, 'end': 159, 'repeat': 0 },
                        'question': { 'start': 167, 'end': 174, 'repeat': 0 }
                    }
                };
                let sprite = this.scene.physics.add.sprite(0, 0, 'objects-atlas', libId + '0000');
                sprite.setOrigin(mapOrigins[libId]['x'], mapOrigins[libId]['y']);
                sprite.setCollideWorldBounds(false);
                sprite.body.setSize(bodySize[libId]['w'], bodySize[libId]['h']);
                sprite.body.setOffset(bodySize[libId]['x'], bodySize[libId]['y']);
                sprite.setImmovable(true);
                sprite.body["setAllowGravity"](false);
                for (let k in animations[libId]) {
                    let anim = libId + "_" + k;
                    if (!this.scene.anims.exists(anim)) {
                        this.scene.anims.create({
                            key: anim,
                            frames: this.scene.anims.generateFrameNames(sprite.texture.key, {
                                start: animations[libId][k]['start'], end: animations[libId][k]['end'], zeroPad: 4,
                                prefix: libId, suffix: ''
                            }),
                            frameRate: 60,
                            repeat: animations[libId][k]['repeat']
                        });
                    }
                }
                return sprite;
            }
            createSprite(spriteInfo
            /*
            spriteInfo[0] = sprite id
            spriteInfo[1] = x
            spriteInfo[2] = y
            spriteInfo[3] = libId
            spriteInfo[4] = options
            */
            ) {
                let libId = spriteInfo[3];
                if (libId == "enemy4MC")
                    libId = "enemy4MC" + "_kid" + (Math.ceil(Math.random() * 3));
                let sprite_mc = this.createConstructedObject(libId);
                if (!sprite_mc) {
                    if (spriteInfo[3].indexOf("decor") == 0) {
                        sprite_mc = this.createDecorSprite(libId);
                    }
                    else if (spriteInfo[3].indexOf("enemy") == 0 || spriteInfo[3].indexOf("hazard") == 0) {
                        sprite_mc = this.createEnemySprite(libId);
                    }
                    else {
                        sprite_mc = this.createOtherSprite(libId);
                        if (!sprite_mc) {
                            sprite_mc = this.scene.add.sprite(0, 0, 'objects-atlas', libId + '0000');
                        }
                    }
                }
                sprite_mc.setPosition(Number(spriteInfo[1]), Number(spriteInfo[2]));
                sprite_mc["defPosition"] = { x: Number(spriteInfo[1]), y: Number(spriteInfo[2]) };
                sprite_mc["libId"] = libId;
                let spriteId = sprite_mc["spriteId"] = spriteInfo[0];
                // extract options
                let options = spriteInfo[4].split('_');
                let spriteType = sprite_mc["spriteType"] = options[0];
                if (spriteType == 'E') {
                    // enemy
                    // define enemy hits required
                    sprite_mc["hitsToKill"] = Math.ceil(Number(options[1]));
                    //moving range
                    var movingRange = parseFloat(options[2]);
                    if (!isNaN(movingRange)) {
                        sprite_mc["movingRange"] = movingRange;
                    }
                    // pixel range
                    sprite_mc["enemyType"] = options[3];
                    //sprite_mc.dx = sprite_mc.xSpeed;
                    sprite_mc["dy"] = 0;
                    sprite_mc["dead"] = false;
                }
                else if (spriteType == 'H') {
                    // hazard
                    // define hazard strength
                    sprite_mc["strength"] = options[1];
                }
                else if (spriteType == 'C') {
                    // chick / collectable
                    // orientate?
                    if (Math.random() > 0.5)
                        sprite_mc.scaleX = -1;
                    sprite_mc["points"] = Number(options[1]);
                    // flap at random:
                    // sprite_mc.gotoAndStop(Math.ceil(Math.random()*15));
                }
                else if (spriteType == 'D') {
                    // decor
                    sprite_mc["decorType"] = options[1];
                    sprite_mc["speech"] = options[2];
                    if (sprite_mc["decorType"] == 'protestor' && sprite_mc["speech"]) {
                        sprite_mc["speaking"] = false;
                        sprite_mc["dy"] = 0;
                    }
                    else if ((sprite_mc["decorType"] == 'pipeDown' || sprite_mc["decorType"] == 'pipeSide' || sprite_mc["decorType"] == 'pipeUp') && sprite_mc["speech"]) {
                        // rename correctly:
                        sprite_mc["pipeRoute"] = sprite_mc["speech"];
                    }
                    else if (sprite_mc["decorType"] == 'bounce' || sprite_mc["decorType"] == 'uberBounce') {
                    }
                    else if (sprite_mc["decorType"] && sprite_mc["decorType"].substr(0, 3) == 'fan') {
                        if (sprite_mc["decorType"] == 'fanUp') {
                            sprite_mc["fanDir"] = (sprite_mc["decorType"] == 'fanUp') ? -1 : 1;
                        }
                        else {
                            sprite_mc["fanDir"] = (sprite_mc["decorType"] == 'fanLeft') ? -1 : 1;
                        }
                    }
                    else if (sprite_mc["decorType"] == 'recovery') {
                        // recovery point
                        sprite_mc['-active-'] = false;
                    }
                    else if (sprite_mc["decorType"] == 'switch') {
                        // flip switch
                        sprite_mc["switchType"] = options[3];
                    }
                    if (sprite_mc["decorType"] == 'above') {
                        // send to front
                        // water object
                        if (sprite_mc["hitSpace_mc"]) {
                        }
                    }
                }
                else if (spriteType == 'B') {
                    // B (Blocks): [hitsToDestroy]-[playLabel]-[points/value]
                    sprite_mc["hitsLeft"] = Number(options[1]);
                    sprite_mc["playLabel"] = options[2];
                    sprite_mc["points"] = Number(options[3]);
                    sprite_mc["displayType"] = options[4];
                    // value block?
                    if (sprite_mc["playLabel"]) {
                        if (!sprite_mc["displayType"])
                            sprite_mc["displayType"] = 'question';
                        this.gotoAndPlay(sprite_mc, sprite_mc["displayType"]);
                    }
                }
                if (sprite_mc["libId"] == "decor3MC") {
                    let zzz_anim = 'zzz-anim';
                    if (!this.scene.anims.exists(zzz_anim)) {
                        this.scene.anims.create({
                            key: zzz_anim,
                            frames: this.scene.anims.generateFrameNames('decor-atlas', {
                                start: 0, end: 124, zeroPad: 4,
                                prefix: 'zzz', suffix: ''
                            }),
                            frameRate: 60,
                            repeat: -1
                        });
                    }
                    sprite_mc["-attachedSprite-"] = [];
                    for (let i = 0; i < 4; i++) {
                        let zzz = this.scene.add.sprite(0, 0, 'decor-atlas', 'zzz0000');
                        zzz.setOrigin(-0.3, 1.3);
                        setTimeout(() => {
                            zzz.play(zzz_anim);
                        }, i * 250);
                        sprite_mc["-attachedSprite-"].push(zzz);
                    }
                    sprite_mc["-attachedSprite-layer-"] = "above";
                }
                if (sprite_mc["libId"] == "decor4MC") {
                    let decor4MC_dot = this.scene.add.sprite(0, 0, 'decor-atlas', 'decor4MC_dot0000');
                    decor4MC_dot.setOrigin(1.1, 1);
                    let decor4MC_dot_anim = 'decor4MC_dot-anim';
                    if (!this.scene.anims.exists(decor4MC_dot_anim)) {
                        this.scene.anims.create({
                            key: decor4MC_dot_anim,
                            frames: this.scene.anims.generateFrameNames('decor-atlas', {
                                start: 0, end: 126, zeroPad: 4,
                                prefix: 'decor4MC_dot', suffix: ''
                            }),
                            frameRate: 60,
                            repeat: -1
                        });
                    }
                    decor4MC_dot.play(decor4MC_dot_anim);
                    sprite_mc["-attachedSprite-"] = decor4MC_dot;
                    sprite_mc["-attachedSprite-layer-"] = "above";
                }
                return sprite_mc;
            }
            createConstructedObject(libId) {
                let object = null;
                if (libId == "boss2MC") {
                    object = new nscs.character.Boss(this.scene);
                }
                else if (libId == "flagPoleMC") {
                    object = this.scene.add.container(0, 0);
                    let flagPoleMC = this.scene.physics.add.sprite(0, 0, 'objects-atlas', 'flagPoleMC0000');
                    flagPoleMC.setOrigin(0.5, 1);
                    flagPoleMC.setCollideWorldBounds(false);
                    flagPoleMC.body.setSize(9, 181);
                    flagPoleMC.setImmovable(true);
                    flagPoleMC.body["setAllowGravity"](false);
                    object.add(flagPoleMC);
                    object["flagPoleMC"] = flagPoleMC;
                    let flag_kfc_MC = new Phaser.GameObjects.Image(this.scene, 0, -185, 'objects-atlas', 'flag_kfc_MC0000');
                    flag_kfc_MC.setOrigin(1, 0);
                    object.add(flag_kfc_MC);
                    object["flag_kfc_MC"] = flag_kfc_MC;
                }
                else if (libId == "tinyChickMC") {
                    object = this.scene.physics.add.sprite(0, 0, 'objects-atlas');
                    object.setOrigin(12 / 24, 25 / 24);
                    object.setCollideWorldBounds(false);
                    object.body.setSize(24, 24);
                    object.setImmovable(true);
                    object.body["setAllowGravity"](false);
                    let chick_mc_anim = 'tinyChickMC-anim';
                    if (!this.scene.anims.exists(chick_mc_anim)) {
                        this.scene.anims.create({
                            key: chick_mc_anim,
                            frames: this.scene.anims.generateFrameNames('objects-atlas', {
                                start: 0, end: 15, zeroPad: 4,
                                prefix: 'tinyChickMC', suffix: ''
                            }),
                            frameRate: 60,
                            repeat: -1
                        });
                    }
                    object.play(chick_mc_anim);
                }
                return object;
            }
            playAnimation(object, animName = null) {
                if (object["libId"] == "flagPoleMC") {
                    let fn = (d) => {
                        nscs.util.Functions.delayedCall(d, () => {
                            let flag_peta_MC = new Phaser.GameObjects.Image(this.scene, 0, 0, 'objects-atlas', 'flag_peta_MC0000');
                            flag_peta_MC.setOrigin(0, 0);
                            flag_peta_MC.scaleX = 1;
                            flag_peta_MC.scaleY = 0;
                            this.scene.tweens.add({
                                targets: flag_peta_MC,
                                duration: 500,
                                y: -185,
                                scaleY: 1,
                                ease: Phaser.Math.Easing.Sine.Out
                            });
                            object.add(flag_peta_MC);
                        });
                    };
                    if (animName == "normal-flag-reached") {
                        this.scene.tweens.add({
                            targets: object["flagPoleMC"],
                            duration: 500,
                            alpha: 1,
                            ease: Phaser.Math.Easing.Back.Out
                        });
                        this.scene.tweens.add({
                            targets: object["flag_kfc_MC"],
                            duration: 500,
                            y: 0,
                            scaleY: 0,
                            ease: Phaser.Math.Easing.Sine.Out,
                            onComplete: () => { if (object["flag_kfc_MC"].parentContainer)
                                object["flag_kfc_MC"].parentContainer.remove(object["flag_kfc_MC"]); }
                        });
                        fn(500);
                    }
                    else if (animName == "boss-flag-reached") {
                        object["flagPoleMC"].alpha = 0;
                        this.scene.tweens.add({
                            targets: object["flagPoleMC"],
                            duration: 500,
                            alpha: 1,
                            ease: Phaser.Math.Easing.Back.Out
                        });
                        let flag_kfc_MC = object["flag_kfc_MC"].setPosition(0, -185);
                        this.scene.tweens.add({
                            targets: flag_kfc_MC,
                            duration: 500,
                            y: 0,
                            scaleY: 0,
                            ease: Phaser.Math.Easing.Sine.Out,
                            onComplete: () => { if (flag_kfc_MC.parentContainer)
                                flag_kfc_MC.parentContainer.remove(flag_kfc_MC); }
                        });
                        fn(1000);
                    }
                    else if (animName == "boss-flag-appear") {
                        object.y = object.y - 250;
                        object.setScale(1, 0.5);
                        object.alpha = 0;
                        this.scene.tweens.add({
                            targets: object,
                            duration: 500,
                            scaleY: 1,
                            y: object.y + 250,
                            alpha: 1,
                            ease: Phaser.Math.Easing.Back.Out
                        });
                        let flag_kfc_MC = object["flag_kfc_MC"].setPosition(0, -50);
                        flag_kfc_MC.scaleY = 0;
                        this.scene.tweens.add({
                            targets: flag_kfc_MC,
                            duration: 500,
                            y: -185,
                            scaleY: 1,
                            ease: Phaser.Math.Easing.Sine.Out
                        });
                        object.add(flag_kfc_MC);
                    }
                }
                else if (object["playingAnimName"]) {
                    object.play(object["playingAnimName"]);
                }
            }
            gotoAndPlay(sprite, label) {
                let animName = sprite["libId"] + "_" + label;
                sprite['_animationComplete_'] = false;
                sprite['_animationToComplete_'] = animName;
                if (!sprite["_animationComplete_listener_"]) {
                    sprite["_animationComplete_listener_"] = true;
                    sprite.on('animationcomplete', () => {
                        if (sprite.anims.getCurrentKey() == sprite['_animationToComplete_']) {
                            sprite['_animationComplete_'] = true;
                        }
                    });
                }
                sprite.anims.stop();
                sprite.play(animName);
            }
            isAnimationComplete(sprite) {
                return !sprite.hasOwnProperty('_animationComplete_') || sprite['_animationComplete_'];
            }
            createTypicalButton(x, y, key) {
                let btn = this.scene.add.sprite(x, y, 'ui-atlas', key + "0000");
                btn.setInteractive({ cursor: 'pointer' });
                btn.on('pointerout', () => {
                    btn.setFrame(key + '0000');
                });
                btn.on('pointerover', () => {
                    btn.setFrame(key + '0001');
                });
                btn.on('pointerdown', () => {
                    btn.setFrame(key + '0002');
                });
                return btn;
            }
        }
        Factory.ANIM = {
            'chickette_small': {
                'walk': { 'start': 0, 'end': 17 },
                'idle': { 'start': 0, 'end': 5 },
                'fly': { 'start': 6, 'end': 6 },
                'squat': { 'start': 18, 'end': 18 },
                'pounceLand': { 'start': 19, 'end': 35 },
                'pounce': { 'start': 36, 'end': 66 },
                'climbing': { 'start': 67, 'end': 83 },
                'grow': { 'start': 84, 'end': 115 }
            },
            'chickette_big': {
                'walk': { 'start': 0, 'end': 17 },
                'idle': { 'start': 0, 'end': 5 },
                'fly': { 'start': 6, 'end': 6 },
                'pounceLand': { 'start': 18, 'end': 34 },
                'pounce': { 'start': 35, 'end': 49 },
                'climbing': { 'start': 50, 'end': 66 },
                'grow': { 'start': 67, 'end': 98 },
                'seaKittenise': { 'start': 99, 'end': 133 }
            },
            'nugget_small': {
                'walk': { 'start': 0, 'end': 17 },
                'idle': { 'start': 0, 'end': 5 },
                'fly': { 'start': 6, 'end': 6 },
                'pounceLand': { 'start': 18, 'end': 34 },
                'pounce': { 'start': 35, 'end': 59 },
                'climbing': { 'start': 60, 'end': 76 },
                'grow': { 'start': 77, 'end': 108 }
            },
            'nugget_big': {
                'walk': { 'start': 0, 'end': 17 },
                'idle': { 'start': 0, 'end': 5 },
                'fly': { 'start': 6, 'end': 6 },
                'pounceLand': { 'start': 18, 'end': 34 },
                'pounce': { 'start': 35, 'end': 49 },
                'climbing': { 'start': 50, 'end': 66 },
                'grow': { 'start': 67, 'end': 98 },
                'seaKittenise': { 'start': 99, 'end': 133 }
            },
            'pam_small': {
                'walk': { 'start': 0, 'end': 17 },
                'idle': { 'start': 0, 'end': 5 },
                'fly': { 'start': 6, 'end': 6 },
                'pounceLand': { 'start': 18, 'end': 34 },
                'pounce': { 'start': 35, 'end': 64 },
                'climbing': { 'start': 65, 'end': 81 },
                'grow': { 'start': 82, 'end': 113 }
            },
            'pam_big': {
                'walk': { 'start': 0, 'end': 17 },
                'idle': { 'start': 0, 'end': 5 },
                'fly': { 'start': 6, 'end': 6 },
                'pounceLand': { 'start': 18, 'end': 34 },
                'pounce': { 'start': 35, 'end': 49 },
                'climbing': { 'start': 50, 'end': 66 },
                'grow': { 'start': 67, 'end': 98 },
                'seaKittenise': { 'start': 99, 'end': 133 }
            }
        };
        gameplay.Factory = Factory;
    })(gameplay = nscs.gameplay || (nscs.gameplay = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var gameplay;
    (function (gameplay) {
        class Gameplay {
            constructor() {
                this.character = Gameplay.characters[0];
                this.worlds = [
                    ["1", "_LEVEL1DATA", 400, 146, 320, NaN],
                    ["2", "_LEVEL2DATA", 700, 146, 130, [
                            { p1: { x: 700, y: 1450 }, p2: { x: 860, y: 1450 }, p3: { x: 860, y: 1500 }, p4: { x: 700, y: 1500 } },
                            { p1: { x: 10, y: 1250 }, p2: { x: 580, y: 1250 }, p3: { x: 580, y: 1500 }, p4: { x: 10, y: 1500 } },
                            { p1: { x: 1400, y: 960 }, p2: { x: 1600, y: 960 }, p3: { x: 1600, y: 1100 }, p4: { x: 1400, y: 1100 } },
                        ]
                    ],
                    ["2.1", "_LEVEL2_1DATA", 150, 250, 560, [
                            { p1: { x: 180, y: 650 }, p2: { x: 900, y: 650 }, p3: { x: 900, y: 750 }, p4: { x: 180, y: 750 } }
                        ]],
                    ["2.2", "_LEVEL2_2DATA", 200, 1998, 1470, NaN],
                    ["3", "_LEVEL3DATA", 800, 110, 32, [
                            { p1: { x: 250, y: 1175 }, p2: { x: 450, y: 1175 }, p3: { x: 450, y: 1300 }, p4: { x: 250, y: 1300 } },
                            { p1: { x: 1200, y: 640 }, p2: { x: 1450, y: 640 }, p3: { x: 1450, y: 750 }, p4: { x: 1200, y: 750 } },
                            { p1: { x: 1740, y: 400 }, p2: { x: 1940, y: 400 }, p3: { x: 1940, y: 750 }, p4: { x: 1740, y: 750 } },
                            { p1: { x: 50, y: 1450 }, p2: { x: 2800, y: 1450 }, p3: { x: 2800, y: 1600 }, p4: { x: 50, y: 1600 } },
                            { p1: { x: 350, y: 850 }, p2: { x: 700, y: 850 }, p3: { x: 700, y: 950 }, p4: { x: 350, y: 950 } }
                        ]
                    ],
                    ["3.1", "_LEVEL3_1DATA", 100, 286, 480, NaN],
                    ["3.2", "_LEVEL3_2DATA", 100, 320, 320, NaN],
                    ["4", "_LEVEL4DATA", 900, 170, 1420, NaN],
                    ["4.1", "_LEVEL4_1DATA", 400, 242, 1450, NaN],
                    ["5", "_LEVEL5DATA", 900, 120, 1420, NaN],
                    ["5.1", "_LEVEL5_1DATA", 150, 394, 1472, NaN],
                ];
                this.thisWorldId = 0;
                this.lives = 3;
                // player physics:
                this.charSize = 'small';
                this.ammo = 0; // int representing appropriate bullet MC frame (0: no ammo)
                this.seaKitten = false;
                this.xSpeed0 = 180; // 1 - 10
                this.xSpeed = this.xSpeed0; // 1 - 10
                this.movingPlatformSpeed = this.xSpeed0 * 0.7;
                this.ladderSpeed0 = 125; // 1 - 10
                this.jumpHeight0 = 620; // 1 - 10
                this.jumpHeight = this.jumpHeight0;
                this.gravity = Gameplay.gravity0; // 1 - 10
                this.gravityDir = 1; // 1 is upright -1 is upside down
                // init
                this.inWater = false;
                this.waterLevel = NaN;
                this.waterRects = null;
                this.ladderSpeed = this.ladderSpeed0;
                // world dimensions
                this.tileWidth = 32;
                this.tileHeight = 32;
                this.worldTilesX = 90;
                this.worldTilesY = 47;
                this.levelComplete = false;
                this.gameScreen = null;
                this.gameScreensInCache = [];
                /////////////////// SCORING ////////////////////
                this.score = 0;
                this.scoreUps = 10;
                this.milestone = 0;
                this.chicks = 0;
            }
            static setText(textField, stringsType, updateTextFieldPosition = true) {
                let str = this.strings[stringsType][Gameplay.languages.indexOf(Gameplay.currentLanguage)];
                if (updateTextFieldPosition) {
                    nscs.util.Functions.updateTextFieldPosition(textField, str);
                }
                else {
                    textField.setText(str);
                }
            }
            static getText(stringsType) {
                let str = this.strings[stringsType][Gameplay.languages.indexOf(Gameplay.currentLanguage)];
                let character = nscs.scene.MainScene.instance.gameplay.character;
                let substr = '--player--';
                while (str.indexOf(substr) >= 0) {
                    str = str.replace(substr, nscs.util.Functions.capitalise(nscs.scene.MainScene.instance.gameplay ?
                        character : Gameplay.characters[0]));
                }
                substr = '--princess--';
                let replaceWith = character != "pam" ? "me" : "us";
                while (str.indexOf(substr) >= 0) {
                    str = str.replace(substr, replaceWith);
                }
                substr = '--me--';
                while (str.indexOf(substr) >= 0) {
                    str = str.replace(substr, character);
                }
                return str;
            }
            isGravityFlipped() {
                return this.gravityDir < 0;
            }
            calculateGravity() {
                return this.gravity * this.gravityDir;
            }
            getFanWaterCoefficient() {
                return this.inWater ? 1 : 1 / 1.5;
            }
            loadWorld(worldId, transitionFlag = true, destroyPreviousWorlds = true, takeFromCache = false) {
                this.grid = null;
                this.levelComplete = false;
                this.worldWidth = this.tileWidth * this.worldTilesX;
                this.worldHeight = this.tileHeight * this.worldTilesY;
                nscs.scene.MainScene.instance.physics.world.bounds.width = this.worldWidth;
                nscs.scene.MainScene.instance.physics.world.bounds.height = this.worldHeight;
                if (typeof worldId === "string") {
                    for (let i = 0; i < this.worlds.length; i++) {
                        if (this.worlds[i][0] == worldId) {
                            worldId = i;
                            break;
                        }
                    }
                }
                this.thisWorldId = worldId;
                // gather world information
                let world = this.worlds[this.thisWorldId];
                this.newX = Number(world[3]);
                this.newY = Number(world[4]);
                let waterRects = [];
                if (typeof world[5] == "number") {
                    this.waterLevel = Number(world[5]);
                }
                else {
                    for (let elemet of world[5]) {
                        if (typeof elemet == "number") {
                            this.waterLevel = Number(elemet);
                        }
                        else {
                            waterRects.push(elemet);
                        }
                    }
                }
                if (waterRects.length > 0)
                    this.waterRects = waterRects;
                else
                    this.waterRects = null;
                this.timer0 = this.timer = Number(world[2]);
                this.loadLevel(String(world[1]));
                let prevGameScreen = this.gameScreen;
                this.gameScreen = null;
                let takenFromCache = false;
                if (takeFromCache) {
                    for (let i = this.gameScreensInCache.length - 1; i >= 0; i--) {
                        if (this.gameScreensInCache[i].worldIdName == world[0]) {
                            this.gameScreen = this.gameScreensInCache[i];
                            this.gameScreensInCache.splice(i, 1);
                            takenFromCache = true;
                            break;
                        }
                    }
                }
                if (destroyPreviousWorlds) {
                    this.destroyPreviousWorlds();
                    this.gravityDir = 1;
                }
                else {
                    if (prevGameScreen) {
                        let notExistSameNamedGameScreenAlready = true;
                        for (let i = this.gameScreensInCache.length - 1; i >= 0; i--) {
                            if (this.gameScreensInCache[i].worldIdName == prevGameScreen.worldIdName) {
                                notExistSameNamedGameScreenAlready = false;
                                break;
                            }
                        }
                        if (notExistSameNamedGameScreenAlready) {
                            this.gameScreensInCache.push(prevGameScreen);
                        }
                    }
                }
                if (!takenFromCache) {
                    this.gameScreen = new nscs.screen.GameScreen(nscs.scene.MainScene.instance, world[0]);
                    this.loadSprites();
                    this.gameScreen.fetchRecoveryPoints();
                }
                nscs.scene.MainScene.instance.switchScreen(this.gameScreen, transitionFlag, destroyPreviousWorlds);
                nscs.util.Functions.updateTextFieldPosition(this.gameScreen.inGameUI.world_txt, String(world[0].split(".")[0]));
                nscs.util.Functions.updateTextFieldPosition(this.gameScreen.inGameUI.timer_txt, String(this.timer));
                this.gameScreen.inGameUI.setCharacterName(nscs.util.Functions.capitalise(this.character), this.lives);
                this.gameScreen.inGameUI.setScore(this.score);
                this.startTimer();
            }
            destroyPreviousWorlds() {
                for (let i = this.gameScreensInCache.length - 1; i >= 0; i--) {
                    this.gameScreensInCache[i].destroy(true);
                    this.gameScreensInCache.splice(i, 1);
                }
            }
            startTimer() {
                this.destroyTimer();
                this.timerEvent = nscs.scene.MainScene.instance.time.addEvent({ delay: 1000, repeat: this.timer0 });
                this.timerEvent.callback = () => {
                    this.timer = this.timerEvent.repeatCount;
                    nscs.util.Functions.updateTextFieldPosition(this.gameScreen.inGameUI.timer_txt, String(this.timer));
                    if (this.timer == 0) {
                        this.gameScreen.onTimeout();
                    }
                };
            }
            pause() {
                this.timerEvent.paused = true;
            }
            resume() {
                this.timerEvent.paused = false;
            }
            destroyTimer() {
                if (!this.timerEvent)
                    return;
                this.timerEvent.paused = true;
                this.timerEvent.destroy();
            }
            destroy() {
                this.destroyPreviousWorlds();
                this.destroyTimer();
            }
            loadLevel(worldFile) {
                let data = nscs.scene.MainScene.instance.cache.json.get('data');
                let levelDataRaw = data[worldFile];
                this.levelData = new Object();
                let levelDataVars = levelDataRaw.split('&');
                for (let ldv = 0; ldv < levelDataVars.length; ldv++) {
                    let dataBits = levelDataVars[ldv].split('=');
                    let varName = dataBits[0];
                    let varValue = dataBits[1];
                    this.levelData[varName] = varValue;
                }
                var dats = this.levelData["ldat"].split(",");
                var cnt = 0;
                this.grid = new Array(this.worldTilesY);
                for (var i = 0; i < this.worldTilesY; i++) {
                    this.grid[i] = new Array(this.worldTilesX);
                    for (var j = 0; j < this.worldTilesX; j++) {
                        this.grid[i][j] = Number(dats[cnt++]);
                    }
                }
                this.solid_array = this.levelData['sol'].split(",");
                this.ladder_array = this.levelData['lad'].split(",");
                this.spriteList = this.levelData['sprites'].split(',');
                this.updateWaterPhysics();
            }
            loadSprites() {
                let spriteCount = 0;
                for (let sp = 0; sp < this.spriteList.length; sp++) {
                    spriteCount++;
                    let spriteInfo = this.spriteList[sp].split('|');
                    /*
                    spriteInfo[0] = sprite id
                    spriteInfo[1] = x
                    spriteInfo[2] = y
                    spriteInfo[3] = libId
                    spriteInfo[4] = options
                    */
                    let sprite_mc = nscs.scene.MainScene.instance.factory.createSprite(spriteInfo);
                    sprite_mc["spriteNumber"] = spriteCount;
                    let attachedSprites = null;
                    if (sprite_mc["-attachedSprite-"]) {
                        attachedSprites = Array.isArray(sprite_mc["-attachedSprite-"]) ? sprite_mc["-attachedSprite-"] : [sprite_mc["-attachedSprite-"]];
                        for (let a of attachedSprites) {
                            a.setPosition(sprite_mc.x, sprite_mc.y);
                        }
                        if (sprite_mc["-attachedSprite-layer-"] == "under") {
                            for (let a of attachedSprites) {
                                this.gameScreen.addSprite(a);
                            }
                        }
                    }
                    this.gameScreen.addSprite(sprite_mc);
                    if (attachedSprites && sprite_mc["-attachedSprite-layer-"] != "under") {
                        for (let a of attachedSprites) {
                            this.gameScreen.addSprite(a);
                        }
                    }
                }
                this.gameScreen.onSpritesAdded();
            }
            addLife() {
                this.lives++;
                this.gameScreen.showTextPopUp('1UP');
                this.gameScreen.inGameUI.setCharacterName(nscs.util.Functions.capitalise(this.character), this.lives);
            }
            minusLife() {
                this.lives--;
                this.gameScreen.inGameUI.setCharacterName(nscs.util.Functions.capitalise(this.character), this.lives);
                this.setSeaKitten(false);
            }
            addToScore(scoreToAdd) {
                this.score += scoreToAdd;
                this.gameScreen.inGameUI.setScore(this.score);
            }
            scoreUp(scoreBit) {
                this.gameScreen.scoreUp(scoreBit);
                // play scoreUp animation:
                this.addToScore(scoreBit);
                this.scoreUps++;
            }
            addChick() {
                this.chicks++;
                this.gameScreen.inGameUI.setChicks(this.chicks);
                if (Math.floor(this.chicks / 100) > this.milestone) {
                    this.milestone = Math.floor(this.chicks / 100);
                    this.addLife();
                }
            }
            getNextWorldNumber() {
                let thisWorldId = this.thisWorldId;
                if (typeof thisWorldId == "number") {
                    thisWorldId = this.worlds[this.thisWorldId][0];
                }
                let thisWorldsNumber = Math.floor(parseFloat(thisWorldId));
                return thisWorldsNumber + 1;
            }
            loadNextWorld() {
            }
            setSeaKitten(active) {
                this.seaKitten = active;
            }
            updateWaterPhysics() {
                if (this.inWater) {
                    this.gravity = Gameplay.gravity0 * 0.19;
                    if (this.seaKitten) {
                        this.xSpeed = this.xSpeed0 * 0.65;
                        this.jumpHeight = this.jumpHeight0 * 0.4;
                    }
                    else {
                        this.xSpeed = this.xSpeed0 * 0.7;
                        this.jumpHeight = this.jumpHeight0 * 0.47;
                    }
                }
                else {
                    // revert
                    this.gravity = Gameplay.gravity0;
                    this.xSpeed = this.xSpeed0;
                    this.jumpHeight = this.jumpHeight0;
                }
            }
            calculateTotalScore() {
                this.score += this.timer * 100;
                if (this.thisWorldId == 5) {
                    this.score += this.lives * 1500;
                }
            }
        }
        Gameplay.isPamLocked = true;
        Gameplay.languages = ["EN", "NL", "ES", "SK", "JA", "DE"];
        Gameplay.currentLanguage = "EN";
        Gameplay.strings = {
            NewGameBtn: ["New Game", "Nieuwe game", "Juego nuevo", "Nová hra", "新しいゲームへ", "Neues Spiel"],
            StartKidFriendlyGameBtn: ["Start Kid-Friendly Game", "Start dit kindvriendelijke spel", "Iniciar juego apropiado para niños", "Hra začiatočného stupňa vhodná pre deti", "子ども用ゲームをスタート", "Kinderfreundliches Spiel starten"],
            NextBtn: ["Next", "Volgende", "Siguiente", "Ďalší", "次", " Zunächst "],
            EnterCodeBtn: ["Enter Code", "Entercode", "Introduce código", "Zadaj kód", "コード入力", "Code eingeben"],
            EnterCodePrompt: ["Enter code to play as Pamela Anderson:", "Klik op de entercode en speel als Pamela:", "Introduce el código para jugar como Pamela Anderson:", "Zadaj kód, aby si mohol hrať ako Pamela Andersonová:", "パメラ・アンダーソンとしてプレーするためにコードを入力", "Gib den Code ein, um als Pamela zu spielen:"],
            OKBtn: ["OK", "OK", "Aceptar", "OK", "OK", "OK"],
            CancelBtn: ["Cancel", "Annuleer", "Cancelar", "Zruš", "キャンセル", "Löschen "],
            HighScoresBtn: ["High Scores", "Hoge scores", "Puntuación alta", "Vysoké skóre", "ハイスコア", "High Score"],
            Instruct1: ["Colonel Sanders and his minions have kidnapped Pamela Anderson for revealing to the world that KFC's secret recipe is cruelty to chickens! Help the Super Chick Sisters save Pam before it's too late!"],
            StartGameBtn: ["Start Game", "Start game", "Iniciar juego", "Spustiť hru", "ゲーム開始", "Spiel starten"],
            Instruct2: ["Use the arrows to move. Use the \"up\" arrow to jump, climb, and break blocks. Click ESC to pause the game.Defeat enemies by jumping on their heads."],
            ChooseChar: ["Choose Your Character!", "Kies je personage!", "¡Elige su personaje!", "Zvoľ si svoju postavičku!", "キャラクターを選んでください", "Wähle Deine Figur!"],
            Nugget: ["Nugget", "Goudhaantje", "Nugget", "Nugget", "ナゲット", "Nugget"],
            Chickette: ["Chickette", "Kippie", "Chickette", "Chickette", "チッケット", "Chickette"],
            Pam: ["Pam", "Pam", "Pam", "Pam", "パメラ・アンダーソン", "Pam"],
            PamLong: ["Pamela Anderson", "Pamela Anderson", "Pamela Anderson", "Pamela Andersonová", "パメラ・アンダーソン", "Pamela Anderson"],
            Locked: ["Locked", "Gesloten", "Cerrado", "Zamknutý", "ロックされています", "Gesperrt"],
            World: ["World", "Wereld", "Mundo", "Svet", "ワールド", "Welt"],
            Time: ["Time", "Tijd", "Tiempo", "Čas", "時間", "Zeit"],
            Paused: ["Game Paused", "Spel afgebroken", "Juego en pausa", "Hra je prerušená", "ゲーム一時停止", "Pause"],
            QuitBtn: ["Quit", "Stoppen", "Abandonar", "Skončiť", "終了", "Ende"],
            ResumeBtn: ["Resume", "Terug", "Continuar", "Obnoviť", "再開", "Weiterspielen"],
            TimeOver: ["Time Over!", "Tijd verlopen!", "¡Tiempo muerto!", "Koniec vymedzeného času!", "時間切れです！", "Zeit zuende!"],
            activist1: ["Hi, --player--! Did you know that KFC chickens have their sensitive beaks cut off?! How painful! Many birds are so stressed from being \"debeaked\" that they cannot eat. Please, hurry!"],
            activist2: ["Thank goodness you\'re here, --player--! KFC is scalding chickens to death! Many birds are still awake when their feathers are scalded off in \"defeathering tanks.\" Can you imagine THAT?! Yuck!"],
            activist3: ["--player--! We\'ve seen so many crippled chickens with broken wings and legs. And these overgrown birds are still just babies when they are killed! You can\'t let the Colonel get away with this!"],
            activist4: ["Hurry, --player--! We just found out that the chickens are being fed drugs that make them grow so large that many of them won\'t be able to move! You\'ve got to help them!"],
            activist5: ["You\'re just in time, --player--! You have to stop KFC from making more bloody buckets!"],
            activist6: ["Things are getting worse around here, --player--. The Colonel wants to sell more and more chickens, and he doesn\'t care at all about how unhappy they are. You\'re the only one who can stop him!"],
            activist7: ["Keep up the great work, --player--! Once everyone knows exactly what the Colonel is doing to these chickens to make his buckets, he\'ll have to stop it!"],
            activist8: ["It\'s so horrible what KFC does to these chickens! They have their sensitive beaks cut off and their legs broken, and they\'re often scalded to death!"],
            activist9: ["--player--! KFC and the Colonel don\'t even use painkillers when they cut the chickens\' throats. There must be something we can do to stop them!"],
            activist10: ["These chickens are crammed into spaces so small, they barely have room to move around. Can you believe it?!"],
            activist11: ["Don\'t give up now, --player--. We\'ve got the Colonel on the run!"],
            activist12: ["--player--! Some of these chickens have horrible diseases, and the Colonel won\'t do anything to help them. Please, hurry!"],
            activist13: ["Thank you so much for helping the chickens, --player--! The KFC workers have to catch so many that they just grab them and throw them onto trucks, which often breaks their wings and legs!"],
            activist14: ["We\'re so glad you\'re helping these chickens, --player--! KFC should never be allowed to get away with what it\'s doing."],
            activist15: ["I\'m sorry, but --princess-- in another building."],
            activist16: ["I\'m sorry, but --princess-- in another building."],
            activist17: ["I\'m sorry, but --princess-- in another building."],
            activist18: ["I\'m sorry, but --princess-- in another building."],
            activist19: ["Thanks for saving me! Now we have to let the world know that wicked Colonel Sanders slices chickens\' sensitive beaks off when they\'re only 10 days old and throws them alive into near-boiling water to remove their feathers..."],
            activist20: ["With your help, we can let the Colonel know that nobody\'s going to eat at KFC until this cruelty stops."],
            GameOver: ["Game Over!", "Game over!", "¡Juego terminado!", "Koniec hry!", "ゲーム終了！", "Game over!"],
            GameOverText: ["Learn more about McDonald\'s cruelty to prepare for your next game.", "Leer meer over de wreedheid van McDonald\'s om je op de volgende game voor te bereiden.", "Aprende más sobre la crueldad de McDonald\'s y te prepara para tu próximo juego.", "Dozveď sa viac o McDonaldovej krutosti a priprav sa na novú hru.", "次のゲームのために、マクドナルドによる虐待について、もっと見てください！ ", "Lerne mehr über die Grausamkeit bei McDonald’s USA."],
            PlayAgainBtn: ["Play Again", "Opnieuw spelen", "Jugar otra vez", "Znovu hraj", "もう１度ゲームをする ", "Nochmal spielen"],
            HighScoresTitle: ["High Scores!", "Hoge scores", "Puntuación alta", "Vysoké skóre", "ハイスコア", "High Scores"],
            HighScoresConnecting: ["Connecting to high score server...", "Ga naar de hoge score server ...", "Conectando al servidor de puntuación alta…", "Pripájanie sa na server vysokého skóre…", "ハイスコア・サーバーに接続中・・・", "Verbindung zum High Score Server wird hergestellt"],
            HighScoresUnreachable: ["The high score server cannot be reached! Please check your Internet connection and try again...", "De server is niet te bereiken. Controleer je internetverbinding en probeer het opnieuw.", "¡El servidor de puntuación alta no puede ser encontrado! Por favor checa tu conexión del Internet e inténtalo otra vez…", "Server vysokého skóre sa nedá dosiahnuť! Skontroluj internetové spojenie a znovu sa pokús…", "ハイスコア・サーバーに接続できません！インターネット接続を確認して、もう１度試してください・・・", "Der High Score Server kann nicht verbunden werden. Bitte kontrolliere Deine Internetverbindung und versuche es noch einmal..."],
            RetryBtn: ["Retry", "Herstart", "Reintentar", "Opakovať", "再試行", "Wiederholen"],
            AllTimeBtn: ["All Time", "Top Score", "Sin precedentes", "Rekordný", "過去最高", "Alle"],
            RecentBtn: ["Recent", "Recent", "Reciente", "Aktuálny", "最近", "Letzte"],
            RestartBtn: ["Restart", "Herstart", "Reanudar", "Reštartuj", "リスタート", "Neustart"],
            HighScoreTitle: ["High Score!", "Hoge score!", "¡Puntaje alto!", "Vysoké skóre!", "ハイスコア！", "High Score!"],
            NamePrompt: ["Name:", "Naam:", "Nombre:", "Meno:", "名前： ", "Name"],
            PostBtn: ["Post!", "Verzend!", "¡Fijar!", "Zverejni!", "掲示！", "Eingeben!"],
            allTimeNotice: ["Yours is an all-time high score! Post your name to the scoreboard!", "Jij hebt de allerhoogste score! Plaats je naam op het scorebord!", "¡Tienes un puntaje alto sin precedentes! ¡Fija tu nombre al marcador!", "To tvoje sa nachádza v kategórii rekordne vysokého skóre! Zverejni svoje meno na tabuli výsledkov!", "過去最高のハイスコアです！スコアボードに名前を掲示してください！ ", "Du hast einen All-Time-High Score geschafft. Schreib Deinen Namen an die Ehrenwand!"],
            recentNotice: ["Yours is a recent high score! Post your name to the scoreboard!", "Jouw score was een van de hoogste! (Plaats je naam op het scorebord!", "¡Tienes un puntaje alto reciente! ¡Fija tu nombre al marcador!", "To tvoje sa nachádza v kategórii aktuálne vysokého skóre! Zverejni svoje meno na tabuli výsledkov!", "最近のハイスコアです！スコアボードに名前を掲示してください", "Du hast einen neuen High Score geschafft. Schreib Deinen Namen an die Ehrenwand!"],
            cutscene0_1: ["Pamela Anderson: I am here today to tell you the terrible secrets that KFC has been trying to keep from the public about what it does to chickens."],
            cutscene0_1B: ["Pamela Anderson: Here goes..."],
            cutscene0_2: ["What the ...?!"],
            cutscene0_3: ["Mmmmmph! Mmmmmph!"],
            cutscene0_4: ["Toad: Hey, guys! Someone\'s been kidnapped! Stop playing Wii and get down here!"],
            cutscene0_5: ["Mario: We played too long. I can\'t feel my arm anymore!"],
            cutscene0_5B: ["Mario: I think we have ... Wiitis."],
            cutscene0_6: ["Mario: We need to see a doctor! It\'s not as if there\'s another pair of super-powered siblings out there who can help save the day..."],
            cutscene0_7: ["Pam\'s in trouble! There\'s no time to lose!"],
            cutscene1_1: ["There\'s still work to be done ..."],
            cutscene1_2: ["Mario: You have to hurry, doc! There\'s simply no one else out there who can help save this kidnapped princess."],
            cutscene2_3: ["Activist: You!\rMario: Uh-oh ..."],
            "": ["                                                                           "],
            cutscene3_1: ["Our work here is done. Let\'s move on and rescue Pam before it\'s too late!"],
            cutscene3_2: ["Mario: Excuse me, but have you seen this woman? She\'s been kidnapped, and as usual, I\'m the only one who can save the day."],
            cutscene3_3: ["Mario: Princess?! What are you doing here?"],
            cutscene3_3B: ["Princess Peach: Don\'t you worry about that. Hey, whose picture are you holding?"],
            cutscene3_4: ["Mario: Um ... she\'s ... um ..."],
            cutscene4_1: ["Mario: Yoshi! My faithful steed! Saddle up - we have to hurry and save the day."],
            cutscene4_1B: ["Yoshi: Why don\'t you saddle yourself up? What makes you think you can ride me around anyway?"],
            cutscene4_2: ["Yoshi: My new friends have taught me that I don\'t have to do anything I don\'t want to do."],
            cutscene4_3: ["Chickette: We must hurry before she ends up in an unhappy meal!", "Kippie: We moeten opschieten voordat ze in een unhappy meal terecht komt!", "Chickette: ¡Tenemos que apresurarnos antes de que se transformara en una cajita infeliz!", "Chickette: Musíme sa ponáhľať prv než sa ocitne v unhappy meal!", "チッケット：パメラ姫がアンハッピー・ミールになっちゃう前に助けなくちゃ！", "Chickette: Wir müssen uns beeilen, ansonsten endet sie in einem Unhappy Meal!"],
            cutscene5_1: ["Mario: Those other superhero siblings have rescued the Princess again …", "Mario: Die andere superheldhaftige broertjes en zusjes hebben de prinses weer gered  …", "Mario: Esos otros hermanos superhéroes han rescatado a la princesa otra vez…", "Mario: Tí ostatní súrodenci-superhrdinovia znovu zachránili princeznu…", "マリオ：また、あっちのスーパーヒーローきょうだいに先を越された", "Mario: Diese anderen beiden Superhelden-Zwillinge haben mal wieder die Prinzessin gerettet."],
            cutscene5_1B: ["Bowser: Fungah! Foiled again!", "Bowser: Fungah! Weer verslagen!", "Bowser: ¡Funga! ¡Frustrado otra vez!", "Prehliadač: Fungah! Znovu je to zneškodnené!", "バウザー：フンガー！まただめだったか！", "Bowser: Verdammt! Was für \'ne Pleite!"],
            cutscene5_2: ["Phone: Ring, ring, ring", "Telefoon: Tring, tring, tring", "Teléfono: Ring, ring, ring", "Telefón: zvonenie, zvonenie, zvonenie", "電話：リーン、リーン、リーン", "Phone: Ring, Ring, Ring"],
            cutscene5_3: ["Mario: Another offer just came in … a surefire hit: \'New Mario Teaches Typing\'.", "Mario: Er kwam net een andere game-aanbieding binnen … een gegarandeerde hit: \'New Mario Teaches Typing\'.", "Mario: Otra oferta acaba de llegar… un éxito seguro: \'Nuevo Mario enseña teclear\'.", "Mario: Ďalšia ponuka prišla…stopercentný hit: Nový Mario učí písanie na stroji.", "マリオ：また新しい話が来た。「新・タイプの先生マリオ」だって。ヒット確実だ。 ", "Mario: Gerade kam ein neues Angebot herein, das wird definitiv ein Bestseller: \'Mario bringt euch das Tippen bei\'."],
            cutscene5_4: ["Bowser: What people really want is \'Luigi Paint\'!", "Bowser: Wat de mensen echt willen is de game \'Luigi Paint\'!", "Bowser: ¡Lo que le gente realmente quiere es \'Luigi dibuja\'!", "Prehliadač: Čo ľudia naozaj chcú, to je Luigiho Farba!", "バウザー：ほんとにヒットするのは「ルイジ・ペイント」だ！", "Bowser: Was die Kids wirklich wollen ist doch \'Luigi Paint\'!"],
            cutscene5_5: ["Luigi: Yeah, nobody wants more Mario shovelware!", "Luigi: Ja, niemand wil meer ouwe meuk van Mario!", "Luigi: ¡De acuerdo, nadie quiere más \'shovelware\' de Mario!", "Luigi: Mhm, nikto už viac nechce Mariove lopaty!", "ルイジ：そうだ、もうみんなマリオのシャベルウェアには飽き飽きしているよ", "Luigi: Ja genau, keiner will mehr diese Mario-Ramschware"],
            cutscene5_6: ["You have rescued me again and saved millions of chickens from the worst abuses at the hands of McDonald\'s.", "Je hebt me weer bevrijd en miljoenen kippen gered van de ergste mishandelingen uit de handen van McDonald\'s.", "Me han salvado otra vez y salvado millones de pollos de los abusos horribles en las manos de McDonald\'s. ", "Ty si znovu zachránil nielen mňa, ale aj milióny kurčiat, a to pred najhorším týraním McDonaldovými rukami.", "また私を助けてくれてありがとう。そしてマクドナルドのひどい虐待から、何百万羽ものニワトリを助けてくれてありがとう", "Ihr habt mich einmal mehr gerettet und Millionen von Hühnern vor den schlimmsten Misshandlungen durch McDonald’s USA bewahrt."],
            cutscene5_7: ["To play again as me, enter this secret code: PamvsMcCruelty.", "Om weer te kunnen spelen verander de code in: PamVsMcCruelty.", "Para jugar otra vez como yo, entra este código secreto: PamVsMcCruelty.", "Ak chceš hrať v mojom mene, vlož tento tajný kód: PamVsMcCruelty.", "もう１度「私」としてプレーするには、次のシークレット・コードを入力してください：PamVsMcCruelty. ", "Um nochmal zu spielen, gib diesen Geheim-Code ein: PamvsMcCruelty."],
            vid1: ["You\'ve earned a bonus video!", "Je hebt een bonusvideo verdiend!", "¡Has ganado un vídeo adicional!", "Získal si prémiové video.", "ボーナス･ビデオの時間です！", "Du hast Dir ein Bonus-Video verdient!"],
            vid2: ["Game Will Continue In …", "Het spel gaat verder ,,,", "Juego continuará en…", "Hra bude pokračovať o…", "ゲーム継続まで・・・", "Spiel wird fortgesetzt in …"],
            vid3: ["Continue Game", "Speel  door ", "Continuar juego", "Pokračuj v hre", "ゲーム継続", "Spiel fortsetzen"],
        };
        Gameplay.characters = ['nugget', 'chickette', 'pam'];
        Gameplay.gravity0 = 1285; // 1 - 10
        gameplay.Gameplay = Gameplay;
    })(gameplay = nscs.gameplay || (nscs.gameplay = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var input;
    (function (input) {
        class InputController {
            constructor(scene) {
                this.scene = scene;
                this.cursorKeys = this.scene.input.keyboard.createCursorKeys();
                this.cursorKeys.up.on('up', () => { this.cursorKeys.up['-used-'] = false; });
                this.cursorKeys.up['-used-'] = false;
                this.scene.input.keyboard.addCapture([Phaser.Input.Keyboard.KeyCodes.LEFT, Phaser.Input.Keyboard.KeyCodes.RIGHT, Phaser.Input.Keyboard.KeyCodes.UP, Phaser.Input.Keyboard.KeyCodes.DOWN]);
                this.escObj = scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ESC); // Get key object
                this.escObj.on('up', () => { this.escObj['-used-'] = false; });
                this.escObj['-used-'] = false;
                this.enterObj = scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ENTER); // Get key object
                this.enterObj.on('up', () => { this.enterObj['-used-'] = false; });
                this.enterObj['-used-'] = false;
            }
            upPressedDownAndReleased() {
                return this.cursorKeys.up.isDown && !this.cursorKeys.up['-used-'];
            }
            upPressUsed() {
                this.cursorKeys.up['-used-'] = true;
            }
            escPressedDownAndReleased() {
                return this.escObj.isDown && !this.escObj['-used-'];
            }
            escPressUsed() {
                this.escObj['-used-'] = true;
            }
            enterPressedDownAndReleased() {
                return this.enterObj.isDown && !this.enterObj['-used-'];
            }
            enterPressUsed() {
                this.enterObj['-used-'] = true;
            }
        }
        input.InputController = InputController;
    })(input = nscs.input || (nscs.input = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var input;
    (function (input) {
        class InputManager {
            constructor() {
                this.buttons = [];
                this.keyUpUsed = false;
                this.isDowButton = {
                    'UP': false,
                    'DOWN': false,
                    'LEFT': false,
                    'RIGHT': false
                };
            }
            static get instance() {
                return this._instance ? InputManager._instance : InputManager._instance = new InputManager();
            }
            isDown(key) {
                return this.isDowButton[key];
            }
            create(scene) {
                if (!game.device.input.touch)
                    return;
                this.scene = scene;
                this.createJoystick(38, 245);
            }
            destroy() {
                if (!game.device.input.touch)
                    return;
                for (let c of this.buttons) {
                    this.scene.children.remove(c);
                }
            }
            createJoystick(x, y) {
                const UP = 'UP', RIGHT = 'RIGHT', DOWN = 'DOWN', LEFT = 'LEFT';
                this.JOYSTICK_UP_ = new Phaser.GameObjects.Image(this.scene, 405, 0, 'arrow');
                this.JOYSTICK_UP_.angle = -90;
                this.JOYSTICK_DOWN_ = new Phaser.GameObjects.Image(this.scene, 330, 0, 'arrow');
                this.JOYSTICK_DOWN_.angle = 90;
                this.JOYSTICK_RIGHT_ = new Phaser.GameObjects.Image(this.scene, 75, 0, 'arrow');
                this.JOYSTICK_RIGHT_.angle = 0;
                this.JOYSTICK_LEFT_ = new Phaser.GameObjects.Image(this.scene, 0, 0, 'arrow');
                this.JOYSTICK_LEFT_.angle = 180;
                this.buttons = [this.JOYSTICK_UP_, this.JOYSTICK_DOWN_, this.JOYSTICK_RIGHT_, this.JOYSTICK_LEFT_];
                for (let c of this.buttons) {
                    this.scene.children.add(c);
                    c.setOrigin(0.5, 0.5);
                    c.setScale(0.7, 0.7);
                    c.alpha = 0.3;
                    c.x += x;
                    c.y += y;
                    c.setScrollFactor(0);
                    c.setInteractive();
                }
                this.JOYSTICK_UP_.on('pointerdown', () => { this.isDowButton[UP] = true; }, this);
                this.JOYSTICK_UP_.on('pointerover', () => { this.isDowButton[UP] = true; }, this);
                this.JOYSTICK_UP_.on('pointerup', () => { this.isDowButton[UP] = false; }, this);
                this.JOYSTICK_UP_.on('pointerout', () => { this.isDowButton[UP] = false; }, this);
                this.JOYSTICK_DOWN_.on('pointerdown', () => { this.isDowButton[DOWN] = true; }, this);
                this.JOYSTICK_DOWN_.on('pointerover', () => { this.isDowButton[DOWN] = true; }, this);
                this.JOYSTICK_DOWN_.on('pointerup', () => { this.isDowButton[DOWN] = false; }, this);
                this.JOYSTICK_DOWN_.on('pointerout', () => { this.isDowButton[DOWN] = false; }, this);
                this.JOYSTICK_RIGHT_.on('pointerdown', () => { this.isDowButton[RIGHT] = true; }, this);
                this.JOYSTICK_RIGHT_.on('pointerover', () => { this.isDowButton[RIGHT] = true; }, this);
                this.JOYSTICK_RIGHT_.on('pointerup', () => { this.isDowButton[RIGHT] = false; }, this);
                this.JOYSTICK_RIGHT_.on('pointerout', () => { this.isDowButton[RIGHT] = false; }, this);
                this.JOYSTICK_LEFT_.on('pointerdown', () => { this.isDowButton[LEFT] = true; }, this);
                this.JOYSTICK_LEFT_.on('pointerover', () => { this.isDowButton[LEFT] = true; }, this);
                this.JOYSTICK_LEFT_.on('pointerup', () => { this.isDowButton[LEFT] = false; }, this);
                this.JOYSTICK_LEFT_.on('pointerout', () => { this.isDowButton[LEFT] = false; }, this);
                this.keyUpUsed = false;
                this.JOYSTICK_UP_.on('pointerup', () => { this.keyUpUsed = false; }, this);
                this.JOYSTICK_UP_.on('pointerout', () => { this.keyUpUsed = false; }, this);
            }
            upPressedDownAndReleased() {
                if (!game.device.input.touch)
                    return false;
                return this.isDown('UP') && !this.keyUpUsed;
            }
            upPressUsed() {
                if (!game.device.input.touch)
                    return;
                this.keyUpUsed = true;
            }
        }
        InputManager._instance = null;
        input.InputManager = InputManager;
    })(input = nscs.input || (nscs.input = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var input;
    (function (input) {
        class InputTextField extends Phaser.GameObjects.Container {
            constructor(scene) {
                super(scene);
                this.pokemonNameDiv = null;
                this.inputTextField = null;
                this.inputTextFieldWidth = 160;
                this.inputTextFieldHeight = 30;
                this.inputTextFieldFontSize = 13;
                this.inputTextFieldPosition = { x: 0, y: 0 };
                this.adjustInput = () => {
                    let globalPos = toGlobal(this, this.inputTextFieldPosition);
                    const px = 'px';
                    let pr = 1; //this.scene.game.device.os.desktop ? 1 : Math.min(this.scene.game.device.os.pixelRatio, 3);
                    this.inputTextField.style.width = Math.ceil(this.inputTextFieldWidth / pr / this.scene.game.scale.displayScale.x) + px;
                    this.inputTextField.style.height = this.inputTextFieldHeight + px;
                    this.inputTextField.style.fontSize = this.inputTextFieldFontSize / this.scene.game.scale.displayScale.y + px;
                    let mt = parseInt(this.scene.game.canvas.style.marginTop.split(px)[0]);
                    let ml = parseInt(game.canvas.style.marginLeft.split(px)[0]);
                    this.pokemonNameDiv.style.marginTop = (mt + Math.ceil(globalPos.y / pr / this.scene.game.scale.displayScale.y) - this.inputTextFieldHeight / 2) + px;
                    this.pokemonNameDiv.style.marginLeft = (ml + Math.ceil(globalPos.x / pr / this.scene.game.scale.displayScale.x)) + px;
                };
                this.pokemonNameDiv = document.querySelector('#pamNameDiv');
                this.inputTextField = document.querySelector('#pamInputId');
            }
            initializeInput() {
                this.setInputTextFieldContainerVisible(true);
                this.adjustInput();
                this.scene.game.scale.addListener(Phaser.Scale.Events.RESIZE, this.adjustInput);
            }
            destroyInput() {
                this.setInputTextFieldContainerVisible(false);
                this.scene.game.scale.removeListener(Phaser.Scale.Events.RESIZE, this.adjustInput);
            }
            setInputTextFieldContainerVisible(visible) {
                document.querySelector('.inputContainer').style.display = visible ? 'block' : 'none';
                if (visible) {
                    this.inputTextField.focus();
                }
            }
            getText() {
                return this.inputTextField.value;
            }
            setText(text) {
                this.inputTextField.value = text;
            }
        }
        input.InputTextField = InputTextField;
    })(input = nscs.input || (nscs.input = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var scene;
    (function (scene) {
        class Boot extends Phaser.Scene {
            init() {
                new FitScaleManager(this.game).setup();
            }
            create() {
                this.input.addPointer(1);
                game.scene.remove('Boot');
                game.scene.add('Preloader', nscs.scene.Preloader, true);
            }
        }
        scene.Boot = Boot;
    })(scene = nscs.scene || (nscs.scene = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var scene;
    (function (scene) {
        class MainScene extends Phaser.Scene {
            constructor() {
                super(...arguments);
                this.subWorld = null;
                this.worldNumber = 1;
            }
            create() {
                MainScene.instance = this;
                this.inputController = new nscs.input.InputController(this);
                this.factory = new nscs.gameplay.Factory(this);
                this.currentScreensContainer = new Phaser.GameObjects.Container(this, 0, 0);
                this.children.add(this.currentScreensContainer);
                this.logo_btn = new Phaser.GameObjects.Image(this, 5, 295, 'ui-atlas', 'logo_btn' + '0000').setOrigin(0, 0);
                this.logo_btn.setInteractive({ cursor: 'pointer' });
                this.logo_btn.on('pointerup', () => {
                    window.open("https://www.kentuckyfriedcruelty.com/", '_blank');
                    this.logo_btn.setFrame('logo_btn' + '0000');
                    sendEvent(petaGA_GameCategory_Game, 'Click', 'Super Chick Sisters - KentuckyFriedCruelty Link Click');
                });
                this.logo_btn.on('pointerout', () => {
                    this.logo_btn.setFrame('logo_btn' + '0000');
                });
                this.logo_btn.on('pointerover', () => {
                    this.logo_btn.setFrame('logo_btn' + '0001');
                });
                this.soundControl_mc = new Phaser.GameObjects.Image(this, 464, 306, 'ui-atlas', 'soundControl_mc' + '0000');
                this.soundControl_mc.setInteractive({ cursor: 'pointer' });
                this.soundControl_mc.on('pointerup', () => {
                    nscs.sound.SoundManager.getInstance().mute();
                    this.soundControl_mc.setFrame(nscs.sound.SoundManager.getInstance().muted ? 'soundControl_mc' + '0009' : 'soundControl_mc' + '0000');
                    if (nscs.sound.SoundManager.getInstance().muted) {
                        sendEvent(petaGA_GameCategory_Game, 'Audio Off', 'Super Chick Sisters - Audio Off');
                    }
                    else {
                        sendEvent(petaGA_GameCategory_Game, 'Audio On', 'Super Chick Sisters - Audio On');
                    }
                });
                this.switchScreen(new nscs.screen.MainMenuScreen(this));
                this.children.add(this.soundControl_mc);
                this.children.add(this.logo_btn);
                this.updateLogoAndSndBtnVisibility();
                this.logo_btn.setScrollFactor(0);
                this.soundControl_mc.setScrollFactor(0);
                //worlds direct testing
                // this.gameplay = new nscs.gameplay.Gameplay();
                // this.startLevel('3');
            }
            resetGameplay() {
                if (this.gameplay) {
                    this.gameplay.destroy();
                }
                this.setWorldsNumber(1);
                this.gameplay = new nscs.gameplay.Gameplay();
            }
            playAsPam() {
                this.resetGameplay();
                this.gameplay.character = 'pam';
                this.startGame();
            }
            setWorldsNumber(worldNumber, subWorld = null) {
                this.worldNumber = worldNumber;
                this.subWorld = subWorld;
            }
            getWorldNumber() {
                return this.worldNumber;
            }
            playGame() {
                this.showStorySlides(() => {
                    this.startGame();
                });
            }
            startLevel(worldId) {
                this.setWorldsNumber(Math.floor(Number(worldId)));
                this.gameplay.loadWorld(worldId, true, true);
                this.gameplay.gameScreen.showNewGameNewWorldScreen();
                nscs.sound.SoundManager.getInstance().playMusic('soundtrack' + this.worldNumber, true);
            }
            startGame() {
                this.startLevel(this.subWorld != null ? this.subWorld : String(this.worldNumber));
            }
            showStorySlides(onComplete) {
                this.gameplay.destroyPreviousWorlds();
                this.switchScreen(new nscs.screen.StorySlides(this, this.worldNumber, onComplete), false, true);
            }
            proceedLevelComplete() {
                sendEvent(petaGA_GameCategory_Game, 'Win', 'Super Chick Sisters - Win World ' + this.worldNumber);
                this.setWorldsNumber(this.gameplay.getNextWorldNumber());
                if (this.worldNumber == 6) {
                    // END OF GAME
                    this.showStorySlides(() => {
                        this.switchScreen(new nscs.screen.MainMenuScreen(this) /*new nscs.screen.HigscoreScreen(this)*/);
                    });
                }
                else {
                    this.playGame();
                }
            }
            update() {
                let screens = this.currentScreensContainer.getAll();
                for (let c of screens) {
                    if (c instanceof nscs.screen.BaseScreen && this.currentScreen != c)
                        c.updateScreen();
                }
                this.currentScreen.updateScreen();
            }
            updateLogoAndSndBtnVisibility() {
                this.logo_btn.visible = (this.currentScreen instanceof nscs.screen.MainMenuScreen
                    ||
                        this.currentScreen instanceof nscs.screen.InGameUI
                    ||
                        this.currentScreen instanceof nscs.screen.GameScreen);
                this.logo_btn.alpha = this.currentScreen instanceof nscs.screen.GameScreen ? 0.6 : 1;
            }
            switchScreen(newScreen, useTransition = false, destroyOld = true, onMidCallback = null) {
                if (this.currentScreen) {
                    let prevScreen = this.currentScreen;
                    this.currentScreen = newScreen;
                    prevScreen.switchScreen(newScreen, useTransition, destroyOld, () => {
                        if (onMidCallback)
                            onMidCallback();
                        this.updateLogoAndSndBtnVisibility();
                    });
                }
                else {
                    this.currentScreensContainer.add(newScreen);
                    this.currentScreen = newScreen;
                    this.updateLogoAndSndBtnVisibility();
                }
            }
        }
        MainScene.instance = null;
        scene.MainScene = MainScene;
    })(scene = nscs.scene || (nscs.scene = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var scene;
    (function (scene) {
        class Preloader extends Phaser.Scene {
            preload() {
                this.load.atlas(nscs.screen.Preloader.ATLAS, 'assets/imgs/atlas/' + nscs.screen.Preloader.ATLAS + '.png', 'assets/imgs/atlas/' + nscs.screen.Preloader.ATLAS + '.json');
            }
            create() {
                let p = new nscs.screen.Preloader(this);
                this.children.add(p);
                this.load.json('data', 'assets/json/data.json');
                this.load.pack('preloader', 'assets/pack.json');
                this.load.on('progress', (value) => {
                    p.updateProgress(value);
                }, this);
                this.load.on('complete', () => {
                    this.nextScene();
                });
                this.load.start();
            }
            nextScene() {
                game.scene.remove('Preloader');
                game.scene.add('MainScene', nscs.scene.MainScene, true);
            }
        }
        scene.Preloader = Preloader;
    })(scene = nscs.scene || (nscs.scene = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class BaseScreen extends Phaser.GameObjects.Container {
            constructor(scene) {
                super(scene);
                if (!(this instanceof screen.GameScreen))
                    this.setScrollFactor(0);
            }
            createBlackShape() {
                return this.createShape('0x000000');
            }
            createShape(color) {
                let transition = new Phaser.GameObjects.Graphics(this.scene);
                transition.setPosition(0, 0);
                transition.fillStyle(color, 1);
                transition.fillRect(0, 0, game.scale.width, game.scale.height);
                transition.setInteractive();
                transition.setScrollFactor(0);
                return transition;
            }
            switchScreen(newScreen, useTransition, destroyOld, onMidCallback) {
                let f = () => {
                    // if (!destroyOld) {
                    if (this instanceof screen.GameScreen) {
                        this.onRemovedFromParent();
                    }
                    // }
                    if (newScreen instanceof screen.GameScreen) {
                        newScreen.onAddedToParent();
                    }
                };
                let parentContainer = this.parentContainer;
                if (useTransition) {
                    if (destroyOld) {
                        this.scene.tweens.killAll();
                        nscs.util.Functions.destroyAllDelayedCalls();
                        // this.scene.time.removeAllEvents();
                    }
                    let transition = this.createBlackShape();
                    this.parentContainer.add(transition);
                    transition.alpha = 0;
                    this.scene.tweens.add({
                        targets: transition,
                        alpha: 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Linear,
                        onComplete: () => {
                            this.scene.tweens.add({
                                targets: transition,
                                alpha: 0,
                                duration: 500,
                                ease: Phaser.Math.Easing.Linear,
                                onComplete: () => {
                                    parentContainer.remove(transition, true);
                                }
                            });
                            f();
                            parentContainer.remove(this, destroyOld);
                            parentContainer.addAt(newScreen, parentContainer.getIndex(transition));
                            if (onMidCallback)
                                onMidCallback();
                        }
                    });
                }
                else {
                    f();
                    parentContainer.remove(this, destroyOld);
                    parentContainer.add(newScreen);
                    if (onMidCallback)
                        onMidCallback();
                }
            }
            updateScreen() {
            }
        }
        screen.BaseScreen = BaseScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class ChooseCharacterScreen extends screen.BaseScreen {
            constructor(scene) {
                super(scene);
                let bg = new Phaser.GameObjects.Graphics(this.scene);
                bg.setPosition(0, 0);
                bg.fillStyle(0x36ACBE, 1);
                bg.fillRect(0, 0, game.scale.width, game.scale.height);
                this.add(bg);
                this.add(new Phaser.GameObjects.Image(this.scene, 54 - 10, 91 - 15, 'ui-atlas', 'circ' + '0000').setOrigin(0, 0));
                this.add(new Phaser.GameObjects.Image(this.scene, 175 - 10, 129 - 15, 'ui-atlas', 'circ' + '0000').setOrigin(0, 0));
                this.add(new Phaser.GameObjects.Image(this.scene, 299 - 10, 91 - 15, 'ui-atlas', 'circ' + '0000').setOrigin(0, 0));
                let positions = [
                    { x: 54 - 3, y: 91 - 15 }, { x: 175 - 3, y: 129 - 15 }, { x: 299 - 3, y: 91 - 15 }
                ];
                let i = 0;
                for (let p of positions) {
                    let btn = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'ui-atlas', 'nugget_btn' + '0000').setOrigin(0, 0);
                    this.add(btn);
                    let character = nscs.gameplay.Gameplay.characters[i];
                    i++;
                    btn.setInteractive({ cursor: 'pointer' });
                    btn.on('pointerup', () => {
                        if (nscs.gameplay.Gameplay.isPamLocked && character == "pam")
                            return;
                        btn.setFrame('nugget_btn' + '0000');
                        // nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                        nscs.scene.MainScene.instance.gameplay.character = character;
                        nscs.scene.MainScene.instance.playGame();
                        if (character == 'nugget') {
                            sendEvent(petaGA_GameCategory_Game, 'Character Selection', 'Super Chick Sisters - Character Nugget');
                        }
                        else if (character == 'chickette') {
                            sendEvent(petaGA_GameCategory_Game, 'Character Selection', 'Super Chick Sisters - Character Chickette');
                        }
                    });
                    btn.on('pointerover', () => {
                        nscs.sound.SoundManager.getInstance().playSound('whistleSND', 2);
                        btn.setFrame('nugget_btn' + '0001');
                    });
                    btn.on('pointerout', () => {
                        btn.setFrame('nugget_btn' + '0000');
                    });
                }
                this.add(new Phaser.GameObjects.Image(this.scene, 54 - 10 + 75, 91 - 15 + 55, 'ui-atlas', 'ANI_Nugget_wholeMC' + '0000').setOrigin(0.5, 0.5).setScale(-1, 1));
                this.add(new Phaser.GameObjects.Image(this.scene, 175 - 10 + 80, 129 - 15 + 35, 'ui-atlas', 'ANI_Chickette_wholeMC' + '0000').setOrigin(0.5, 0.5).setScale(-1, 1));
                this.add(new Phaser.GameObjects.Image(this.scene, 175 + 200, 129 - 25, 'ui-atlas', 'pam_sel' + '0000').setOrigin(0.5, 0.5).setScale(-1, 1));
                this.add(new Phaser.GameObjects.Image(this.scene, 259, 87, 'ui-atlas', 'pic_c' + '0000').setOrigin(0.5, 0.5));
                this.add(new Phaser.GameObjects.Image(this.scene, 130, 82, 'ui-atlas', 'pic_n' + '0000').setOrigin(0.5, 0.5));
                this.locked_image = new Phaser.GameObjects.Image(this.scene, 165 + 200, 150, 'ui-atlas', 'pamlocked_btn' + '0000').setOrigin(0.5, 0.5);
                this.add(this.locked_image);
                this.locked_label = this.scene.add.text(162 + 200, 160, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 24,
                    "color": "#006699",
                    "align": 'left'
                });
                this.locked_label.angle = -15;
                this.locked_label.setOrigin(0.5, 0.5);
                this.add(this.locked_label);
                nscs.gameplay.Gameplay.setText(this.locked_label, 'Locked');
                this.add(screen.MainMenuScreen.createEye(120, 120, this.scene));
                this.add(screen.MainMenuScreen.createEye(150, 117, this.scene));
                this.add(screen.MainMenuScreen.createEye(240, 133, this.scene, 2000));
                this.add(screen.MainMenuScreen.createEye(270, 130, this.scene, 2000));
                let pam_mc_eye = scene.add.sprite(358, 80, 'ui-atlas');
                let pam_mc_eye_anim = 'pam_mc_eye_anim';
                if (!scene.anims.exists(pam_mc_eye_anim)) {
                    scene.anims.create({
                        key: pam_mc_eye_anim,
                        frames: scene.anims.generateFrameNames('ui-atlas', {
                            start: 0, end: 337, zeroPad: 4,
                            prefix: 'pam_mc_eye', suffix: ''
                        }),
                        frameRate: 60,
                        repeat: -1
                    });
                }
                pam_mc_eye.play(pam_mc_eye_anim);
                pam_mc_eye.setScale(-1, 1);
                this.add(pam_mc_eye);
                let character0_label = this.scene.add.text(54 - 10 + 65, 91 - 15 + 170, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 14,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                character0_label.setOrigin(0.5, 0.5);
                this.add(character0_label);
                nscs.gameplay.Gameplay.setText(character0_label, 'Nugget');
                let character1_label = this.scene.add.text(175 - 10 + 65, 129 - 15 + 170, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 14,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                character1_label.setOrigin(0.5, 0.5);
                this.add(character1_label);
                nscs.gameplay.Gameplay.setText(character1_label, 'Chickette');
                let character2_label = this.scene.add.text(299 - 10 + 80, 91 - 15 + 175, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 14,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                character2_label.setOrigin(0.5, 0.5);
                character2_label.setWordWrapWidth(100);
                this.add(character2_label);
                nscs.gameplay.Gameplay.setText(character2_label, 'PamLong');
                let ChooseChar3_label = this.scene.add.text(30, 30, "Select your character!".toUpperCase(), {
                    "fontFamily": "ArcadeClassic",
                    "fontSize": 26,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                ChooseChar3_label.setOrigin(0, 0.5);
                this.add(ChooseChar3_label);
                this.setPamLocked(nscs.gameplay.Gameplay.isPamLocked);
            }
            setPamLocked(locked) {
                this.locked_image.visible = this.locked_label.visible = locked;
            }
            updateScreen() {
                super.updateScreen();
                if (nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased()) {
                    nscs.scene.MainScene.instance.inputController.escPressUsed();
                    nscs.scene.MainScene.instance.switchScreen(new screen.MainMenuScreen(this.scene));
                }
            }
        }
        screen.ChooseCharacterScreen = ChooseCharacterScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class GameOverScreen extends screen.BaseScreen {
            constructor(scene) {
                super(scene);
                this.add(new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'gameoverbg0000').setOrigin(0));
                this.txt = this.scene.add.text(game.scale.width / 2 - 75, -100, "", {
                    "fontFamily": "ArcadeClassic",
                    "fontSize": 32,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                this.txt.setShadow(4, 4, '#000000', 4, true);
                this.txt.setOrigin(0.5, 0.5);
                this.add(this.txt);
                this.txt.setWordWrapWidth(300);
                nscs.gameplay.Gameplay.setText(this.txt, 'GameOver');
                this.fg = new Phaser.GameObjects.Graphics(this.scene);
                this.fg.setPosition(0, 0);
                this.fg.fillStyle(0x000000, 1);
                this.fg.fillRect(0, 0, game.scale.width, game.scale.height);
                this.add(this.fg);
                this.scene.tweens.add({
                    targets: this.fg,
                    alpha: 0,
                    duration: 500,
                    onComplete: () => {
                        this.remove(this.fg);
                        this.scene.tweens.add({
                            targets: this.txt,
                            y: game.scale.height / 2,
                            duration: 500,
                            ease: Phaser.Math.Easing.Back.Out
                        });
                        nscs.util.Functions.delayedCall(3000, () => {
                            nscs.scene.MainScene.instance.switchScreen(new nscs.screen.MainMenuScreen(this.scene));
                        });
                    }
                });
            }
        }
        screen.GameOverScreen = GameOverScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class GameScreen extends screen.BaseScreen {
            constructor(scene, worldIdName) {
                super(scene);
                this.activeBubbles = [];
                this.tofuMCs = [];
                this.seakittens = [];
                this.recentEnemyKillsNumber = 0;
                this.recentEnemyKillsNumberDelayedCall = null;
                this.enemy4MCArray = [];
                this.shceduleGravitySwitching = false;
                this.isPipeTravelingActive = false;
                this.reusedArray = [];
                this.boss = null;
                this.onRonaldKilled = () => {
                    if (!this.finishFlag)
                        return;
                    this.finishFlag.visible = true;
                    nscs.scene.MainScene.instance.factory.playAnimation(this.finishFlag, "boss-flag-appear");
                    nscs.sound.SoundManager.getInstance().playSound('flagGrowSND');
                };
                this.onBossAttacksPlayer = () => {
                    this.onEnemyOrHazzardContacted();
                };
                this.isFlagReached = false;
                this.finishFlag = null;
                this.ticker = 0;
                this.isPaused = false;
                this.gameplay = nscs.scene.MainScene.instance.gameplay;
                this.worldIdName = worldIdName;
                this.synchronizeGravity();
                this.inGameUI = new screen.InGameUI(this.scene);
                this.inGameUI.setScrollFactor(0);
                // set background
                this.bg = new Phaser.GameObjects.Container(this.scene, 0, 0);
                this.add(this.bg);
                for (var i = 0; i < 2; i++) {
                    let img = new Phaser.GameObjects.Image(this.scene, i * (730 - 1), 0, "bg-atlas", this.gameplay.levelData['bg'] + '0000').setOrigin(0, 0);
                    this.bg.add(img);
                }
                this.bg.setScrollFactor(0);
                //tiles
                this.repaintGrid();
                this.spritesBackLayer = this.scene.add.container(0, 0);
                this.add(this.spritesBackLayer);
                this.player = new nscs.character.Player();
                this.player.setWorldPosition(this.gameplay.newX, this.gameplay.newY);
                this.add(this.player.sprite);
                this.playerToGridCollider = this.scene.physics.add.collider(this.gridRender.getAll(), this.player.sprite, (o1, o2) => {
                    this.onContactWithStaticObject(o1 == this.player.sprite ? o2 : o1);
                });
                this.spritesTopLayer = this.scene.add.container(0, 0);
                this.add(this.spritesTopLayer);
                this.add(this.inGameUI);
                this.inGameUI.setScrollFactor(0);
                this.inGameUI.pauseScreen.onResume = () => {
                    this.setPaused(false);
                };
                this.inGameUI.pauseScreen.onQuit = () => {
                    this.gameplay.destroyTimer();
                    nscs.scene.MainScene.instance.switchScreen(new nscs.screen.MainMenuScreen(this.scene) /*new nscs.screen.HigscoreScreen(this.scene)*/, false);
                    nscs.sound.SoundManager.getInstance().stopMusic();
                };
                this.startFollowCamera();
                nscs.input.InputManager.instance.create(this.scene);
                window["printPlayerPos"] = () => { console.log(Math.round(this.player.sprite.x), Math.round(this.player.sprite.y)); };
            }
            startFollowCamera() {
                // set bounds so the camera won't go outside the game world
                this.scene.cameras.main.setBounds(0, 0, this.gameplay.worldWidth, this.gameplay.worldHeight);
                // make the camera follow the player
                this.scene.cameras.main.startFollow(this.player.sprite, true, 0.75, 0.75, 0, -40);
                this.scene.cameras.main.setRoundPixels(true);
            }
            stopFollowCamera() {
                // make the camera follow the player
                this.scene.cameras.main.stopFollow();
            }
            onSpritesAdded() {
                if (this.finishFlag) {
                    this.finishFlag.visible = this.boss ? false : true;
                }
                let gridSprites = this.gridRender.getAll();
                let sprites = this.getAllSprites();
                for (let s of sprites) {
                    if (this.isSpriteGravityAllowed(s)) {
                        if (s.body) {
                            s.body["setAllowGravity"](true);
                            s.setCollideWorldBounds(true);
                            this.scene.physics.add.collider(gridSprites, s);
                            for (let b of sprites) {
                                if (b["spriteType"] == 'B') {
                                    this.scene.physics.add.collider(b, s);
                                }
                            }
                        }
                    }
                }
            }
            addSprite(sprite) {
                if (sprite["libId"] == "boss2MC") {
                    this.boss = sprite;
                    this.boss.setup(this.player, 400, 1330, 1190, 1300, 1320, 1150, this.onRonaldKilled, this.onBossAttacksPlayer);
                    this.addAt(this.boss, this.getIndex(this.player.sprite));
                    return;
                }
                else if (sprite["libId"] == "flagPoleMC") {
                    this.finishFlag = sprite;
                    this.finishFlag["flagPoleMC"].body.checkCollision.up = this.finishFlag["flagPoleMC"].body.checkCollision.down = false;
                    this.addAt(this.finishFlag, this.getIndex(this.gridRender) + 1);
                    return;
                }
                let topLayerSprites = [
                    // 'decor84MC', 'decor83MC', 'decor82MC', 'decor81MC', 'decor79MC', 'decor78MC', 'decor80MC', 'decor113MC', 'decor77MC',
                    // 'decor76MC', 'decor13MC', 'decor12MC', 'decor15MC', 'decor17MC', 'decor16MC', 'decor100MC', 'decor69MC', 'decor68MC',
                    // 'decor18MC', 'decor14MC', 'decor19MC', 'decor10MC', 'decor26MC', 'decor92MC', 'decor91MC',
                    'decor61MC', 'decor10MC', 'decor26MC', 'decor60MC', 'decor11MC', 'decor27MC',
                    'decor18MC', 'decor16MC', 'decor19MC', 'decor17MC', 'decor15MC', 'decor14MC', 'decor12MC', 'decor13MC', 'decor44MC'
                ];
                if (topLayerSprites.indexOf(sprite["libId"]) >= 0) {
                    this.spritesTopLayer.add(sprite);
                }
                else {
                    this.spritesBackLayer.add(sprite);
                }
            }
            showBubbles(x, y, minNum, maxNum, direction, dBase, lifeDistance, duration, onComplete) {
                let num = minNum + Math.round(Math.random() * Math.floor(maxNum - minNum));
                for (let i = 0; i < num; i++) {
                    let fromX = x, fromY = y;
                    if (direction == "left" || direction == "right") {
                        fromY += (Math.random() - 0.5) * dBase;
                    }
                    else if (direction == "up" || direction == "down") {
                        fromX += (Math.random() - 0.5) * dBase;
                    }
                    let toX = fromX, toY = fromY;
                    if (direction == "left") {
                        toX -= lifeDistance;
                    }
                    else if (direction == "right") {
                        toX += lifeDistance;
                    }
                    else if (direction == "up") {
                        toY -= lifeDistance;
                    }
                    else if (direction == "down") {
                        toY += lifeDistance;
                    }
                    let bubble = new Phaser.GameObjects.Image(this.scene, fromX, fromY, 'objects-atlas', 'whiteBubbleMC' + '0000');
                    bubble.setOrigin(0.5, 0.5);
                    bubble.setScale(0.75 + Math.random() * 0.25);
                    bubble['-onLifeEndCallback-'] = () => {
                        if (onComplete)
                            onComplete();
                        if (bubble.parentContainer)
                            bubble.parentContainer.remove(bubble);
                    };
                    this.scene.tweens.add({
                        targets: bubble,
                        x: toX,
                        y: toY,
                        scale: 0,
                        alpha: 0.5,
                        duration: duration,
                        ease: Phaser.Math.Easing.Sine.Out,
                        onComplete: bubble['-onLifeEndCallback-'],
                        onStart: () => {
                            bubble.visible = true;
                            this.activeBubbles.push(bubble);
                        },
                        delay: i * 50 + Math.random() * 100
                    });
                    bubble.visible = false;
                    this.addAt(bubble, this.getIndex(this.spritesBackLayer) - 1);
                }
            }
            destroyBubble(b) {
                let ind = this.activeBubbles.indexOf(b);
                if (ind >= 0)
                    this.activeBubbles.splice(ind, 1);
                this.scene.tweens.killTweensOf(b);
                b['-onLifeEndCallback-']();
            }
            showTextPopUp(content) {
                let txt = this.scene.add.text(this.player.sprite.x, this.player.sprite.y, "", {
                    "fontFamily": "AxaxaxRg-Bold",
                    "fontSize": 12,
                    "color": "#FFFFFF",
                    "align": 'center'
                }).setOrigin(0.5, 0.5);
                txt.setStroke('#000000', 2);
                this.add(txt);
                nscs.util.Functions.updateTextFieldPosition(txt, content);
                this.scene.tweens.add({
                    targets: txt,
                    y: txt.y - 75,
                    duration: 1000,
                    onComplete: () => {
                        if (txt.parentContainer)
                            txt.parentContainer.remove(txt);
                    }
                });
                if (content == '1UP') {
                    nscs.sound.SoundManager.getInstance().playSound('1upSND');
                }
            }
            scoreUp(number) {
                this.showTextPopUp(String(number));
            }
            showPickUpHeart(x, y) {
                let heart = new Phaser.GameObjects.Sprite(this.scene, x, y, 'objects-atlas', 'OneUpXMC' + '0000');
                this.scene.tweens.add({
                    targets: heart,
                    y: heart.y - 60,
                    alpha: 0,
                    duration: 1500,
                    ease: Phaser.Math.Easing.Sine.Out,
                    onComplete: () => {
                        if (heart.parentContainer)
                            heart.parentContainer.remove(heart);
                    }
                });
                this.addAt(heart, this.getIndex(this.spritesBackLayer) + 1);
            }
            showPickUpChick(chick, scaleX, x, y) {
                if (!chick) {
                    chick = nscs.scene.MainScene.instance.factory.createConstructedObject("tinyChickMC");
                    chick.setPosition(x, y);
                    chick.scaleX = scaleX;
                }
                this.scene.tweens.add({
                    targets: chick,
                    x: chick.x + (chick.scaleX > 0 ? 1 : -1) * (Math.random() * 35 + 40),
                    y: chick.y - 200 - Math.random() * 20,
                    duration: 2500 + Math.random() * 750,
                    ease: Phaser.Math.Easing.Sine.Out,
                    onComplete: () => {
                        if (chick.parentContainer)
                            chick.parentContainer.remove(chick);
                    }
                });
                this.scene.tweens.add({
                    targets: chick,
                    delay: 1000,
                    duration: 500,
                    alpha: 0
                });
                this.addAt(chick, this.getIndex(this.spritesBackLayer) + 1);
            }
            repaintGrid() {
                this.ladderArray = [];
                this.gridRender = this.scene.add.container(0, 0);
                this.add(this.gridRender);
                this.gridRenderView = this.scene.add.container(0, 0);
                this.add(this.gridRenderView);
                let noPhysics = [
                    [0, 0], [6, 0], [7, 0], [8, 0], [14, 0],
                    [13, 1],
                    [6, 2], [7, 2], [8, 2], [9, 2], [10, 2], [11, 2], [12, 2], [13, 2],
                    [3, 3], [4, 3], [5, 3], [6, 3], [7, 3], [8, 3],
                    [3, 4], [4, 4], [5, 4], [6, 4],
                    [7, 5], [8, 5], [9, 5],
                    [0, 6], [1, 6], [2, 6], [3, 6], [4, 6], [5, 6], [6, 6], [7, 6], [8, 6], [9, 6], [10, 6], [11, 6], [14, 6],
                    [0, 7], [1, 7], [2, 7], [3, 7], [4, 7], [5, 7], [6, 7], [7, 7], [8, 7], [9, 7],
                    [14, 8],
                    [13, 10], [14, 10],
                    [0, 11], [1, 11], [7, 11], [13, 11], [14, 11],
                    [0, 12], [1, 12], [2, 12], [6, 12], [7, 12], [8, 12], [9, 12], [10, 12], [11, 12], [12, 12], [13, 12], [14, 12],
                    [0, 13], [1, 13], [2, 13], [3, 13], [7, 13], [12, 13], [13, 13], [14, 13],
                    [0, 14], [1, 14], [2, 14], [11, 14], [12, 14], [13, 14], [14, 14]
                ];
                let _grid = [];
                const n = 16;
                for (var i = 0; i < this.gameplay.worldTilesY; i++) {
                    let _row = new Array(this.gameplay.worldTilesX);
                    for (let _i = 0; _i < this.gameplay.worldTilesY; _i++)
                        _row[_i] = 0;
                    _grid.push(_row);
                    for (var j = 0; j < this.gameplay.worldTilesX; j++) {
                        if (this.gameplay.grid[i][j] > 0) {
                            var srcx = this.gameplay.grid[i][j] % n;
                            var srcy = Math.floor(this.gameplay.grid[i][j] / n);
                            let cdw = 0;
                            let cdh = 0;
                            // if (srcx == 10 && srcy == 0) cdw = -1;
                            // else if (srcx== 11&&srcy==2 || srcx== 12&&srcy==2 || srcx== 13&&srcy==2) cdh = -1;
                            if (Number(this.gameplay.ladder_array[this.gameplay.grid[i][j]]) == 1) {
                                let ladder_tile = this.scene.physics.add.sprite(j * this.gameplay.tileWidth, i * this.gameplay.tileHeight, 'texture');
                                ladder_tile.setOrigin(srcx / (n - 1), srcy / (n - 1));
                                ladder_tile.setCrop(srcx * this.gameplay.tileWidth, srcy * this.gameplay.tileHeight, this.gameplay.tileWidth + cdw, this.gameplay.tileHeight + cdh);
                                ladder_tile.setCollideWorldBounds(false);
                                ladder_tile.body.setSize(this.gameplay.tileWidth, this.gameplay.tileHeight);
                                ladder_tile.setImmovable(true);
                                ladder_tile.body["setAllowGravity"](false);
                                ladder_tile.body.setOffset(srcx / (n - 1) * ladder_tile.width, srcy / (n - 1) * ladder_tile.height);
                                this.ladderArray.push(ladder_tile);
                                this.add(ladder_tile);
                                ladder_tile["-grid-i-"] = i;
                                ladder_tile["-grid-j-"] = j;
                                ladder_tile["-srcx-"] = srcx;
                                ladder_tile["-srcy-"] = srcy;
                            }
                            else {
                                let hasNoPhysics = false;
                                for (let np of noPhysics)
                                    if (srcx == np[0] && srcy == np[1]) {
                                        hasNoPhysics = true;
                                        break;
                                    }
                                if (!hasNoPhysics) {
                                    _row[j] = 1;
                                }
                                let tile = this.scene.add.sprite(j * this.gameplay.tileWidth, i * this.gameplay.tileHeight, 'texture');
                                tile.setOrigin(srcx / (n - 1), srcy / (n - 1));
                                tile.setCrop(srcx * this.gameplay.tileWidth, srcy * this.gameplay.tileHeight, this.gameplay.tileWidth + cdw, this.gameplay.tileHeight + cdh);
                                this.gridRenderView.add(tile);
                            }
                        }
                    }
                }
                this.createGridRenderPhysics(_grid);
            }
            isTileInBlockRects(i, j, rects) {
                for (let r of rects) {
                    if (i >= r["i"] && j >= r["j"] && i < r["i"] + r["h"] && j < r["j"] + r["w"]) {
                        return true;
                    }
                }
                return false;
            }
            createGridRenderPhysics(_grid) {
                let rects = [];
                for (let i = 0; i < _grid.length; i++) {
                    label_1: for (let j = 0; j < _grid[i].length; j++) {
                        let w = 0;
                        let h = 0;
                        if (_grid[i][j] == 1) {
                            if (this.isTileInBlockRects(i, j, rects)) {
                                continue label_1;
                            }
                            w = 1;
                            h = 1;
                            for (let k = i + 1; k < _grid.length; k++) {
                                if (this.isTileInBlockRects(k, j, rects)) {
                                    break;
                                }
                                if (_grid[k][j] != 1)
                                    break;
                                else
                                    h++;
                            }
                            label: for (let l = j + 1; l < _grid[i].length; l++) {
                                for (let k = i; k < i + h; k++) {
                                    if (this.isTileInBlockRects(k, l, rects)) {
                                        break label;
                                    }
                                    if (_grid[k][l] != 1)
                                        break label;
                                }
                                w++;
                            }
                            rects.push({
                                "i": i, "j": j, "w": w, "h": h
                            });
                        }
                    }
                }
                for (let r of rects) {
                    let tile = this.scene.physics.add.sprite(r["j"] * this.gameplay.tileWidth + (r["w"] - 1) * this.gameplay.tileWidth / 2, r["i"] * this.gameplay.tileHeight + (r["h"] - 1) * this.gameplay.tileHeight / 2, null);
                    tile.setCollideWorldBounds(false);
                    tile.setOrigin(0);
                    tile.visible = false;
                    tile.body.setSize(r["w"] * this.gameplay.tileWidth, r["h"] * this.gameplay.tileHeight);
                    tile.setImmovable(true);
                    tile.body["setAllowGravity"](false);
                    this.gridRender.add(tile);
                }
            }
            updateBlock(sprite_mc) {
                this.scene.physics.world.collide(this.player.sprite, sprite_mc, () => {
                    this.onContactWithStaticObject(sprite_mc);
                    if (sprite_mc["displayType"] && sprite_mc["displayType"].toLowerCase().indexOf("solid") >= 0)
                        return;
                    //------------------------------------
                    let crash = () => {
                        let bblock1BreakMC = this.scene.add.sprite(sprite_mc.x, sprite_mc.y, 'objects-atlas', 'bblock1BreakMC' + '0000');
                        bblock1BreakMC.setOrigin(0.5, 1);
                        this.addAt(bblock1BreakMC, this.getIndex(this.spritesBackLayer) + 1);
                        let anim = 'bblock1BreakMC' + "_" + "playingAnimName";
                        if (!this.scene.anims.exists(anim)) {
                            this.scene.anims.create({
                                key: anim,
                                frames: this.scene.anims.generateFrameNames(bblock1BreakMC.texture.key, {
                                    start: 0, end: 11, zeroPad: 4,
                                    prefix: 'bblock1BreakMC', suffix: ''
                                }),
                                frameRate: 60
                            });
                        }
                        bblock1BreakMC.anims.play(anim);
                        bblock1BreakMC.once('animationcomplete', () => { if (bblock1BreakMC.parentContainer)
                            bblock1BreakMC.parentContainer.remove(bblock1BreakMC); });
                        nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, sprite_mc["displayType"] = 'makeSolid');
                        if (sprite_mc.parentContainer)
                            sprite_mc.parentContainer.remove(sprite_mc);
                        nscs.sound.SoundManager.getInstance().playSound('breakBlockSND');
                    };
                    //------------------------------------
                    if (this.gameplay.isGravityFlipped() ?
                        ((this.player.sprite.body.touching.down && sprite_mc.body.touching.up)
                            ||
                                (this.player.sprite.body.touching.up && sprite_mc.body.touching.down && this.player.pounceLanding)) :
                        ((this.player.sprite.body.touching.up && sprite_mc.body.touching.down)
                            ||
                                (this.player.sprite.body.touching.down && sprite_mc.body.touching.up && this.player.pounceLanding))) {
                        if (sprite_mc["displayType"] == "question" || sprite_mc["displayType"] == "masked") {
                            //------------------------------------
                            if (sprite_mc["playLabel"] == "chick") {
                                nscs.scene.MainScene.instance.gameplay.addChick();
                                this.showPickUpChick(null, Math.random() > 0.5 ? 1 : -1, sprite_mc.x, sprite_mc.y);
                            }
                            else if (sprite_mc["playLabel"] == "tofu" || (sprite_mc["playLabel"] == "1up" && (!isNaN(sprite_mc["points"])) && sprite_mc["points"] != 0)) {
                                this.createTofuMC(sprite_mc.x, sprite_mc.y - 15, sprite_mc["playLabel"]);
                            }
                            else if (sprite_mc["playLabel"] == "1up") {
                                this.gameplay.addLife();
                                this.showPickUpHeart(sprite_mc.x, sprite_mc.y - 20);
                            }
                            else if (sprite_mc["playLabel"] == "seakitten") {
                                this.createSeakitten(sprite_mc.x, sprite_mc.y - 20);
                            }
                            //------------------------------------
                            if (!isNaN(sprite_mc["points"]) && sprite_mc["points"] > 0) {
                                this.gameplay.scoreUp(sprite_mc["points"]);
                            }
                            //------------------------------------
                            sprite_mc["hitsLeft"]--;
                            if (sprite_mc["hitsLeft"] <= 0) {
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, sprite_mc["displayType"] = 'makeSolid');
                            }
                            else {
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'question-wobble');
                                nscs.sound.SoundManager.getInstance().playSound('bumpSND');
                            }
                        }
                        else if (typeof sprite_mc["displayType"] === "undefined") {
                            if (this.gameplay.charSize == "small") {
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'wobble');
                                nscs.sound.SoundManager.getInstance().playSound('bumpSND');
                            }
                            else if (this.gameplay.charSize == "big") {
                                // this.player.sprite.setVelocityY(0);
                                crash();
                            }
                        }
                        else if (sprite_mc["displayType"] === "hidden") {
                            if (sprite_mc["hitsLeft"] == 0) {
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, sprite_mc["displayType"] = 'hiddenToSolid');
                            }
                            else {
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, sprite_mc["displayType"] = 'question');
                            }
                        }
                        // console.log(sprite_mc["hitsLeft"],sprite_mc["playLabel"],sprite_mc["points"], sprite_mc["displayType"])
                    }
                });
            }
            createTofuMC(x, y, playLabel) {
                let tofuMC = this.scene.physics.add.sprite(x, y, 'objects-atlas', 'tofuMC' + '0000');
                tofuMC.setOrigin(0, 1);
                tofuMC.setCollideWorldBounds(false);
                tofuMC.setImmovable(true);
                tofuMC.body["setAllowGravity"](false);
                tofuMC.alpha = 0;
                tofuMC.scaleY = 0;
                this.scene.tweens.add({
                    targets: tofuMC,
                    duration: 500,
                    alpha: 1,
                    scaleY: 1,
                    onComplete: () => {
                        tofuMC['-activated-'] = true;
                    }
                });
                tofuMC["playLabel"] = playLabel;
                this.addAt(tofuMC, this.getIndex(this.spritesBackLayer) + 1);
                this.tofuMCs.push(tofuMC);
                nscs.sound.SoundManager.getInstance().playSound('tofuSND');
            }
            createSeakitten(x, y) {
                let seakitten = this.scene.physics.add.sprite(x, y, 'objects-atlas', 'skMC' + '0000');
                seakitten.setOrigin(0, 1);
                seakitten.setCollideWorldBounds(false);
                seakitten.setImmovable(true);
                seakitten.body["setAllowGravity"](false);
                seakitten.alpha = 0;
                seakitten.scaleY = 0;
                this.scene.tweens.add({
                    targets: seakitten,
                    duration: 500,
                    alpha: 1,
                    scaleY: 1,
                    onComplete: () => {
                        seakitten['-activated-'] = true;
                    }
                });
                this.addAt(seakitten, this.getIndex(this.spritesBackLayer) + 1);
                this.seakittens.push(seakitten);
                nscs.sound.SoundManager.getInstance().playSound('seaKittenSND');
            }
            updateTofu() {
                for (let i = this.tofuMCs.length - 1; i >= 0; i--) {
                    let tofuMC = this.tofuMCs[i];
                    if (!tofuMC['-activated-'])
                        continue;
                    this.scene.physics.world.overlap(this.player.sprite, tofuMC, () => {
                        if (tofuMC["playLabel"] == "1up") {
                            this.gameplay.addLife();
                        }
                        else {
                            this.gameplay.scoreUp(1000);
                            this.player.setCharSize("big");
                            nscs.sound.SoundManager.getInstance().playSound('growBigSND');
                        }
                        this.scene.tweens.add({
                            targets: tofuMC,
                            duration: 500,
                            alpha: 0,
                            scaleY: 0,
                            onComplete: () => {
                                if (tofuMC.parentContiner)
                                    tofuMC.parentContiner.remove(tofuMC);
                            }
                        });
                        this.tofuMCs.splice(i, 1);
                    });
                }
            }
            updateSeakitten() {
                for (let i = this.seakittens.length - 1; i >= 0; i--) {
                    let seakitten = this.seakittens[i];
                    if (!seakitten['-activated-'])
                        continue;
                    this.scene.physics.world.overlap(this.player.sprite, seakitten, () => {
                        this.gameplay.scoreUp(1000);
                        this.player.setCharSize("big");
                        this.player.setSeaKittenise(true);
                        nscs.sound.SoundManager.getInstance().playSound('growBigSND');
                        this.scene.tweens.add({
                            targets: seakitten,
                            duration: 500,
                            alpha: 0,
                            scaleY: 0,
                            onComplete: () => {
                                if (seakitten.parentContiner)
                                    seakitten.parentContiner.remove(seakitten);
                            }
                        });
                        this.seakittens.splice(i, 1);
                    });
                }
            }
            updateChick(sprite_mc) {
                this.scene.physics.world.overlap(this.player.sprite, sprite_mc, () => {
                    nscs.scene.MainScene.instance.gameplay.addChick();
                    if (sprite_mc.parentContainer)
                        sprite_mc.parentContainer.remove(sprite_mc);
                    this.showPickUpChick(sprite_mc);
                    nscs.sound.SoundManager.getInstance().playSound('coinSND');
                });
            }
            onEnemyOrHazzardContacted() {
                if (this.player.fullyActive()) {
                    if (this.gameplay.charSize == "big") {
                        this.player.setCharSize("small");
                        nscs.sound.SoundManager.getInstance().playSound('shrinkSND');
                        this.player.setImmortalBlinking();
                    }
                    else {
                        this.minusOneLife();
                    }
                }
            }
            updateHazzard(sprite_mc) {
                if (this.player.immortalBlinkingTicker != 0)
                    return;
                this.scene.physics.world.collide(this.player.sprite, sprite_mc, () => {
                    this.onEnemyOrHazzardContacted();
                    nscs.sound.SoundManager.getInstance().playSound('spikesSND');
                });
            }
            gainScoreForEnemyKill() {
                if (this.recentEnemyKillsNumberDelayedCall)
                    nscs.util.Functions.destroyDelayedCall(this.recentEnemyKillsNumberDelayedCall);
                this.recentEnemyKillsNumberDelayedCall = nscs.util.Functions.delayedCall(1750, () => { this.recentEnemyKillsNumber = 0; });
                this.recentEnemyKillsNumber++;
                this.gameplay.scoreUp(this.player.pounceLanding ? this.recentEnemyKillsNumber * 750 : this.recentEnemyKillsNumber * 500);
            }
            updateEnemy4MC() {
                let sprite_mc;
                for (sprite_mc of this.enemy4MCArray) {
                    if (sprite_mc["dead"])
                        continue;
                    if (this.gameplay.isGravityFlipped()) {
                        sprite_mc.body["setAllowGravity"](false);
                    } /* else {
                        sprite_mc.body["setAllowGravity"](true);
                    }*/
                    if (sprite_mc.body.velocity.y < 0 && sprite_mc.body.velocity.y > -10) {
                        sprite_mc.setVelocityY(-50);
                    }
                    let d = Phaser.Math.Distance.Between(this.player.sprite.x, this.player.getFootsWorldY(), sprite_mc.x, sprite_mc.y);
                    let ch = this.gridRender.getAll();
                    for (let c of ch) {
                        this.scene.physics.world.collide(sprite_mc, c, () => {
                            if (sprite_mc.body.touching.right || sprite_mc.body.touching.left) {
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'bounceSide');
                                if (d < 250)
                                    nscs.sound.SoundManager.getInstance().playSound('fryKidSND');
                            }
                            else if (this.gameplay.isGravityFlipped() ?
                                sprite_mc.body.touching.down || sprite_mc.body.touching.up :
                                sprite_mc.body.touching.up || sprite_mc.body.touching.down) {
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'bounce');
                                if (d < 250)
                                    nscs.sound.SoundManager.getInstance().playSound('fryKidSND');
                            }
                        });
                    }
                }
            }
            showDustMC(x, y, scale, angle) {
                let dustMC = this.scene.add.sprite(x, y, 'objects-atlas', 'dustMC' + '0000');
                dustMC.setOrigin(0.5, 0.75);
                let anim = 'dustMC' + "_" + "playingAnimName";
                if (!this.scene.anims.exists(anim)) {
                    this.scene.anims.create({
                        key: anim,
                        frames: this.scene.anims.generateFrameNames(dustMC.texture.key, {
                            start: 0, end: 39, zeroPad: 4,
                            prefix: 'dustMC', suffix: ''
                        }),
                        frameRate: 60
                    });
                }
                dustMC.play(anim);
                dustMC.once('animationcomplete', () => { if (dustMC.parentContainer)
                    dustMC.parentContainer.remove(dustMC); });
                dustMC.setScale(scale);
                dustMC.setAngle(angle);
                this.addAt(dustMC, this.getIndex(this.player.sprite) + 1);
            }
            updateEnemy(sprite_mc) {
                if (sprite_mc["dead"])
                    return;
                let hitTestMethod = "collide";
                if (sprite_mc["libId"] == "enemy1MC") {
                    var speedX = 55;
                    var justCreated = !sprite_mc["-initialized-"];
                    sprite_mc["-initialized-"] = true;
                    if (justCreated) {
                        sprite_mc.setImmovable(false);
                        sprite_mc.setVelocity(speedX, 0);
                        sprite_mc.setFlip(false, false);
                        sprite_mc["moveRight"] = true;
                        nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'move');
                    }
                    else {
                        if (sprite_mc.x <= -sprite_mc["movingRange"] / 4 + sprite_mc["defPosition"]["x"] && !sprite_mc["moveRight"]) {
                            sprite_mc["moveRight"] = true;
                        }
                        else if (sprite_mc["defPosition"]["x"] + sprite_mc["movingRange"] / 4 <= sprite_mc.x && sprite_mc["moveRight"]) {
                            sprite_mc["moveRight"] = false;
                        }
                        if (sprite_mc["moveRight"]) {
                            sprite_mc.setVelocity(speedX, 0);
                            sprite_mc.setFlip(false, false);
                        }
                        else {
                            sprite_mc.setVelocity(-speedX, 0);
                            sprite_mc.setFlip(true, false);
                        }
                    }
                }
                else if (sprite_mc["libId"] == "enemy2MC") {
                    var justCreated = !sprite_mc["-initialized-"];
                    sprite_mc["-initialized-"] = true;
                    if (justCreated) {
                        let chain_mc = new Phaser.GameObjects.Image(this.scene, sprite_mc["defPosition"]["x"], sprite_mc["defPosition"]["y"], sprite_mc.texture.key, 'chain_mc0000');
                        chain_mc.setOrigin(0.5, 0);
                        sprite_mc.parentContainer.addAt(chain_mc, sprite_mc.parentContainer.getIndex(sprite_mc));
                        sprite_mc["chain_mc"] = chain_mc;
                        sprite_mc.setImmovable(false);
                        let update = () => {
                            if (!sprite_mc.parentContainer)
                                return;
                            if (sprite_mc.y > sprite_mc["defPosition"].y + sprite_mc["movingRange"] * 2) {
                                sprite_mc.y = sprite_mc["defPosition"].y + sprite_mc["movingRange"] * 2;
                            }
                            else if (sprite_mc.y < sprite_mc["defPosition"].y) {
                                sprite_mc.y = sprite_mc["defPosition"].y;
                            }
                            let dy = sprite_mc.y - sprite_mc["defPosition"]["y"];
                            sprite_mc["chain_mc"].scaleY = dy / sprite_mc["chain_mc"].height;
                        };
                        let alive = () => {
                            if (!sprite_mc.parentContainer)
                                return;
                            nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'idle');
                            sprite_mc.body.velocity.y = 0;
                            this.scene.tweens.add({
                                targets: sprite_mc.body.velocity,
                                "y": 5,
                                duration: 500,
                                repeat: 1,
                                yoyo: true,
                                onUpdate: update,
                                onComplete: () => {
                                    if (!sprite_mc.parentContainer)
                                        return;
                                    nscs.util.Functions.delayedCall(1500 + Math.random() * 1500, () => {
                                        if (!sprite_mc.parentContainer)
                                            return;
                                        nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'drop');
                                        sprite_mc.body.velocity.y = 0;
                                        this.scene.tweens.add({
                                            targets: sprite_mc.body.velocity,
                                            "y": 120,
                                            duration: 4500 * sprite_mc["movingRange"] / 100,
                                            ease: Phaser.Math.Easing.Cubic.In,
                                            onUpdate: update,
                                            onComplete: () => {
                                                if (!sprite_mc.parentContainer)
                                                    return;
                                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'pull');
                                                sprite_mc.body.velocity.y = 0;
                                                this.scene.tweens.add({
                                                    targets: sprite_mc.body.velocity,
                                                    "y": -240,
                                                    duration: 2250 * sprite_mc["movingRange"] / 100,
                                                    ease: Phaser.Math.Easing.Cubic.In,
                                                    delay: 1500,
                                                    onUpdate: update,
                                                    onComplete: () => {
                                                        if (!sprite_mc.parentContainer)
                                                            return;
                                                        nscs.util.Functions.delayedCall(1000, alive);
                                                        nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'idle');
                                                        sprite_mc.body.velocity.y = 0;
                                                    }
                                                });
                                            }
                                        });
                                    });
                                }
                            });
                        };
                        alive();
                    }
                }
                else if (sprite_mc["libId"] == "enemy3MC") {
                    if (nscs.scene.MainScene.instance.factory.isAnimationComplete(sprite_mc)) {
                        nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, Math.random() > 0.9 ? 'attack' : 'idle');
                    }
                }
                else if (sprite_mc["libId"] == "enemy5MC") {
                    let dist = Phaser.Math.Distance.Between(sprite_mc.x, sprite_mc.y, this.player.sprite.x, this.player.sprite.y);
                    if (!sprite_mc["appeared"]) {
                        if (dist < 250) {
                            sprite_mc["appeared"] = true;
                            nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'appear');
                            nscs.sound.SoundManager.getInstance().playSound('mbJumpSND');
                            nscs.sound.SoundManager.getInstance().playSound('mbRustleSND');
                        }
                    }
                    else {
                        if (dist > 250) {
                            sprite_mc["appeared"] = false;
                            nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'disappear');
                        }
                        if (nscs.scene.MainScene.instance.factory.isAnimationComplete(sprite_mc)) {
                            nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, Math.random() > 0.85 ? 'attack' : 'appeared');
                        }
                    }
                }
                else if (sprite_mc["libId"].indexOf("enemy4MC") == 0) {
                    hitTestMethod = "overlap";
                    if (Math.abs(this.player.sprite.x - sprite_mc.x) < game.scale.width && Math.abs(this.player.sprite.y - sprite_mc.y) < game.scale.height) {
                        if (this.enemy4MCArray.indexOf(sprite_mc) < 0) {
                            this.enemy4MCArray.push(sprite_mc);
                            sprite_mc.setVelocity((Math.random() > 0.5 ? 1 : -1) * (Math.random() * 0.5 + 0.5) * 40, (Math.random() * 0.5 + 0.5) * 100);
                            sprite_mc.setBounce(1, 1);
                            sprite_mc.setCollideWorldBounds(false);
                            sprite_mc.setImmovable(false);
                            sprite_mc.body["setAllowGravity"](true);
                            sprite_mc['-defVelocityLength-'] = sprite_mc.body.velocity.length();
                            this.scene.tweens.add({
                                targets: sprite_mc,
                                angle: Math.random() > 0.5 ? 360 : -360,
                                duration: 5000,
                                repeat: -1,
                                ease: Phaser.Math.Easing.Linear
                            });
                        }
                    }
                }
                if (sprite_mc["libId"] == "enemy5MC" && !sprite_mc["appeared"]) {
                    return;
                }
                this.scene.physics.world[hitTestMethod](this.player.sprite, sprite_mc, () => {
                    // sprite_mc.setImmovable(true);
                    // sprite_mc.body["setAllowGravity"](false);
                    sprite_mc.setVelocity(0, 0);
                    if (this.gameplay.isGravityFlipped() ? this.player.sprite.body.touching.up : this.player.sprite.body.touching.down) {
                        if (this.gameplay.isGravityFlipped() ? sprite_mc.body.touching.down : sprite_mc.body.touching.up) {
                            if (this.player.pounceLanding) {
                                sprite_mc["hitsToKill"] = 0;
                            }
                            else {
                                sprite_mc["hitsToKill"]--;
                            }
                            if (sprite_mc["hitsToKill"] <= 0) {
                                sprite_mc["dead"] = true;
                                this.gainScoreForEnemyKill();
                                nscs.sound.SoundManager.getInstance().playSound('squashSND');
                                nscs.sound.SoundManager.getInstance().playSound('hairballHitSND');
                                if (sprite_mc["libId"] == "enemy1MC") {
                                    this.scene.tweens.add({
                                        targets: sprite_mc,
                                        scaleY: 0,
                                        duration: 300,
                                        delay: 350,
                                        onComplete: () => {
                                            if (sprite_mc.parentContainer) {
                                                sprite_mc.parentContainer.remove(sprite_mc);
                                            }
                                        }
                                    });
                                }
                                if (sprite_mc["libId"] == "enemy2MC") {
                                    nscs.util.Functions.delayedCall(2000, () => {
                                        if (sprite_mc.parentContainer) {
                                            sprite_mc.parentContainer.remove(sprite_mc);
                                        }
                                    });
                                    if (sprite_mc["chain_mc"].parentContainer) {
                                        sprite_mc["chain_mc"].parentContainer.remove(sprite_mc["chain_mc"]);
                                    }
                                    sprite_mc.flipY = true;
                                    this.scene.tweens.killTweensOf(sprite_mc.body.velocity);
                                    sprite_mc.setVelocity(0, 275);
                                }
                                else {
                                    nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'die');
                                }
                            }
                            else {
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'hit');
                            }
                            this.player.doAfterJumpOverEnemy();
                        }
                    }
                    if (!sprite_mc["dead"]) {
                        if (this.player.sprite.body.touching.left || this.player.sprite.body.touching.right || this.player.sprite.body.touching.up) {
                            if (sprite_mc.body.touching.left || sprite_mc.body.touching.right || (this.gameplay.isGravityFlipped() ? sprite_mc.body.touching.up : sprite_mc.body.touching.down)) {
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'attack');
                                this.onEnemyOrHazzardContacted();
                            }
                        }
                    }
                });
                if (sprite_mc.y > this.gameplay.waterLevel) {
                    if (!sprite_mc['tickerModer'])
                        sprite_mc['tickerModer'] = Math.ceil(Math.random() * 10) + 30;
                    if (this.ticker % sprite_mc['tickerModer'] == 0 && Math.random() > 0.75) {
                        this.showBubbles(sprite_mc.x, sprite_mc.y, 1, 2, this.gameplay.isGravityFlipped() ? 'down' : 'up', 10, 75 + Math.random() * 50, 1500, null);
                    }
                }
            }
            isSpriteGravityAllowed(sprite_mc) {
                return sprite_mc["libId"] == "decor93MC" || sprite_mc["libId"] == "decor94MC" || sprite_mc["libId"] == "decor95MC" || sprite_mc["libId"] == "enemy3MC";
            }
            updateDecor(sprite_mc) {
                if (sprite_mc["libId"] == 'decor96MC' && this.gameplay.inWater) {
                    let dx = this.player.sprite.x - sprite_mc.x;
                    let dy = this.player.sprite.y - sprite_mc.y;
                    let d = Math.sqrt(dx * dx + dy * dy);
                    sprite_mc.scaleY = this.player.sprite.x < sprite_mc.x ? -1 : 1;
                    sprite_mc.rotation = Math.atan2(dy, dx);
                    let sprite_mcY = sprite_mc.y;
                    if (d < 300 && d > 75) {
                        sprite_mc.x += (this.player.sprite.x - sprite_mc.x) / 60;
                        sprite_mcY += (this.player.sprite.y - sprite_mcY) / 60;
                    }
                    if (sprite_mc.y > this.gameplay.waterLevel) {
                        if (this.ticker % 45 == 0 && Math.random() > 0.5) {
                            this.showBubbles(sprite_mc.x, sprite_mc.y, 1, 3, this.gameplay.isGravityFlipped() ? 'down' : 'up', 10, 75 + Math.random() * 50, 1000, null);
                        }
                    }
                    if (this.isPointInWater(sprite_mc.x, sprite_mcY - 20)) {
                        sprite_mc.y = sprite_mcY;
                    }
                }
                if (!sprite_mc["decorType"])
                    return;
                if (sprite_mc["decorType"] == 'protestor' && sprite_mc["speech"]) {
                    let scaleX = 1;
                    if (sprite_mc.hasOwnProperty('lookingLeft'))
                        scaleX = sprite_mc['lookingLeft'] ? 1 : -1;
                    if (!this.isSpriteGravityAllowed(sprite_mc)) {
                        if (this.player.sprite.x < sprite_mc.x) {
                            scaleX *= 1;
                        }
                        else {
                            scaleX *= -1;
                        }
                    }
                    sprite_mc.scaleX = scaleX;
                    let overlap = this.scene.physics.world.overlap(this.player.sprite, sprite_mc);
                    if (overlap) {
                        if (!sprite_mc["speaking"]) {
                            sprite_mc["speaking"] = true;
                            this.inGameUI.showSpeechDialog(this.scene.cameras.main.getScroll(sprite_mc.x, sprite_mc.y).x, nscs.gameplay.Gameplay.getText('activist' + sprite_mc["speech"]));
                            nscs.sound.SoundManager.getInstance().playSound('whistleSND');
                        }
                        else {
                            this.inGameUI.updateSpeechDialog(this.scene.cameras.main.getScroll(this.player.sprite.x, this.player.sprite.y).x);
                        }
                    }
                    else {
                        if (sprite_mc["speaking"]) {
                            sprite_mc["speaking"] = false;
                            this.inGameUI.hideSpeechDialog();
                        }
                    }
                }
                else if (sprite_mc["decorType"].indexOf('pipe') == 0) {
                    let overlap = this.scene.physics.world.overlap(this.player.sprite, sprite_mc);
                    if (overlap) {
                        this.onContactWithStaticObject(sprite_mc);
                        let inputController = nscs.scene.MainScene.instance.inputController;
                        let l = (inputController.cursorKeys.left.isDown || nscs.input.InputManager.instance.isDown('LEFT'))
                            && sprite_mc.body.touching.right && this.player.sprite.body.touching.left;
                        let r = (inputController.cursorKeys.right.isDown || nscs.input.InputManager.instance.isDown('RIGHT'))
                            && sprite_mc.body.touching.left && this.player.sprite.body.touching.right;
                        if ((sprite_mc["decorType"] == 'pipeDown' && (this.gameplay.isGravityFlipped() ?
                            /*inputController.cursorKeys.up.isDown && */ sprite_mc.body.touching.down && this.player.sprite.body.touching.up :
                            (inputController.cursorKeys.down.isDown || nscs.input.InputManager.instance.isDown('DOWN'))
                                && sprite_mc.body.touching.up && this.player.sprite.body.touching.down))
                            ||
                                (sprite_mc["decorType"] == 'pipeUp' && (this.gameplay.isGravityFlipped() ?
                                    (inputController.cursorKeys.down.isDown || nscs.input.InputManager.instance.isDown('DOWN'))
                                        && sprite_mc.body.touching.up && this.player.sprite.body.touching.down :
                                    /*inputController.cursorKeys.up.isDown && */ sprite_mc.body.touching.down && this.player.sprite.body.touching.up))
                            ||
                                (sprite_mc["decorType"] == 'pipeSide' && (sprite_mc.x < this.player.sprite.x && l
                                    ||
                                        sprite_mc.x >= this.player.sprite.x && r))) {
                            let inDirection;
                            if (sprite_mc["decorType"] == 'pipeDown')
                                inDirection = 'down';
                            else if (sprite_mc["decorType"] == 'pipeUp')
                                inDirection = 'up';
                            else if (l)
                                inDirection = 'left';
                            else if (r)
                                inDirection = 'right';
                            this.pipeTravel(sprite_mc["pipeRoute"], inDirection);
                        }
                    }
                }
                else if (sprite_mc["decorType"] == 'bounce' || sprite_mc["decorType"] == 'uberBounce') {
                    let overlap = this.scene.physics.world.overlap(this.player.sprite, sprite_mc);
                    if (overlap) {
                        this.player.doBounceJump();
                        nscs.scene.MainScene.instance.factory.playAnimation(sprite_mc);
                        nscs.sound.SoundManager.getInstance().playSound('bouncerSND');
                    }
                }
                else if (sprite_mc["decorType"] == 'recovery') {
                    if (!sprite_mc['-active-']) {
                        if (this.scene.physics.world.overlap(this.player.sprite, sprite_mc)) {
                            sprite_mc['-active-'] = true;
                        }
                    }
                }
                else if (sprite_mc["decorType"] == 'switch') {
                    if (sprite_mc["switchType"] == "gravity") {
                        if (this.player.pounceLanding) {
                            sprite_mc.body.checkCollision.right = sprite_mc.body.checkCollision.left = false;
                            if (this.scene.physics.world.collide(this.player.sprite, sprite_mc)) {
                                if (this.gameplay.isGravityFlipped() ?
                                    this.player.sprite.body.touching.up && sprite_mc.body.touching.down :
                                    this.player.sprite.body.touching.down && sprite_mc.body.touching.up) {
                                    this.shceduleGravitySwitching = true;
                                    this.onContactWithStaticObject(sprite_mc);
                                }
                            }
                        }
                    }
                }
                else if (sprite_mc["decorType"] && sprite_mc["decorType"].substr(0, 3) == 'fan') {
                    if (this.scene.physics.world.overlap(this.player.sprite, sprite_mc)) {
                        if (sprite_mc["decorType"] == 'fanUp') {
                            this.player.fanUp = true;
                        }
                        else {
                            if (sprite_mc["decorType"] == 'fanLeft') {
                                this.player.fanLeft = true;
                            }
                            else if (sprite_mc["decorType"] == 'fanRight') {
                                this.player.fanRight = true;
                            }
                        }
                    }
                }
                else if (sprite_mc["decorType"] == 'thumper') {
                    if (this.player.immortalBlinkingTicker == 0) {
                        if (this.scene.physics.world.collide(this.player.sprite, sprite_mc)) {
                            if (sprite_mc.body.velocity.y > 0 && this.player.sprite.body.touching.up && sprite_mc.body.touching.down) {
                                this.onEnemyOrHazzardContacted();
                            }
                        }
                    }
                    var justCreated = !sprite_mc["-initialized-"];
                    sprite_mc["-initialized-"] = true;
                    if (justCreated) {
                        let g = new Phaser.GameObjects.Graphics(this.scene);
                        g.setPosition(sprite_mc["defPosition"]["x"], sprite_mc["defPosition"]["y"] + sprite_mc.height);
                        g.fillStyle(0, 0).fillRect(-sprite_mc.width / 2, -sprite_mc.height, sprite_mc.width, sprite_mc.height);
                        sprite_mc.parentContainer.add(g);
                        sprite_mc.mask = g.createGeometryMask();
                        let update = () => {
                            if (!sprite_mc.parentContainer)
                                return;
                            if (sprite_mc.y > sprite_mc["defPosition"].y + 82) {
                                sprite_mc.y = sprite_mc["defPosition"].y + 82;
                            }
                            else if (sprite_mc.y < sprite_mc["defPosition"].y) {
                                sprite_mc.y = sprite_mc["defPosition"].y;
                            }
                        };
                        let move = () => {
                            if (!sprite_mc.parentContainer)
                                return;
                            sprite_mc.body.velocity.y = 0;
                            this.scene.tweens.add({
                                targets: sprite_mc.body.velocity,
                                "y": 340,
                                duration: 1000,
                                ease: Phaser.Math.Easing.Cubic.In,
                                onUpdate: update,
                                onComplete: () => {
                                    if (!sprite_mc.parentContainer)
                                        return;
                                    if (Phaser.Math.Distance.BetweenPoints(this.player.sprite, sprite_mc) < game.scale.width) {
                                        nscs.sound.SoundManager.getInstance().playSound('thumpSND', 0.25);
                                    }
                                    sprite_mc.body.velocity.y = 0;
                                    this.scene.tweens.add({
                                        targets: sprite_mc.body.velocity,
                                        "y": -60,
                                        duration: 1750,
                                        ease: Phaser.Math.Easing.Cubic.Out,
                                        delay: 1500,
                                        onUpdate: update,
                                        onComplete: () => {
                                            if (!sprite_mc.parentContainer)
                                                return;
                                            nscs.util.Functions.delayedCall(2000, move);
                                            sprite_mc.body.velocity.y = 0;
                                        }
                                    });
                                }
                            });
                        };
                        move();
                    }
                }
                else if (sprite_mc["decorType"] == 'beltRight') {
                    if (this.scene.physics.world.collide(this.player.sprite, sprite_mc)) {
                        if (this.player.sprite.body.touching.down && sprite_mc.body.touching.up) {
                            this.onContactWithStaticObject(sprite_mc);
                            this.player.setMovingPlatformForThisUpdate();
                        }
                    }
                    if (Phaser.Math.Distance.BetweenPoints(this.player.sprite, sprite_mc) < game.scale.width) {
                        if (!sprite_mc["-isAlreadySndPlaying-"]) {
                            nscs.sound.SoundManager.getInstance().playSound('beltSND', 0.25);
                            sprite_mc["-isAlreadySndPlaying-"] = true;
                        }
                    }
                    else {
                        sprite_mc["-isAlreadySndPlaying-"] = false;
                    }
                }
            }
            synchronizeGravity() {
                this.scene.physics.world.gravity.set(0, this.gameplay.calculateGravity());
            }
            switchGravity() {
                this.gameplay.gravityDir *= -1;
                this.synchronizeGravity();
                this.player.updateBodyFlipY();
                this.player.updateBodyOffset();
                this.player.playForcedFlyAnimation();
                let sprites = this.getAllSprites();
                for (let sprite_mc of sprites) {
                    if (this.isSpriteGravityAllowed(sprite_mc)) {
                        sprite_mc.setImmovable(false);
                        if (this.gameplay.isGravityFlipped()) {
                            sprite_mc.flipY = true;
                            sprite_mc.body.offset.y = sprite_mc.body.offset['-yFlipped-'];
                        }
                        else {
                            sprite_mc.flipY = false;
                            sprite_mc.body.offset.y = sprite_mc.body.offset['-y-'];
                        }
                    }
                }
                this.showWhiteSplashScreen();
                nscs.sound.SoundManager.getInstance().playSound('gravitySND');
            }
            pipeTravel(pipeRoute, inDirection) {
                if (this.isPipeTravelingActive)
                    return;
                // init
                var newWorldId = null;
                var enterAniAxis = 'down';
                var newX = 0;
                var newY = 0;
                switch (pipeRoute) {
                    ////////////////// LEVEL 1 PIPES ///////////////////
                    // shortcut
                    case '1-1':
                        newWorldId = '2';
                        newX = 146;
                        newY = 130;
                        enterAniAxis = 'down';
                        break;
                    case "1-1":
                        newX = 146;
                        newY = 130;
                        newWorldId = "2";
                        enterAniAxis = "";
                        break;
                    case "3-24":
                        newX = 170;
                        newY = 1420;
                        newWorldId = "4";
                        break;
                    case "4-2":
                        newX = 110;
                        newY = 32;
                        newWorldId = "5";
                        break;
                    case "2-1":
                        newWorldId = "2.1";
                        newX = 250;
                        newY = 600;
                        break;
                    case "2-2":
                        newWorldId = "2";
                        newX = 150;
                        newY = 955;
                        break;
                    case "2-3":
                        newX = 110;
                        newY = 32;
                        newWorldId = "3";
                        enterAniAxis = "";
                        break;
                    case "3-1":
                        newX = 686;
                        newY = 576;
                        enterAniAxis = "left";
                        break;
                    case "3-2":
                        newX = 1564;
                        newY = 960;
                        break;
                    case "3-3":
                        newX = 926;
                        newY = 288;
                        break;
                    case "3-4":
                        newX = 2068;
                        newY = 670;
                        enterAniAxis = "right";
                        break;
                    case "3-5":
                        newX = 2400;
                        newY = 1374;
                        break;
                    case "3-6":
                        newX = 2080;
                        newY = 268;
                        break;
                    case "3-7":
                        newX = 2290;
                        newY = 1150;
                        enterAniAxis = "left";
                        break;
                    case "3-8":
                        newX = 2398;
                        newY = 1376;
                        break;
                    case "3-9":
                        newWorldId = "3.1";
                        newX = 286;
                        newY = 480;
                        break;
                    case "3-10":
                        newX = 2400;
                        newY = 606;
                        break;
                    case "3-11":
                        newX = 2400;
                        newY = 606;
                        break;
                    case "3-12":
                        newX = 288;
                        newY = 512;
                        break;
                    case "3-13":
                        newX = 190;
                        newY = 864;
                        break;
                    case "3-14":
                        newX = 94;
                        newY = 864;
                        break;
                    case "3-15":
                        newX = 926;
                        newY = 288;
                        break;
                    case "3-16":
                        newX = 1504;
                        newY = 96;
                        break;
                    case "3-17":
                        newX = 1868;
                        newY = 670;
                        enterAniAxis = "left";
                        break;
                    case "3-18":
                        newX = 288;
                        newY = 512;
                        break;
                    case "3-19":
                        newX = 686;
                        newY = 576;
                        enterAniAxis = "left";
                        break;
                    case "3-20":
                        newX = 2400;
                        newY = 606;
                        break;
                    case "3-21":
                        newX = 2080;
                        newY = 268;
                        break;
                    case "3-22":
                        newX = 288;
                        newY = 512;
                        break;
                    case "3-23":
                        newWorldId = "3.2";
                        newX = 320;
                        newY = 320;
                        break;
                    case "3-2-1":
                        newX = 542;
                        newY = 320;
                        break;
                    case "3-2-2":
                        newX = 764;
                        newY = 320;
                        break;
                    case "3-2-3":
                        newX = 986;
                        newY = 320;
                        break;
                    case "3-101":
                        newWorldId = "3";
                        newX = 2290;
                        newY = 1150;
                        enterAniAxis = "left";
                        break;
                    case "3-102":
                        newWorldId = "3";
                        newX = 1504;
                        newY = 96;
                        break;
                    case "3-103":
                        newWorldId = "3";
                        newX = 2080;
                        newY = 268;
                        break;
                    case "4-1":
                        newX = 250;
                        newY = 1440;
                        newWorldId = "4.1";
                        enterAniAxis = "up";
                        break;
                    case "4-1-1":
                        newX = 2624;
                        newY = 1440;
                        newWorldId = "4";
                        enterAniAxis = "up";
                        break;
                    case "5-1":
                        newX = 74;
                        newY = 510;
                        enterAniAxis = "right";
                        break;
                    case "5-2":
                        newX = 406;
                        newY = 1472;
                        newWorldId = "5.1";
                        enterAniAxis = "right";
                }
                let doNotResetTimerFlag = true;
                // accomodate for height difference:
                if (enterAniAxis == 'down' && newY)
                    newY += 16;
                let dSize = this.gameplay.charSize == 'small' ? 35 : 40;
                if (enterAniAxis == "left")
                    newX += dSize;
                else if (enterAniAxis == "right")
                    newX -= dSize;
                this.player.goInOutPipe(inDirection, dSize, () => {
                    this.showBlackFGFading(() => {
                        if (newWorldId) {
                            nscs.scene.MainScene.instance.gameplay.loadWorld(newWorldId, false, false, true);
                            let newGameScreen = nscs.scene.MainScene.instance.gameplay.gameScreen;
                            newGameScreen.player.setWorldPosition(newX, newY);
                            newGameScreen.isPipeTravelingActive = true;
                            newGameScreen.player.goInOutPipe(enterAniAxis, dSize, () => {
                                newGameScreen.isPipeTravelingActive = false;
                                newGameScreen.player.resetPipeGoing();
                            });
                            this.isPipeTravelingActive = false;
                        }
                        else {
                            this.player.setWorldPosition(newX, newY);
                            this.isPipeTravelingActive = true;
                            this.player.goInOutPipe(enterAniAxis, dSize, () => {
                                this.isPipeTravelingActive = false;
                            });
                            this.player.resetPipeGoing();
                        }
                    });
                });
                nscs.sound.SoundManager.getInstance().playSound('pipeSND');
            }
            fetchRecoveryPoints() {
                this.recoverySprites = [];
                let ch = this.getAllSprites();
                for (let c of ch) {
                    if (c["decorType"] == 'recovery') {
                        this.recoverySprites.push(c);
                    }
                }
            }
            findClosestActiveRecoveryPoint() {
                let minDist = Number.MAX_VALUE;
                let closest = { x: this.gameplay.newX, y: this.gameplay.newY };
                for (let r of this.recoverySprites) {
                    if (r['-active-']) {
                        let d = Phaser.Math.Distance.Between(this.player.sprite.x, this.player.sprite.y, r.x, r.y);
                        if (d < minDist) {
                            minDist = d;
                            closest = r;
                        }
                    }
                }
                return closest;
            }
            getAllSprites() {
                this.reusedArray.splice(0, this.reusedArray.length);
                this.reusedArray = this.reusedArray.concat(this.spritesBackLayer.getAll()).concat(this.spritesTopLayer.getAll());
                return this.reusedArray;
            }
            onFlagReached() {
                if (this.isFlagReached)
                    return;
                nscs.scene.MainScene.instance.factory.playAnimation(this.finishFlag, this.boss ? "boss-flag-reached" : "normal-flag-reached");
                nscs.sound.SoundManager.getInstance().playSound('flagHitSND');
                this.player.isFlagReached = true;
                this.isFlagReached = true;
                this.gameplay.calculateTotalScore();
                this.inGameUI.tweenScore(this.gameplay.score, 3000);
                this.inGameUI.tweenTimer(0, 3000);
                this.gameplay.destroyTimer();
                nscs.util.Functions.delayedCall(4000, () => {
                    nscs.scene.MainScene.instance.proceedLevelComplete();
                });
                nscs.sound.SoundManager.getInstance().playSound('levelCompleteSND');
            }
            checkFlagReached() {
                if (!this.finishFlag)
                    return;
                if (!this.finishFlag.visible)
                    return;
                let collide = this.scene.physics.world.collide(this.player.sprite, this.finishFlag["flagPoleMC"]);
                if (collide) {
                    this.onFlagReached();
                }
            }
            updateSprites() {
                let ch = this.getAllSprites();
                for (let sprite_mc of ch) {
                    let spriteType = sprite_mc["spriteType"];
                    if (spriteType == 'E') {
                        this.updateEnemy(sprite_mc);
                    }
                    else if (spriteType == 'H') {
                        this.updateHazzard(sprite_mc);
                    }
                    else if (spriteType == 'C') {
                        this.updateChick(sprite_mc);
                    }
                    else if (spriteType == 'D') {
                        this.updateDecor(sprite_mc);
                    }
                    else if (spriteType == 'B') {
                        this.updateBlock(sprite_mc);
                    }
                }
            }
            onContactWithStaticObject(staticObject) {
                if (this.gameplay.isGravityFlipped() ?
                    this.player.sprite.body.touching.up && staticObject.body['touching'].down :
                    this.player.sprite.body.touching.down && staticObject.body['touching'].up) {
                    this.player.contactDownWithStaticObject = true;
                }
                if (this.player.sprite.body.touching.left && staticObject.body['touching'].right) {
                    this.player.contactLeftWithStaticObject = true;
                }
                if (this.player.sprite.body.touching.right && staticObject.body['touching'].left) {
                    this.player.contactRightWithStaticObject = true;
                }
            }
            updateLadder() {
                let inputController = nscs.scene.MainScene.instance.inputController;
                //ladder blocks
                let contactWithLadding = false;
                for (let l of this.ladderArray) {
                    let i = l["-grid-i-"];
                    let j = l["-grid-j-"];
                    let arr = [
                        [11, 3], [12, 3],
                        [4, 13], [5, 13], [6, 13], [11, 13],
                        [3, 14], [4, 14], [5, 14],
                    ];
                    let _is = false;
                    for (var a of arr) {
                        if (l["-srcx-"] == a[0] && l["-srcy-"] == a[1]) {
                            _is = true;
                            break;
                        }
                    }
                    if (_is) {
                        if (this.scene.physics.world.overlap(this.player.sprite, l)) {
                            if (this.gameplay.isGravityFlipped() ?
                                this.player.sprite.body.touching.up && l.body['touching'].down && (!inputController.cursorKeys.up.isDown || nscs.input.InputManager.instance.isDown('UP')) :
                                this.player.sprite.body.touching.down && l.body['touching'].up && (!inputController.cursorKeys.down.isDown || nscs.input.InputManager.instance.isDown('DOWN'))) {
                                if (this.scene.physics.world.collide(this.player.sprite, l)) {
                                    this.onContactWithStaticObject(l);
                                }
                            }
                        }
                    }
                    let overlaps = this.scene.physics.world.overlap(this.player.sprite, l);
                    if (overlaps) {
                        /*if (i == 0 || Number(this.gameplay.ladder_array[this.gameplay.grid[i-1][j]]) != 1) {
                            if (
                                this.gameplay.isGravityFlipped() ?
                                    this.player.sprite.body.touching.up && l.body['touching'].down && !inputController.cursorKeys.up.isDown :
                                    this.player.sprite.body.touching.down && l.body['touching'].up && !inputController.cursorKeys.down.isDown
                            ) {
                                if (this.scene.physics.world.collide(this.player.sprite, l)) {
                                    this.onContactWithStaticObject(l);
                                }
                            }
                        }*/
                        let dx = this.player.sprite.x - l['x'];
                        if (dx < 25 && dx > 9) {
                            contactWithLadding = true;
                        }
                    }
                }
                if (contactWithLadding) {
                    if (!this.player.isPlayerLadding) {
                        if ((inputController.cursorKeys.up.isDown || nscs.input.InputManager.instance.isDown('UP'))
                            || (inputController.cursorKeys.down.isDown || nscs.input.InputManager.instance.isDown('DOWN'))) {
                            this.player.isPlayerLadding = true;
                        }
                    }
                }
                else {
                    this.player.isPlayerLadding = false;
                }
            }
            showFallingCharacter(onComplete) {
                this.gameplay.pause();
                this.remove(this.player.sprite, false);
                this.addAt(this.player.sprite, this.getIndex(this.spritesTopLayer) + 1);
                this.scene.tweens.add({
                    targets: this.player.sprite,
                    y: this.player.sprite.y - (this.gameplay.isGravityFlipped() ? 200 : 125),
                    duration: 500,
                    ease: Phaser.Math.Easing.Sine.Out,
                    onComplete: () => {
                        let prevFlipY = this.player.sprite.flipY;
                        this.player.sprite.flipY = false;
                        this.scene.tweens.add({
                            targets: this.player.sprite,
                            y: this.player.sprite.y + game.scale.height,
                            duration: 750,
                            ease: Phaser.Math.Easing.Sine.In,
                            onComplete: () => {
                                this.player.sprite.flipY = prevFlipY;
                                onComplete();
                            }
                        });
                    }
                });
                nscs.sound.SoundManager.getInstance().playSound('dyingSND');
            }
            showGameOverScreen() {
                this.gameplay.destroyTimer();
                let gos = new nscs.screen.GameOverScreen(this.scene);
                nscs.scene.MainScene.instance.switchScreen(gos, true);
                nscs.sound.SoundManager.getInstance().stopMusic();
                nscs.sound.SoundManager.getInstance().playSound('gameoverSND');
            }
            onTimeout() {
                this.inGameUI.timeover_mc.visible = true;
                this.player.setTempDead(true);
                this.stopFollowCamera();
                this.showFallingCharacter(() => {
                    this.showGameOverScreen();
                });
            }
            tryMinusOneLife() {
                if (this.player.fullyActive() && !this.isFlagReached) {
                    this.minusOneLife();
                }
            }
            showNewGameNewWorldScreen() {
                this.inGameUI.showNewWorldScreen();
                nscs.util.Functions.delayedCall(2000, () => {
                    this.showBlackFGFading(() => {
                        this.inGameUI.hideNewWorldScreen();
                    });
                });
                nscs.sound.SoundManager.getInstance().playSound('gamestartSND');
            }
            minusOneLife() {
                this.gameplay.minusLife();
                this.player.minusOneLife();
                let closest = this.findClosestActiveRecoveryPoint();
                this.stopFollowCamera();
                this.showFallingCharacter(() => {
                    if (this.gameplay.lives == 0) {
                        sendEvent(petaGA_GameCategory_Game, 'Die', 'Super Chick Sisters - Die World ' + nscs.scene.MainScene.instance.getWorldNumber());
                        this.showGameOverScreen();
                    }
                    else {
                        this.inGameUI.showNewWorldScreen();
                        nscs.util.Functions.delayedCall(2000, () => this.showBlackFGFading(() => {
                            this.remove(this.player.sprite, false);
                            this.addAt(this.player.sprite, this.getIndex(this.spritesTopLayer));
                            this.player.respawn(closest['x'], closest['y']);
                            this.startFollowCamera();
                            this.inGameUI.hideNewWorldScreen();
                            this.gameplay.resume();
                        }));
                    }
                });
            }
            showBlackFGFading(onMid) {
                this.showFGFading(onMid, 250, 500, 0x000000);
            }
            showWhiteSplashScreen() {
                this.showFGFading(null, 40, 120, 0xFFFFFF);
            }
            showFGFading(onMid, druationIn, durationOut, color) {
                let transition = this.createShape(color);
                this.inGameUI.add(transition);
                transition.alpha = 0;
                this.scene.tweens.add({
                    targets: transition,
                    alpha: 1,
                    duration: druationIn,
                    ease: Phaser.Math.Easing.Linear,
                    onComplete: () => {
                        if (onMid)
                            onMid();
                        this.scene.tweens.add({
                            targets: transition,
                            alpha: 0,
                            duration: durationOut,
                            ease: Phaser.Math.Easing.Linear,
                            onComplete: () => {
                                this.inGameUI.remove(transition, true);
                            }
                        });
                    }
                });
            }
            onRemovedFromParent() {
                // this.stopFollowCamera();
                // this.playerToGridCollider.active = false;
            }
            onAddedToParent() {
                // this.playerToGridCollider.active = true;
                this.startFollowCamera();
                this.player.setup();
            }
            destroy(fromScene) {
                this.setPaused(false);
                this.scene.cameras.resetAll();
                if (this.recentEnemyKillsNumberDelayedCall) {
                    nscs.util.Functions.destroyDelayedCall(this.recentEnemyKillsNumberDelayedCall);
                    this.recentEnemyKillsNumberDelayedCall = null;
                }
                super.destroy(fromScene);
                nscs.input.InputManager.instance.destroy();
            }
            generatePlayerWaterBubbles() {
                this.showBubbles(this.player.sprite.x, this.player.getFootsWorldY() - 5 * this.gameplay.gravityDir, 1, 4, this.gameplay.isGravityFlipped() ? 'down' : 'up', 10, 75 + Math.random() * 50, 1000, null);
            }
            updateBubbles() {
                if (!this.gameplay.inWater)
                    return;
                if (this.ticker % 15 == 0 && Math.random() > 0.6) {
                    if (Math.abs(this.player.sprite.body.velocity.x) > Math.abs(this.gameplay.xSpeed) * 0.5 || Math.random() > 0.75) {
                        this.generatePlayerWaterBubbles();
                    }
                }
                for (let i = this.activeBubbles.length - 1; i >= 0; i--) {
                    if (!this.isPointInWater(this.activeBubbles[i].x, this.activeBubbles[i].y)) {
                        this.destroyBubble(this.activeBubbles[i]);
                    }
                }
            }
            updateBoss() {
                if (!this.boss)
                    return;
                this.boss.updateBoss();
            }
            isPointInWater(x, y) {
                let inWater = y > this.gameplay.waterLevel;
                if (this.gameplay.waterRects) {
                    for (let r of this.gameplay.waterRects) {
                        if ((x > r['p1'].x && y > r['p1'].y) && (x < r['p2'].x && y > r['p2'].y)
                            &&
                                (x > r['p4'].x && y < r['p4'].y) && (x < r['p3'].x && y < r['p3'].y)) {
                            inWater = true;
                            break;
                        }
                    }
                }
                return inWater;
            }
            updateInWater() {
                let prevInWater = this.gameplay.inWater;
                this.gameplay.inWater = this.isPointInWater(this.player.sprite.x, this.player.getFootsWorldY());
                if (prevInWater != this.gameplay.inWater) {
                    this.gameplay.updateWaterPhysics();
                    this.synchronizeGravity();
                    if (this.gameplay.inWater) {
                        this.generatePlayerWaterBubbles();
                        nscs.sound.SoundManager.getInstance().playSound('splashdownSND');
                        this.player.sprite.body.velocity.y /= 5;
                    }
                    else {
                        this.player.sprite.body.velocity.y *= 2.2;
                    }
                }
            }
            updateScreen() {
                super.updateScreen();
                this.updateEnemy4MC();
                if (this.player.tempDead)
                    return;
                this.updateBG();
                this.ticker++;
                this.updateTofu();
                this.updateSeakitten();
                this.updateLadder();
                this.updateSprites();
                this.player.update();
                this.updateBoss();
                if (this.player.fallenBelowTheWorld) {
                    this.tryMinusOneLife();
                }
                this.updateInWater();
                this.checkFlagReached();
                if (this.shceduleGravitySwitching) {
                    this.shceduleGravitySwitching = false;
                    this.switchGravity();
                }
                this.updateBubbles();
                this.updatePause();
            }
            updatePause() {
                let esc = nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased();
                if (esc) {
                    this.setPaused(!this.isPaused);
                    nscs.scene.MainScene.instance.inputController.escPressUsed();
                }
            }
            setPaused(paused) {
                this.isPaused = paused;
                if (this.isPaused) {
                    this.scene.physics.pause();
                    this.scene.anims.pauseAll();
                    this.scene.tweens.pauseAll();
                    this.scene.time.paused = true;
                    this.inGameUI.pauseScreen.showPauseGame();
                    nscs.sound.SoundManager.getInstance().fadeMusic(null, 500);
                }
                else {
                    this.scene.physics.resume();
                    this.scene.anims.resumeAll();
                    this.scene.tweens.resumeAll();
                    this.scene.time.paused = false;
                    this.inGameUI.pauseScreen.hidePauseGame();
                    nscs.sound.SoundManager.getInstance().revertMusic(500);
                }
            }
            updateBG() {
                let offx = this.player.sprite.x - 240;
                let offy = this.player.getFootsWorldY() - ((this.gameplay.gravityDir > 0) ? 181 : 135);
                if (offx < 0)
                    offx = 0;
                if (offx > this.gameplay.worldWidth - 480)
                    offx = this.gameplay.worldWidth - 480;
                if (offy < 0)
                    offy = 0;
                if (offy > this.gameplay.worldHeight - 320)
                    offy = this.gameplay.worldHeight - 320;
                this.bg.setPosition(-offx / 5, -offy / 5);
            }
        }
        screen.GameScreen = GameScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class HigscoreScreen extends screen.BaseScreen {
            constructor(scene) {
                super(scene);
                this.bg = new Phaser.GameObjects.Container(this.scene, 0, -200, [
                    new Phaser.GameObjects.Image(this.scene, 0, 50, 'bg-atlas', 'bg1_bg0000').setOrigin(0, 0),
                    new Phaser.GameObjects.Image(this.scene, 728, 50, 'bg-atlas', 'bg1_bg0000').setOrigin(0, 0),
                ]);
                this.add(this.bg);
                this.bg.x = 0;
                this.scene.tweens.add({
                    targets: this.bg,
                    x: -728,
                    duration: 40000,
                    ease: Phaser.Math.Easing.Linear,
                    repeat: -1
                });
                this.hs_top_bg = new Phaser.GameObjects.Container(this.scene, 240, 60, [
                    new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'hs_top_bg0000')
                ]);
                this.add(this.hs_top_bg);
                let hs_label = this.scene.add.text(0, -3, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 35,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                hs_label.setOrigin(0.5, 0.5);
                this.hs_top_bg.add(hs_label);
                nscs.gameplay.Gameplay.setText(hs_label, 'HighScoresTitle');
                this.btnCancel = new Phaser.GameObjects.Container(this.scene, 0, 0);
                this.add(this.btnCancel);
                this.btnCancel.add(this.btnCancel['-img-'] = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'btn_back' + '0000'));
                let cancel_label = this.scene.add.text(0, -5, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 19,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                cancel_label.setOrigin(0.5, 0.5);
                this.btnCancel.add(cancel_label);
                nscs.gameplay.Gameplay.setText(cancel_label, 'CancelBtn');
                this.btnRetry = new Phaser.GameObjects.Container(this.scene, 0, 0);
                this.add(this.btnRetry);
                this.btnRetry.add(this.btnRetry['-img-'] = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'btn_back' + '0000'));
                let retry_label = this.scene.add.text(0, -5, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 19,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                retry_label.setOrigin(0.5, 0.5);
                this.btnRetry.add(retry_label);
                nscs.gameplay.Gameplay.setText(retry_label, 'RetryBtn');
                this.txt = this.scene.add.text(game.scale.width / 2, 0, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 13,
                    "color": "#00436F",
                    "align": 'center'
                });
                this.txt.setOrigin(0.5, 0.5);
                this.add(this.txt);
                this.txt.setLineSpacing(5);
                this.txt.setWordWrapWidth(275);
                this.btnCancel['-img-'].setInteractive({ cursor: 'pointer' });
                this.btnCancel['-img-'].once('pointerup', () => {
                    nscs.scene.MainScene.instance.switchScreen(new nscs.screen.MainMenuScreen(this.scene));
                    nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                });
                this.btnRetry['-img-'].setInteractive({ cursor: 'pointer' });
                this.btnRetry['-img-'].on('pointerup', () => {
                    this.switchState(true);
                    nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                });
                this.switchState(true);
            }
            switchState(loading) {
                if (loading) {
                    this.btnCancel.x = game.scale.width / 2;
                    this.btnCancel.y = 210;
                    this.btnRetry.visible = false;
                    this.txt.y = 160;
                    nscs.gameplay.Gameplay.setText(this.txt, 'HighScoresConnecting');
                    this.hs_top_bg.visible = false;
                    nscs.util.Functions.delayedCall(5000, () => {
                        if (!this.parentContainer)
                            return;
                        this.switchState(false);
                    });
                }
                else {
                    this.btnCancel.x = game.scale.width / 2 - 90;
                    this.btnCancel.y = 250;
                    this.btnRetry.x = game.scale.width / 2 + 90;
                    this.btnRetry.y = 250;
                    this.btnRetry.visible = true;
                    this.txt.y = 150;
                    nscs.gameplay.Gameplay.setText(this.txt, 'HighScoresUnreachable');
                    this.hs_top_bg.visible = true;
                }
            }
        }
        screen.HigscoreScreen = HigscoreScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class InGameUI extends screen.BaseScreen {
            constructor(scene) {
                super(scene);
                this.speechDialog = null;
                this.bg = new Phaser.GameObjects.Graphics(this.scene);
                this.bg.setPosition(0, 0);
                this.bg.fillStyle(0x323232, 1);
                this.bg.fillRect(0, 0, game.scale.width, game.scale.height);
                this.add(this.bg);
                this.bg.visible = false;
                //---------------------topUI---------------------//
                this.topUI = new Phaser.GameObjects.Container(this.scene, 0, 0);
                this.add(this.topUI);
                this.charName_txt = this.scene.add.text(9, 9, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 12,
                    "color": "#FFFFFF",
                    "align": 'left',
                    "stroke": "#000000",
                    "strokeThickness": 2
                });
                this.charName_txt.setOrigin(0, 0.5);
                this.topUI.add(this.charName_txt);
                this.score_txt = this.scene.add.text(9, 27, "0000000", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 12,
                    "color": "#FFFFFF",
                    "align": 'left',
                    "stroke": "#000000",
                    "strokeThickness": 2
                });
                this.score_txt.setOrigin(0, 0.5);
                this.topUI.add(this.score_txt);
                let x_txt = this.scene.add.text(170, 27, "x", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 12,
                    "color": "#FFFFFF",
                    "align": 'left',
                    "stroke": "#000000",
                    "strokeThickness": 2
                });
                x_txt.setOrigin(0.5, 0.5);
                this.topUI.add(x_txt);
                this.topUI.add(new Phaser.GameObjects.Image(this.scene, 145, 27, 'objects-atlas', 'tinyChickMC0000'));
                this.chicks_txt = this.scene.add.text(185, 27, "00", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 11,
                    "color": "#FFFFFF",
                    "align": 'left',
                    "stroke": "#000000",
                    "strokeThickness": 2
                });
                this.chicks_txt.setOrigin(0, 0.5);
                this.topUI.add(this.chicks_txt);
                this.World_txt = this.scene.add.text(305, 9, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 11,
                    "color": "#FFFFFF",
                    "align": 'center',
                    "stroke": "#000000",
                    "strokeThickness": 2
                });
                this.World_txt.setOrigin(0.5, 0.5);
                this.topUI.add(this.World_txt);
                nscs.gameplay.Gameplay.setText(this.World_txt, 'World');
                this.world_txt = this.scene.add.text(305, 27, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 11,
                    "color": "#FFFFFF",
                    "align": 'center',
                    "stroke": "#000000",
                    "strokeThickness": 2
                });
                this.world_txt.setOrigin(0.5, 0.5);
                this.topUI.add(this.world_txt);
                this.Time_txt = this.scene.add.text(470, 9, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 11,
                    "color": "#FFFFFF",
                    "align": 'right',
                    "stroke": "#000000",
                    "strokeThickness": 2
                });
                this.Time_txt.setOrigin(1, 0.5);
                this.topUI.add(this.Time_txt);
                nscs.gameplay.Gameplay.setText(this.Time_txt, 'Time');
                this.timer_txt = this.scene.add.text(470, 27, "0", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 11,
                    "color": "#FFFFFF",
                    "align": 'right',
                    "stroke": "#000000",
                    "strokeThickness": 2
                });
                this.timer_txt.setOrigin(1, 0.5);
                this.topUI.add(this.timer_txt);
                //---------------------newWorldScreen_mc---------------------//
                this.newWorldScreen_mc = new Phaser.GameObjects.Container(this.scene, 0, 0);
                this.add(this.newWorldScreen_mc);
                let World_txt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2 - 25, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 15,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                World_txt.setOrigin(0.5, 0.5);
                this.newWorldScreen_mc.add(World_txt);
                nscs.gameplay.Gameplay.setText(World_txt, 'World');
                this.newWorldScreen_mc["World_txt"] = World_txt;
                let charIcon_mc = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 35, game.scale.height / 2 + 25, 'ui-atlas', 'charIcon_mc' + '0000');
                this.newWorldScreen_mc['charIcon_mc'] = charIcon_mc;
                this.newWorldScreen_mc.add(charIcon_mc);
                this.gotoAndStop_charIcon_mc(nscs.scene.MainScene.instance.gameplay.character);
                this.newWorldScreen_mc.add(this.scene.add.text(game.scale.width / 2, game.scale.height / 2 + 25, "x", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 18,
                    "color": "#FFFFFF",
                    "align": 'center'
                }).setOrigin(0.5, 0.5));
                let lives_txt = this.scene.add.text(game.scale.width / 2 + 20, game.scale.height / 2 + 25, "0", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 18,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                lives_txt.setOrigin(0, 0.5);
                this.newWorldScreen_mc.add(lives_txt);
                this.newWorldScreen_mc["lives_txt"] = lives_txt;
                this.newWorldScreen_mc.visible = false;
                //pause
                this.pauseScreen = new nscs.screen.PauseScreen(this.scene);
                this.add(this.pauseScreen);
                //---------------------timeover_mc---------------------//
                this.timeover_mc = new Phaser.GameObjects.Container(this.scene, 0, 0);
                this.add(this.timeover_mc);
                let bg = new Phaser.GameObjects.Graphics(this.scene);
                bg.setPosition(0, 0);
                bg.fillStyle(0x000000, 0.4);
                bg.fillRect(0, 0, game.scale.width, game.scale.height);
                this.timeover_mc.add(bg);
                let TimeOver_txt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 33,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                TimeOver_txt.setOrigin(0.5, 0.5);
                TimeOver_txt.setStroke('#000000', 3);
                this.timeover_mc.add(TimeOver_txt);
                nscs.gameplay.Gameplay.setText(TimeOver_txt, 'TimeOver');
                this.timeover_mc['TimeOver_txt'] = TimeOver_txt;
                this.timeover_mc.visible = false;
            }
            setScore(scores) {
                this.score_txt.setText(nscs.util.Functions.pad(scores, 7, 0));
            }
            setChicks(chicks) {
                this.chicks_txt.setText(nscs.util.Functions.pad(chicks, 2, 0));
            }
            setCharacterName(characterType, lives) {
                nscs.gameplay.Gameplay.setText(this.charName_txt, characterType);
                this.charName_txt.setText(this.charName_txt.text + " x " + lives);
            }
            showNewWorldScreen() {
                nscs.gameplay.Gameplay.setText(this.newWorldScreen_mc["World_txt"], 'World');
                nscs.util.Functions.updateTextFieldPosition(this.newWorldScreen_mc["World_txt"], this.newWorldScreen_mc["World_txt"].text + " " + this.world_txt.text);
                nscs.util.Functions.updateTextFieldPosition(this.newWorldScreen_mc["lives_txt"], this.charName_txt.text.split(" x ")[1]);
                this.newWorldScreen_mc.visible = true;
                this.bg.visible = true;
                return this;
            }
            hideNewWorldScreen() {
                this.newWorldScreen_mc.visible = false;
                this.bg.visible = false;
                return this;
            }
            gotoAndStop_charIcon_mc(label) {
                let labels_map = {
                    'chickette': 'charIcon_mc' + '0000',
                    'nugget': 'charIcon_mc' + '0009',
                    'pam': 'charIcon_mc' + '0019'
                };
                this.newWorldScreen_mc['charIcon_mc'].setFrame(labels_map[label]);
                return this;
            }
            showSpeechDialog(x, textContent) {
                this.hideSpeechDialog();
                this.speechDialog = new Phaser.GameObjects.Container(this.scene, game.scale.width / 2, 136);
                this.add(this.speechDialog);
                this.speechDialog['startX'] = x;
                let bubblex_mc = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'bubblex_mc' + '0000');
                bubblex_mc.setOrigin(0.5, 1);
                this.speechDialog.add(bubblex_mc);
                this.speechDialog["bubblex_mc"] = bubblex_mc;
                let mouthPiece_mc = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'mouthPiece_mc' + '0000');
                mouthPiece_mc.setOrigin(0.5, 1);
                this.speechDialog.add(mouthPiece_mc);
                this.speechDialog["mouthPiece_mc"] = mouthPiece_mc;
                let barMask = new Phaser.GameObjects.Graphics(this.scene);
                let p = this.scene.cameras.main.getWorldPoint(this.speechDialog.x, this.speechDialog.y);
                barMask.setPosition(p.x, p.y);
                barMask.fillStyle(0xFFFFFF, 1);
                barMask.fillRect(-400 / 2, -mouthPiece_mc.height, 400, mouthPiece_mc.height);
                mouthPiece_mc.setMask(barMask.createGeometryMask());
                mouthPiece_mc['barMask'] = barMask;
                this.prevBarMaskPosX = barMask.x;
                this.speechDialog.alpha = 0.5;
                barMask.scale = this.speechDialog.scale = 0;
                this.scene.tweens.add({
                    targets: [this.speechDialog, barMask],
                    duration: 500,
                    scale: 1,
                    alpha: 1,
                    ease: Phaser.Math.Easing.Back.Out
                });
                this.add(this.speechDialog);
                let tf = this.scene.add.text(-222, -120, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 11,
                    "color": "#000000",
                    "align": 'left'
                });
                tf.setOrigin(0, 0);
                tf.setWordWrapWidth(455);
                this.speechDialog.add(tf);
                let textTyper = new nscs.util.TextTyper(this.scene, tf, null);
                textTyper.typeText(textContent);
                this.speechDialog['textTyper'] = textTyper;
            }
            updateSpeechDialog(x) {
                let p = this.scene.cameras.main.getWorldPoint(this.speechDialog.x, this.speechDialog.y);
                this.speechDialog["mouthPiece_mc"]['barMask'].setPosition(this.prevBarMaskPosX + (p.x - this.prevBarMaskPosX) * 2, p.y);
                this.prevBarMaskPosX = p.x;
                this.speechDialog["mouthPiece_mc"].x = this.speechDialog['startX'] - x;
            }
            hideSpeechDialog() {
                if (this.speechDialog) {
                    this.speechDialog['textTyper'].stop();
                    this.remove(this.speechDialog);
                    this.speechDialog = null;
                }
            }
            tweenTextField(txt, to, duration, render = null) {
                txt['-to-'] = parseInt(txt.text);
                if (isNaN(txt['-to-']))
                    txt['-to-'] = 0;
                if (!render)
                    render = () => {
                        nscs.util.Functions.updateTextFieldPosition(txt, String(Math.round(txt['-to-'])));
                    };
                let ticker = 0;
                this.scene.tweens.add({
                    targets: txt,
                    '-to-': to,
                    duration: duration,
                    ease: Phaser.Math.Easing.Linear,
                    onComplete: render,
                    onUpdate: () => {
                        if (ticker++ % 2 == 0)
                            nscs.sound.SoundManager.getInstance().playSound('tickerSND');
                        render();
                    }
                });
            }
            tweenScore(to, duration) {
                this.tweenTextField(this.score_txt, to, duration, () => {
                    this.setScore(Math.round(this.score_txt['-to-']));
                });
            }
            tweenTimer(to, duration) {
                this.tweenTextField(this.timer_txt, to, duration);
            }
        }
        screen.InGameUI = InGameUI;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class InstructionScreen extends screen.BaseScreen {
            constructor(scene) {
                super(scene);
                this.alreadySkipped = false;
                this.skip = () => {
                    if (this.alreadySkipped)
                        return;
                    this.alreadySkipped = true;
                    nscs.scene.MainScene.instance.switchScreen(new nscs.screen.ChooseCharacterScreen(this.scene));
                    nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                };
                this.bg = new Phaser.GameObjects.Image(this.scene, -1, -1, 'ui-atlas', 'bg_story' + '0000');
                this.bg.setOrigin(0, 0);
                this.add(this.bg);
                this.bg.setInteractive({ cursor: 'pointer' });
                this.bg.once('pointerup', this.skip);
                this.nextBtn = new Phaser.GameObjects.Image(this.scene, 240, 160, 'ui-atlas', 'btn_next_story' + '0000');
                this.add(this.nextBtn);
                this.nextBtn.setInteractive({ cursor: 'pointer' });
                this.nextBtn.once('pointerup', this.skip);
                let label_next = this.scene.add.text(this.nextBtn.x, this.nextBtn.y - 5, "", {
                    "fontFamily": "ArcadeClassic",
                    "fontSize": 22,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                label_next.setOrigin(0.5, 0.5);
                this.add(label_next);
                // nscs.gameplay.Gameplay.setText(label_next, 'NextBtn');
                label_next.setText('CLICK HERE');
                let label_Instruct1 = this.scene.add.text(30, 25, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 10,
                    "color": "#FFFFFF",
                    "align": 'right',
                    "lineSpacing": 7
                });
                label_Instruct1.setWordWrapWidth(325);
                this.add(label_Instruct1);
                nscs.gameplay.Gameplay.setText(label_Instruct1, 'Instruct1');
                let label_Instruct2 = this.scene.add.text(160, 200, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 10,
                    "color": "#FFFFFF",
                    "align": 'left',
                    "lineSpacing": 7
                });
                label_Instruct2.setWordWrapWidth(325);
                this.add(label_Instruct2);
                nscs.gameplay.Gameplay.setText(label_Instruct2, 'Instruct2');
                let story_cheif = new Phaser.GameObjects.Image(this.scene, 400, 100, 'ui-atlas', 'story_cheif' + '0000');
                this.add(story_cheif);
                this.add(new Phaser.GameObjects.Image(this.scene, 75, 210, 'ui-atlas', 'pam_sel' + '0000').setOrigin(0.5, 0.5));
                let pam_mc_eye = scene.add.sprite(92, 185, 'ui-atlas');
                let pam_mc_eye_anim = 'pam_mc_eye_anim';
                if (!scene.anims.exists(pam_mc_eye_anim)) {
                    scene.anims.create({
                        key: pam_mc_eye_anim,
                        frames: scene.anims.generateFrameNames('ui-atlas', {
                            start: 0, end: 337, zeroPad: 4,
                            prefix: 'pam_mc_eye', suffix: ''
                        }),
                        frameRate: 60,
                        repeat: -1
                    });
                }
                pam_mc_eye.play(pam_mc_eye_anim);
                this.add(pam_mc_eye);
            }
            destroy(fromScene) {
                nscs.util.Functions.destroyDelayedCall(this.dc);
                super.destroy(fromScene);
            }
            updateScreen() {
                super.updateScreen();
                if (!this.alreadySkipped) {
                    if (nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased()) {
                        nscs.scene.MainScene.instance.inputController.escPressUsed();
                        nscs.scene.MainScene.instance.switchScreen(new screen.MainMenuScreen(this.scene));
                    }
                }
            }
        }
        screen.InstructionScreen = InstructionScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class MainMenuScreen extends screen.BaseScreen {
            constructor(scene) {
                super(scene);
                this.onPamCancel = () => {
                    this.setPamCodeEnterVisible(false);
                    nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                };
                this.onPamOK = () => {
                    let code = nscs.util.Functions.trim(this.code_txt.getText().toLowerCase());
                    this.setPamCodeEnterVisible(false);
                    let nextWorldNo = -1;
                    switch (code) {
                        case "test1":
                            nextWorldNo = 1;
                            break;
                        case "test2":
                            nextWorldNo = 2;
                            break;
                        case "test3":
                            nextWorldNo = 3;
                            break;
                        case "test4":
                            nextWorldNo = 4;
                            break;
                        case "test5":
                            nextWorldNo = 5;
                            break;
                        case "test51":
                            nextWorldNo = 5.1;
                            break;
                        case "gopam!":
                        case "gopam":
                        case "GOPAM":
                            nscs.gameplay.Gameplay.isPamLocked = false;
                            nscs.scene.MainScene.instance.playAsPam();
                            nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                            sendEvent(petaGA_GameCategory_Game, 'Enter Code', 'Super Chick Sisters - Enter Code GoPam!');
                            return;
                    }
                    if (nextWorldNo != -1) {
                        nscs.scene.MainScene.instance.resetGameplay();
                        nscs.scene.MainScene.instance.setWorldsNumber(Math.floor(nextWorldNo), String(nextWorldNo));
                        nscs.scene.MainScene.instance.switchScreen(new nscs.screen.ChooseCharacterScreen(this.scene));
                        nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                    }
                };
                this.add(new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'bluebg0000').setOrigin(0, 0));
                let clouds = [
                    new Phaser.GameObjects.Image(this.scene, 100, 185, 'ui-atlas', 'cloud0000'),
                    new Phaser.GameObjects.Image(this.scene, 550, 55, 'ui-atlas', 'cloud0000').setScale(0.65).setAlpha(0.5),
                    new Phaser.GameObjects.Image(this.scene, 500, 130, 'ui-atlas', 'cloud0000').setScale(0.8).setAlpha(0.75),
                    new Phaser.GameObjects.Image(this.scene, 350, 20, 'ui-atlas', 'cloud0000').setScale(0.5).setAlpha(0.5)
                ];
                this.add(clouds);
                for (let c of clouds) {
                    c.setOrigin(0, 0);
                    c['defX'] = c.x;
                    let fn = () => {
                        if (!this.scene)
                            return;
                        this.scene.tweens.add({
                            targets: c,
                            x: -c.width,
                            duration: Math.random() * 10000 + 25000,
                            ease: Phaser.Math.Easing.Linear,
                            onComplete: () => {
                                c.x = c['defX'] + 480;
                                fn();
                            }
                        });
                    };
                    fn();
                }
                this.add(new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'bg_mc' + '0000').setOrigin(0, 0));
                this.add(new Phaser.GameObjects.Image(this.scene, 56, 4, 'ui-atlas', 'scs_logo' + '0000').setOrigin(0, 0));
                this.add(new Phaser.GameObjects.Image(this.scene, 260, 140, 'ui-atlas', 'ANI_Chickette_wholeMC' + '0000').setOrigin(0, 0));
                this.add(new Phaser.GameObjects.Image(this.scene, 350, 172, 'ui-atlas', 'ANI_Nugget_wholeMC' + '0000').setOrigin(0, 0));
                this.add(new Phaser.GameObjects.Image(this.scene, 306, 160, 'ui-atlas', 'pic_c' + '0000').setOrigin(0.5, 0.5));
                this.add(new Phaser.GameObjects.Image(this.scene, 388.5, 187.5, 'ui-atlas', 'pic_n' + '0000').setOrigin(0.5, 0.5));
                let scs_logo_blink = this.scene.add.sprite(275, 90, 'ui-atlas');
                scs_logo_blink.setScale(2);
                let scs_logo_blink_anim = 'scs_logo_blink_anim';
                if (!this.scene.anims.exists(scs_logo_blink_anim)) {
                    this.scene.anims.create({
                        key: scs_logo_blink_anim,
                        frames: this.scene.anims.generateFrameNames('ui-atlas', {
                            start: 0, end: 327, zeroPad: 4,
                            prefix: 'scs_logo_blink', suffix: ''
                        }),
                        frameRate: 60,
                        repeat: -1
                    });
                }
                scs_logo_blink.play(scs_logo_blink_anim);
                this.add(scs_logo_blink);
                this.buttons = [];
                let btnKeys = ['btn_newgame', 'btn_entercode'];
                let i = 0;
                let btnsY = 195 + 16;
                for (let key of btnKeys) {
                    let btn = nscs.scene.MainScene.instance.factory.createTypicalButton(105, btnsY + i * 33, key);
                    btn.setOrigin(0, 0);
                    this.buttons.push(btn);
                    this.add(btn);
                    btn[key == btnKeys[0] ? 'once' : 'on']('pointerup', () => {
                        if (key == 'btn_newgame') {
                            nscs.scene.MainScene.instance.resetGameplay();
                            nscs.scene.MainScene.instance.switchScreen(new nscs.screen.InstructionScreen(scene));
                            nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                            sendEvent(petaGA_GameCategory_Game, 'New Game', 'Super Chick Sisters - New Game');
                        }
                        else if (key == 'btn_entercode') {
                            this.setPamCodeEnterVisible(true);
                        }
                    });
                    btn.on('pointerover', () => {
                        nscs.sound.SoundManager.getInstance().playSound('coinSND', 0.5);
                    });
                    i++;
                }
                this.add(MainMenuScreen.createEye(290, 205, this.scene, 200));
                this.add(MainMenuScreen.createEye(320, 205, this.scene, 200));
                this.add(MainMenuScreen.createEye(370, 224, this.scene, 1100));
                this.add(MainMenuScreen.createEye(395, 227, this.scene, 1100));
                this.enterCodeContainer = new Phaser.GameObjects.Container(this.scene, 150, 235);
                this.add(this.enterCodeContainer);
                this.enterCodeContainer.visible = false;
                let e = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'enterCode_bg' + '0000');
                e.setScale(0.9);
                this.enterCodeContainer.add(e);
                e.setInteractive();
                let enterCode_btn_cancel = nscs.scene.MainScene.instance.factory.createTypicalButton(-50, 33, 'btn_cancel');
                this.enterCodeContainer.add(enterCode_btn_cancel);
                let enterCode_btn_ok = nscs.scene.MainScene.instance.factory.createTypicalButton(65, 33, 'btn_ok');
                this.enterCodeContainer.add(enterCode_btn_ok);
                let pam_label = this.scene.add.text(0, -37, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 10,
                    "color": "#333333",
                    "align": 'center'
                });
                if (nscs.gameplay.Gameplay.currentLanguage == "ES" || nscs.gameplay.Gameplay.currentLanguage == "SK") {
                    pam_label.y = -45;
                }
                pam_label.setOrigin(0.5, 0);
                this.enterCodeContainer.add(pam_label);
                pam_label.setWordWrapWidth(200);
                nscs.gameplay.Gameplay.setText(pam_label, 'EnterCodePrompt');
                let enterCode_txtinputbg = new Phaser.GameObjects.Image(this.scene, 0, 8, 'ui-atlas', 'enterCode_txtinputbg' + '0000');
                this.enterCodeContainer.add(enterCode_txtinputbg);
                enterCode_btn_cancel.setInteractive({ cursor: 'pointer' });
                enterCode_btn_cancel.on('pointerup', this.onPamCancel);
                enterCode_btn_cancel.on('pointerover', () => {
                    nscs.sound.SoundManager.getInstance().playSound('whistleSND');
                });
                enterCode_btn_ok.setInteractive({ cursor: 'pointer' });
                enterCode_btn_ok.on('pointerup', this.onPamOK);
                enterCode_btn_ok.on('pointerover', () => {
                    nscs.sound.SoundManager.getInstance().playSound('whistleSND');
                });
                this.code_txt = new nscs.input.InputTextField(this.scene);
                this.code_txt.setPosition(-80, enterCode_txtinputbg.y);
                this.enterCodeContainer.add(this.code_txt);
            }
            setPamCodeEnterVisible(visible) {
                this.enterCodeContainer.visible = visible;
                for (let b of this.buttons)
                    b.visible = !visible;
                if (visible) {
                    this.code_txt.initializeInput();
                }
                else {
                    this.code_txt.destroyInput();
                }
                this.code_txt.setText('');
            }
            static createEye(x, y, scene, delay = 0) {
                let blinking_eye = scene.add.sprite(x, y, 'ui-atlas', 'blinking_eye0000');
                let blinking_eye_anim = 'blinking_eye_anim';
                if (!scene.anims.exists(blinking_eye_anim)) {
                    scene.anims.create({
                        key: blinking_eye_anim,
                        frames: scene.anims.generateFrameNames('ui-atlas', {
                            start: 0, end: 260, zeroPad: 4,
                            prefix: 'blinking_eye', suffix: ''
                        }),
                        frameRate: 60,
                        repeat: -1
                    });
                }
                nscs.util.Functions.delayedCall(delay, () => {
                    if (!blinking_eye.parentContainer)
                        return;
                    blinking_eye.play(blinking_eye_anim);
                });
                return blinking_eye;
            }
            updateScreen() {
                super.updateScreen();
                if (nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased()) {
                    if (this.enterCodeContainer.visible) {
                        this.setPamCodeEnterVisible(false);
                    }
                    nscs.scene.MainScene.instance.inputController.escPressUsed();
                }
                else if (nscs.scene.MainScene.instance.inputController.enterPressedDownAndReleased() && this.enterCodeContainer.visible) {
                    nscs.scene.MainScene.instance.inputController.enterPressUsed();
                    requestAnimationFrame(this.onPamOK);
                }
            }
        }
        screen.MainMenuScreen = MainMenuScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class PauseScreen extends screen.BaseScreen {
            constructor(scene) {
                super(scene);
                //---------------------pause---------------------//
                let bg = new Phaser.GameObjects.Graphics(this.scene);
                bg.setPosition(0, 0);
                bg.fillStyle(0x000000, 0.4);
                bg.fillRect(0, 0, game.scale.width, game.scale.height);
                this.add(bg);
                let GamePaused_txt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2 - 25, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 33,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                GamePaused_txt.setOrigin(0.5, 0.5);
                GamePaused_txt.setStroke('#000000', 5);
                this.add(GamePaused_txt);
                nscs.gameplay.Gameplay.setText(GamePaused_txt, 'Paused');
                let _QuitBtn = new Phaser.GameObjects.Image(this.scene, 139, 194, 'ui-atlas', 'btn_next_story' + '0000');
                this.add(_QuitBtn);
                let QuitBtn_txt = this.scene.add.text(_QuitBtn.x, _QuitBtn.y - 5, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 19,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                QuitBtn_txt.setOrigin(0.5, 0.5);
                this.add(QuitBtn_txt);
                nscs.gameplay.Gameplay.setText(QuitBtn_txt, 'QuitBtn');
                let _ResumeBtn = new Phaser.GameObjects.Image(this.scene, 354, 194, 'ui-atlas', 'btn_next_story' + '0000');
                this.add(_ResumeBtn);
                let Resume_txt = this.scene.add.text(_ResumeBtn.x, _ResumeBtn.y - 5, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 19,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                Resume_txt.setOrigin(0.5, 0.5);
                this.add(Resume_txt);
                nscs.gameplay.Gameplay.setText(Resume_txt, 'ResumeBtn');
                _QuitBtn.setInteractive({ cursor: 'pointer' });
                _QuitBtn.on('pointerup', () => {
                    this.onQuit();
                    nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                });
                _QuitBtn.on('pointerover', () => {
                    nscs.sound.SoundManager.getInstance().playSound('whistleSND');
                });
                _QuitBtn.setScrollFactor(0);
                _ResumeBtn.setInteractive({ cursor: 'pointer' });
                _ResumeBtn.on('pointerup', () => {
                    this.onResume();
                    nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                });
                _ResumeBtn.on('pointerover', () => {
                    nscs.sound.SoundManager.getInstance().playSound('whistleSND');
                });
                _ResumeBtn.setScrollFactor(0);
                this.hidePauseGame();
            }
            showPauseGame() {
                this.visible = true;
            }
            hidePauseGame() {
                this.visible = false;
            }
        }
        screen.PauseScreen = PauseScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class Preloader extends Phaser.GameObjects.Container {
            constructor(scene) {
                super(scene);
                this.add(new Phaser.GameObjects.Image(this.scene, 125, 161, Preloader.ATLAS, 'loaded_mc' + '0000').setOrigin(0, 0));
                this.add(new Phaser.GameObjects.Image(this.scene, 125, 140, Preloader.ATLAS, 'loadingtxt' + '0000').setOrigin(0, 0));
                let preloader_burger = new Phaser.GameObjects.Sprite(this.scene, 305, 130, Preloader.ATLAS, 'preloader_burger' + '0000');
                let preloader_burger_playing = 'preloader_burger_playing';
                this.scene.anims.create({
                    key: preloader_burger_playing,
                    frames: this.scene.anims.generateFrameNames(Preloader.ATLAS, {
                        start: 0, end: 69, zeroPad: 4,
                        prefix: 'preloader_burger', suffix: ''
                    }),
                    frameRate: 24, repeat: -1
                });
                preloader_burger.anims.play(preloader_burger_playing);
                this.add(preloader_burger);
                this.bar = new Phaser.GameObjects.Image(this.scene, 125, 161, Preloader.ATLAS, 'preloader_bar' + '0000');
                this.bar.setOrigin(0, 0);
                this.add(this.bar);
                this.barMask = new Phaser.GameObjects.Graphics(this.scene);
                this.barMask.setPosition(this.bar.x, this.bar.y);
                this.barMask.fillStyle(0xFFFFFF, 1);
                this.barMask.fillRect(0, 0, this.bar.width, this.bar.height);
                this.bar.setMask(this.barMask.createGeometryMask());
                sendEvent(petaGA_GameCategory_Game, 'Load', 'Super Chick Sisters - Load');
            }
            updateProgress(progress) {
                this.barMask.scaleX = progress;
            }
        }
        Preloader.ATLAS = 'preloader-atlas';
        screen.Preloader = Preloader;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        var MainScene = nscs.scene.MainScene;
        class StorySlides extends screen.BaseScreen {
            constructor(scene, storyIndex, onComplete) {
                super(scene);
                this.delayedCalls = [];
                this.add(this.createGraphicsRect(0x0));
                this.slidesContainter = new Phaser.GameObjects.Container(this.scene, 0, 0);
                this.add(this.slidesContainter);
                this.btnNext = new Phaser.GameObjects.Image(this.scene, 464 - 26, 303, 'stories', 'btn_change_slide' + '0000');
                this.add(this.btnNext);
                this.btnPrev = new Phaser.GameObjects.Image(this.scene, 464 - 26 - 22, 303, 'stories', 'btn_change_slide' + '0000');
                this.btnPrev.setScale(-1, 1);
                this.add(this.btnPrev);
                this.text = this.scene.add.text(15, 250, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 10,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                this.text.setWordWrapWidth(440);
                this.text.setOrigin(0, 0);
                this.add(this.text);
                this.textTyper = new nscs.util.TextTyper(this.scene, this.text, () => {
                    this.delayedCalls.push(nscs.util.Functions.delayedCall(2000, () => this.showNextSlide()));
                });
                this.slides = StorySlides.STORY_DATA[storyIndex];
                this.slidesNum = StorySlides.STORY_DATA[storyIndex].length;
                this.slideIndex = -1;
                this.showNextSlide();
                let outAlpha = 0.65;
                this.btnNext.alpha = outAlpha;
                this.btnNext.setInteractive({ cursor: 'pointer' });
                this.btnNext.on('pointerup', () => {
                    this.showNextSlide();
                });
                this.btnNext.on('pointerover', () => {
                    this.btnNext.alpha = 1;
                });
                this.btnNext.on('pointerout', () => {
                    this.btnNext.alpha = outAlpha;
                });
                this.btnPrev.alpha = outAlpha;
                this.btnPrev.setInteractive({ cursor: 'pointer' });
                this.btnPrev.on('pointerup', () => {
                    this.showPrevSlide();
                });
                this.btnPrev.on('pointerover', () => {
                    this.btnPrev.alpha = 1;
                });
                this.btnPrev.on('pointerout', () => {
                    this.btnPrev.alpha = outAlpha;
                });
                this.onComplete = onComplete;
            }
            createGraphicsRect(color) {
                let r = new Phaser.GameObjects.Graphics(this.scene);
                r.setPosition(0, 0);
                r.fillStyle(color, 1);
                r.fillRect(0, 0, game.scale.width, game.scale.height);
                return r;
            }
            showFgTransition(onComplete) {
                let fg = this.createGraphicsRect(0x323232);
                MainScene.instance.children.add(fg);
                fg.alpha = 0;
                this.scene.tweens.add({
                    targets: fg,
                    'alpha': 1,
                    duration: 1500,
                    onComplete: () => {
                        this.visible = false;
                        MainScene.instance.children.remove(fg);
                        onComplete();
                    }
                });
                fg.setScrollFactor(0);
            }
            showNextSlide() {
                if (this.slideIndex >= this.slidesNum - 1) {
                    if (this.onComplete) {
                        nscs.sound.SoundManager.getInstance().fadeMusic(null, 1500);
                        this.showFgTransition(this.onComplete);
                        this.onComplete = null;
                    }
                    return;
                }
                this.slideIndex++;
                let slide;
                if (this.slidesContainter.length > this.slideIndex) {
                    slide = this.slidesContainter.getAt(this.slideIndex);
                }
                else {
                    if (this.slides[this.slideIndex].hasOwnProperty('image')) {
                        slide = new Phaser.GameObjects.Container(this.scene);
                        let _slide = new Phaser.GameObjects.Image(this.scene, 0, 0, 'stories', this.slides[this.slideIndex]['image'] + '0000');
                        _slide.setOrigin(0, 0);
                        _slide.setInteractive({ cursor: 'pointer' });
                        _slide.on('pointerup', () => {
                            this.showNextSlide();
                        });
                        slide.add(this.createGraphicsRect(0x0));
                        slide.add(_slide);
                        slide["frame"] = { "name": _slide.frame.name };
                    }
                    else if (this.slides[this.slideIndex].hasOwnProperty('animationClass')) {
                        let animationClass = this.slides[this.slideIndex]['animationClass'];
                        if (animationClass == 'AnimationStory_6_1') {
                            slide = new screen.stories.AnimationStory_6_1(this.scene);
                        }
                        else if (animationClass == 'AnimationStory_6_2') {
                            slide = new screen.stories.AnimationStory_6_2(this.scene);
                        }
                        else if (animationClass == 'AnimationStory_2_1') {
                            slide = new screen.stories.AnimationStory_2_1(this.scene);
                        }
                        else if (animationClass == 'AnimationRunningCharacters_2') {
                            slide = new screen.stories.AnimationRunningCharacters_2(this.scene);
                        }
                        else if (animationClass == 'AnimationRunningCharacters_3') {
                            slide = new screen.stories.AnimationRunningCharacters_3(this.scene);
                        }
                        else if (animationClass == 'AnimationStory_4_1') {
                            slide = new screen.stories.AnimationStory_4_1(this.scene);
                        }
                        else if (animationClass == 'AnimationRunningCharacters_4') {
                            slide = new screen.stories.AnimationRunningCharacters_4(this.scene);
                        }
                        else if (animationClass == 'AnimationRunningCharacters_5') {
                            slide = new screen.stories.AnimationRunningCharacters_5(this.scene);
                        }
                    }
                }
                this.slidesContainter.add(slide);
                let prevSlide = null;
                if (this.slideIndex - 1 >= 0) {
                    prevSlide = this.slidesContainter.getAt(this.slideIndex - 1);
                    if (prevSlide.frame.name != slide.frame.name) {
                        /*this.scene.tweens.add({
                            targets: prevSlide,
                            'alpha': 0,
                            duration: 500
                        });*/
                    }
                    else {
                        this.scene.tweens.killTweensOf(prevSlide);
                        prevSlide.alpha = 0;
                    }
                }
                if (!prevSlide || prevSlide.frame.name != slide.frame.name) {
                    /*slide.alpha = 0;
                    this.scene.tweens.add({
                        targets: slide,
                        'alpha': 1,
                        duration: 500
                    });*/
                }
                else {
                    this.scene.tweens.killTweensOf(slide);
                    slide.alpha = 1;
                }
                if (this.slides[this.slideIndex].hasOwnProperty('text')) {
                    this.typeText();
                }
                else {
                    this.text.setText("");
                }
                this.refreshButtonsNextPrev();
                if (this.slides[this.slideIndex].hasOwnProperty('nextSlideDelay')) {
                    nscs.util.Functions.delayedCall(this.slides[this.slideIndex]["nextSlideDelay"], () => {
                        this.showNextSlide();
                    });
                }
                if (this.slides[this.slideIndex]['soundtrack']) {
                    nscs.sound.SoundManager.getInstance().fadeMusic(this.slides[this.slideIndex]['soundtrack'], 500, true);
                }
            }
            refreshButtonsNextPrev() {
                if (this.slides[this.slideIndex].hasOwnProperty('animationClass')) {
                    this.btnNext.visible = this.btnPrev.visible = false;
                }
                else {
                    this.btnNext.visible = true;
                    this.btnPrev.visible = this.slideIndex > 0 && !this.slides[this.slideIndex - 1].hasOwnProperty('animationClass');
                }
            }
            typeText() {
                this.textTyper.typeText(nscs.gameplay.Gameplay.getText(this.slides[this.slideIndex]['text']));
            }
            showPrevSlide() {
                let currSlide = this.slidesContainter.getAt(this.slideIndex);
                if (this.slideIndex < 1) {
                    this.typeText();
                    return;
                }
                this.slideIndex--;
                let prevSlide = this.slidesContainter.getAt(this.slideIndex);
                if (prevSlide.frame.name != currSlide.frame.name) {
                    /*this.scene.tweens.add({
                        targets: prevSlide,
                        'alpha': 1,
                        duration: 500
                    });*/
                    prevSlide.alpha = 1;
                    /*this.scene.tweens.add({
                        targets: currSlide,
                        'alpha': 0,
                        duration: 500
                    });*/
                    currSlide.alpha = 0;
                }
                else {
                    prevSlide.alpha = 1;
                    currSlide.alpha = 0;
                }
                if (this.slides[this.slideIndex].hasOwnProperty('text')) {
                    this.typeText();
                }
                else {
                    this.text.setText("");
                }
                this.refreshButtonsNextPrev();
            }
            destroy(fromScene) {
                for (let dc of this.delayedCalls) {
                    nscs.util.Functions.destroyDelayedCall(dc);
                }
                this.delayedCalls = [];
                this.textTyper.stop();
                super.destroy(fromScene);
            }
            updateScreen() {
                super.updateScreen();
                if (nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased()) {
                    nscs.scene.MainScene.instance.inputController.escPressUsed();
                    nscs.scene.MainScene.instance.switchScreen(new nscs.screen.ChooseCharacterScreen(this.scene));
                    nscs.sound.SoundManager.getInstance().fadeMusic(null, 500);
                }
                else if (nscs.scene.MainScene.instance.inputController.upPressedDownAndReleased()) {
                    nscs.scene.MainScene.instance.inputController.upPressUsed();
                    this.showNextSlide();
                }
            }
        }
        StorySlides.STORY_DATA = {
            1: [
                {
                    image: 'story_1_1',
                    text: 'cutscene0_1',
                    soundtrack: 'soundtrackCS0'
                },
                {
                    image: 'story_1_1',
                    text: 'cutscene0_1B',
                    soundtrack: 'soundtrackCS0'
                },
                {
                    image: 'story_1_2',
                    text: 'cutscene0_2',
                    soundtrack: 'soundtrackCS0'
                },
                {
                    image: 'story_1_3',
                    text: 'cutscene0_3',
                    soundtrack: 'soundtrackCS0'
                },
                {
                    image: 'story_1_4',
                    text: 'cutscene0_4',
                    soundtrack: 'soundtrackCS0'
                },
                {
                    image: 'story_1_5',
                    text: 'cutscene0_5',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_1_5',
                    text: 'cutscene0_5B',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_1_5',
                    text: 'cutscene0_6',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_1_6',
                    text: 'cutscene0_7',
                    soundtrack: 'soundtrackCS1'
                }
            ],
            2: [
                {
                    animationClass: 'AnimationStory_2_1',
                    text: 'cutscene1_1'
                },
                {
                    animationClass: 'AnimationRunningCharacters_2',
                    nextSlideDelay: 15000
                },
                {
                    image: 'story_2_2',
                    text: 'cutscene1_2',
                    soundtrack: 'soundtrackCS1'
                }
            ],
            3: [
                {
                    animationClass: 'AnimationRunningCharacters_3',
                    nextSlideDelay: 13500
                },
                {
                    image: 'story_3_1',
                    text: '',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_3_2',
                    text: '',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_3_3',
                    text: 'cutscene2_3',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_3_4',
                    text: '',
                    soundtrack: 'soundtrackCS1'
                }
            ],
            4: [
                {
                    animationClass: 'AnimationStory_4_1',
                    text: 'cutscene3_1'
                },
                {
                    animationClass: 'AnimationRunningCharacters_4',
                    nextSlideDelay: 11000
                },
                {
                    image: 'story_4_2',
                    text: 'cutscene3_2',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_4_3',
                    text: 'cutscene3_3',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_4_3',
                    text: 'cutscene3_3B',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_4_4',
                    text: 'cutscene3_4',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_4_5',
                    text: '',
                    soundtrack: 'soundtrackCS1'
                }
            ],
            5: [
                {
                    animationClass: 'AnimationRunningCharacters_5',
                    nextSlideDelay: 12500
                },
                {
                    image: 'story_5_1',
                    text: 'cutscene4_1',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_5_1',
                    text: 'cutscene4_1B',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_5_2',
                    text: 'cutscene4_2',
                    soundtrack: 'soundtrackCS1'
                }
            ],
            6: [
                {
                    animationClass: 'AnimationStory_6_1',
                    nextSlideDelay: 33000,
                    soundtrack: 'soundtrack6'
                },
                {
                    image: 'story_6_3',
                    text: '',
                    soundtrack: 'soundtrack6'
                },
            ]
        };
        screen.StorySlides = StorySlides;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        var stories;
        (function (stories) {
            class AnimationRunningCharacters_2 extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.frame = { name: 'AnimationRunningCharacters_2' };
                    this._bg = this.scene.add.image(-100, -100, 'bg-atlas', 'bg2' + '0000');
                    this._bg.setOrigin(0, 0);
                    this.ground0_1 = this.scene.add.image(game.scale.width / 2, 325, 'stories', 'ground0' + '0000');
                    this.ground0_1.setOrigin(0.5, 1);
                    this.ground0_2 = this.scene.add.image(this.ground0_1.x + this.ground0_1.width, this.ground0_1.y, 'stories', 'ground0' + '0000');
                    this.ground0_2.setOrigin(0.5, 1);
                    this._nuget = this.scene.add.sprite(-350, 300, 'stories', '_nuget' + '0000');
                    this._nuget.setOrigin(0.5, 1);
                    this._chick = this.scene.add.sprite(-200, 302, 'stories', '_chick' + '0000');
                    this._chick.setOrigin(0.5, 1);
                    this.add([this._bg, this.ground0_1, this.ground0_2, this._chick, this._nuget]);
                    this.scene.tweens.add({
                        targets: this._bg,
                        duration: 6000,
                        x: this._bg.x - 50,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this.ground0_1,
                        duration: 6000,
                        x: this.ground0_1.x - 200,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this.ground0_2,
                        duration: 6000,
                        x: this.ground0_2.x - 200,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this._nuget,
                        duration: 4000,
                        x: this._nuget.x + 875,
                    });
                    this.scene.tweens.add({
                        targets: this._chick,
                        duration: 4000,
                        x: this._chick.x + 825,
                        delay: 150
                    });
                    let anim = nscs.gameplay.Factory.createAnimName('_nuget', 'walking');
                    if (!this.scene.anims.exists(anim)) {
                        this.scene.anims.create({
                            key: anim,
                            frames: this.scene.anims.generateFrameNames(this._nuget.texture.key, {
                                start: 0, end: 30, zeroPad: 4,
                                prefix: '_nuget', suffix: ''
                            }),
                            repeat: -1,
                            frameRate: 60
                        });
                    }
                    nscs.util.Functions.delayedCall(150, () => {
                        this._nuget.play(anim);
                    });
                    let _anim = nscs.gameplay.Factory.createAnimName('_chick', 'walking');
                    if (!this.scene.anims.exists(_anim)) {
                        this.scene.anims.create({
                            key: _anim,
                            frames: this.scene.anims.generateFrameNames(this._chick.texture.key, {
                                start: 0, end: 30, zeroPad: 4,
                                prefix: '_chick', suffix: ''
                            }),
                            repeat: -1,
                            frameRate: 60
                        });
                    }
                    this._chick.play(_anim);
                    nscs.util.Functions.delayedCall(6000, () => {
                        this.showSecondPart();
                    });
                }
                showSecondPart() {
                    AnimationRunningCharacters_2.showDust(300, 450, this, 1);
                }
                static showDust(x, y, parent, ind) {
                    nscs.sound.SoundManager.getInstance().playMusic('scarySND', false);
                    let cnt = new Phaser.GameObjects.Container(parent.scene);
                    cnt.setPosition(x, y);
                    for (let i = 0; i < 15; i++) {
                        let dust = new Phaser.GameObjects.Image(parent.scene, 0, 0, 'stories', 'dust_' + '0000');
                        cnt.add(dust);
                        dust.alpha = 0;
                        parent.scene.tweens.add({
                            targets: dust,
                            duration: 10000,
                            y: dust.y - 750 - Math.random() * 200,
                            alpha: 1,
                            scale: 1 + Math.random() * 0.5,
                            delay: (Math.random() * 50 + 100) * i,
                            angle: Math.random() * 60
                        });
                        parent.scene.tweens.add({
                            targets: dust,
                            duration: 10000,
                            x: dust.x + (Math.random() - 0.5) * 275,
                            ease: Phaser.Math.Easing.Cubic.Out,
                            delay: (Math.random() * 250 + 650) * i
                        });
                    }
                    parent.addAt(cnt, ind);
                    return cnt;
                }
            }
            stories.AnimationRunningCharacters_2 = AnimationRunningCharacters_2;
        })(stories = screen.stories || (screen.stories = {}));
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        var stories;
        (function (stories) {
            class AnimationRunningCharacters_3 extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.frame = { name: 'AnimationRunningCharacters_3' };
                    this._bg = this.scene.add.image(-500, -500, 'bg-atlas', 'bg1' + '0000');
                    this._bg.setOrigin(0, 0);
                    this._bg.setScale(1.6);
                    this.ground0_1 = this.scene.add.image(game.scale.width / 2, 325, 'stories', 'ground4' + '0000');
                    this.ground0_1.setOrigin(0.5, 1);
                    this.ground0_2 = this.scene.add.image(this.ground0_1.x + this.ground0_1.width, this.ground0_1.y, 'stories', 'ground4' + '0000');
                    this.ground0_2.setOrigin(0.5, 1);
                    this._nuget = this.scene.add.sprite(-350, 300, 'stories', '_nuget' + '0000');
                    this._nuget.setOrigin(0.5, 1);
                    this._chick = this.scene.add.sprite(-200, 302, 'stories', '_chick' + '0000');
                    this._chick.setOrigin(0.5, 1);
                    this.add([this._bg, this.ground0_1, this.ground0_2, this._chick, this._nuget]);
                    this.scene.tweens.add({
                        targets: this._bg,
                        duration: 6000,
                        x: this._bg.x - 150,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this.ground0_1,
                        duration: 6000,
                        x: this.ground0_1.x - 200,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this.ground0_2,
                        duration: 6000,
                        x: this.ground0_2.x - 200,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this._nuget,
                        duration: 4000,
                        x: this._nuget.x + 875,
                    });
                    this.scene.tweens.add({
                        targets: this._chick,
                        duration: 4000,
                        x: this._chick.x + 825,
                        delay: 150
                    });
                    let anim = nscs.gameplay.Factory.createAnimName('_nuget', 'walking');
                    if (!this.scene.anims.exists(anim)) {
                        this.scene.anims.create({
                            key: anim,
                            frames: this.scene.anims.generateFrameNames(this._nuget.texture.key, {
                                start: 0, end: 30, zeroPad: 4,
                                prefix: '_nuget', suffix: ''
                            }),
                            repeat: -1,
                            frameRate: 60
                        });
                    }
                    nscs.util.Functions.delayedCall(150, () => {
                        this._nuget.play(anim);
                    });
                    let _anim = nscs.gameplay.Factory.createAnimName('_chick', 'walking');
                    if (!this.scene.anims.exists(_anim)) {
                        this.scene.anims.create({
                            key: _anim,
                            frames: this.scene.anims.generateFrameNames(this._chick.texture.key, {
                                start: 0, end: 30, zeroPad: 4,
                                prefix: '_chick', suffix: ''
                            }),
                            repeat: -1,
                            frameRate: 60
                        });
                    }
                    this._chick.play(_anim);
                    nscs.util.Functions.delayedCall(4500, () => {
                        this.showSecondPart();
                    });
                }
                showSecondPart() {
                    stories.AnimationRunningCharacters_2.showDust(300, 450, this, 1);
                    AnimationRunningCharacters_3.throwInstruments(300, 400, this, 1);
                }
                static throwInstruments(x, y, parent, ind) {
                    nscs.sound.SoundManager.getInstance().playSound('toolsSND', 0.5);
                    let cnt = new Phaser.GameObjects.Container(parent.scene);
                    cnt.setPosition(x, y);
                    for (let i = 0; i < 15; i++) {
                        let inst = new Phaser.GameObjects.Image(parent.scene, 0, 0, 'stories', 'instr_' + Math.ceil(Math.random() * 4) + '0000');
                        cnt.add(inst);
                        let d = (Math.random() * 100 + 200) * i;
                        parent.scene.tweens.add({
                            targets: inst,
                            duration: 1000,
                            y: inst.y - 200 - Math.random() * 150,
                            delay: d,
                            ease: Phaser.Math.Easing.Back.Out
                        });
                        parent.scene.tweens.add({
                            targets: inst,
                            duration: 2000,
                            x: inst.x + (Math.random() > 0.5 ? 1 : -1) * (350 + Math.random() * 100),
                            ease: Phaser.Math.Easing.Cubic.Out,
                            delay: d,
                            angle: Math.random() * 360 + 360
                        });
                    }
                    parent.addAt(cnt, ind);
                    let bucket_ = new Phaser.GameObjects.Image(parent.scene, 0, 0, 'stories', 'bucket_' + '0000');
                    cnt.add(bucket_);
                    let d = 2500;
                    parent.scene.tweens.add({
                        targets: bucket_,
                        duration: 750,
                        y: -145,
                        delay: d,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    bucket_.scale = 0.75;
                    parent.scene.tweens.add({
                        targets: bucket_,
                        duration: 1000,
                        x: 50,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        delay: d,
                        angle: 360,
                        scale: 1
                    });
                    return cnt;
                }
            }
            stories.AnimationRunningCharacters_3 = AnimationRunningCharacters_3;
        })(stories = screen.stories || (screen.stories = {}));
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        var stories;
        (function (stories) {
            class AnimationRunningCharacters_4 extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.frame = { name: 'AnimationRunningCharacters_4' };
                    this._bg = this.scene.add.image(-500, -500, 'bg-atlas', 'bg3' + '0000');
                    this._bg.setOrigin(0, 0);
                    this._bg.setScale(1.6);
                    this.ground0_1 = this.scene.add.image(game.scale.width / 2, 325, 'stories', 'ground1' + '0000');
                    this.ground0_1.setOrigin(0.5, 1);
                    this.ground0_2 = this.scene.add.image(this.ground0_1.x + this.ground0_1.width, this.ground0_1.y, 'stories', 'ground1' + '0000');
                    this.ground0_2.setOrigin(0.5, 1);
                    this._nuget = this.scene.add.sprite(-350, 300, 'stories', '_nuget' + '0000');
                    this._nuget.setOrigin(0.5, 1);
                    this._chick = this.scene.add.sprite(-200, 302, 'stories', '_chick' + '0000');
                    this._chick.setOrigin(0.5, 1);
                    this.add([this._bg, this.ground0_1, this.ground0_2, this._chick, this._nuget]);
                    this.scene.tweens.add({
                        targets: this._bg,
                        duration: 6000,
                        x: this._bg.x - 150,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this.ground0_1,
                        duration: 6000,
                        x: this.ground0_1.x - 200,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this.ground0_2,
                        duration: 6000,
                        x: this.ground0_2.x - 200,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this._nuget,
                        duration: 4000,
                        x: this._nuget.x + 875,
                    });
                    this.scene.tweens.add({
                        targets: this._chick,
                        duration: 4000,
                        x: this._chick.x + 825,
                        delay: 150
                    });
                    let anim = nscs.gameplay.Factory.createAnimName('_nuget', 'walking');
                    if (!this.scene.anims.exists(anim)) {
                        this.scene.anims.create({
                            key: anim,
                            frames: this.scene.anims.generateFrameNames(this._nuget.texture.key, {
                                start: 0, end: 30, zeroPad: 4,
                                prefix: '_nuget', suffix: ''
                            }),
                            repeat: -1,
                            frameRate: 60
                        });
                    }
                    nscs.util.Functions.delayedCall(150, () => {
                        this._nuget.play(anim);
                    });
                    let _anim = nscs.gameplay.Factory.createAnimName('_chick', 'walking');
                    if (!this.scene.anims.exists(_anim)) {
                        this.scene.anims.create({
                            key: _anim,
                            frames: this.scene.anims.generateFrameNames(this._chick.texture.key, {
                                start: 0, end: 30, zeroPad: 4,
                                prefix: '_chick', suffix: ''
                            }),
                            repeat: -1,
                            frameRate: 60
                        });
                    }
                    this._chick.play(_anim);
                    nscs.util.Functions.delayedCall(4500, () => {
                        this.showSecondPart();
                    });
                }
                showSecondPart() {
                    AnimationRunningCharacters_4.showAngryMan(200, 325, this, 1);
                    stories.AnimationRunningCharacters_2.showDust(300, 450, this, 1);
                }
                static showAngryMan(x, y, parent, ind) {
                    let cnt = new Phaser.GameObjects.Container(parent.scene);
                    cnt.setPosition(x, y);
                    let man = new Phaser.GameObjects.Image(parent.scene, -10, 50, 'stories', 'man' + '0000');
                    cnt.add(man);
                    man.scaleX = -1;
                    parent.scene.tweens.add({
                        targets: man,
                        duration: 1000,
                        y: -75,
                        delay: 1000
                    });
                    let hand = new Phaser.GameObjects.Image(parent.scene, 35, 50, 'stories', 'hand' + '0000');
                    cnt.add(hand);
                    parent.scene.tweens.add({
                        targets: hand,
                        duration: 1200,
                        y: -100,
                        delay: 1000
                    });
                    let handkey = new Phaser.GameObjects.Image(parent.scene, 60, -137 + 150, 'stories', 'handkey' + '0000');
                    cnt.add(handkey);
                    parent.scene.tweens.add({
                        targets: handkey,
                        duration: 1200,
                        y: -137,
                        delay: 1000
                    });
                    let key_ = new Phaser.GameObjects.Image(parent.scene, 61, -138 + 150, 'stories', 'key_' + '0000');
                    cnt.add(key_);
                    parent.scene.tweens.add({
                        targets: key_,
                        duration: 1200,
                        y: -138,
                        delay: 1000
                    });
                    let hand_ = new Phaser.GameObjects.Image(parent.scene, 46, -125 + 150, 'stories', 'hand_' + '0000');
                    cnt.add(hand_);
                    parent.scene.tweens.add({
                        targets: hand_,
                        duration: 1200,
                        y: -125,
                        delay: 1000
                    });
                    parent.scene.tweens.add({
                        targets: hand,
                        duration: 350,
                        angle: -10,
                        delay: 2000,
                        onComplete: () => {
                            parent.scene.tweens.add({
                                targets: hand,
                                duration: 250,
                                angle: 10,
                                onComplete: () => {
                                    handkey.visible = false;
                                    hand_.visible = true;
                                    parent.scene.tweens.add({
                                        targets: key_,
                                        duration: 750,
                                        angle: 360,
                                        x: key_.x + 300,
                                        y: key_.y + 50,
                                        ease: Phaser.Math.Easing.Cubic.Out
                                    });
                                    parent.scene.tweens.add({
                                        targets: man,
                                        duration: 1000,
                                        y: man.y + 30,
                                        delay: 1000
                                    });
                                    parent.scene.tweens.add({
                                        targets: hand,
                                        duration: 1000,
                                        y: hand.y + 40,
                                        delay: 1000
                                    });
                                    parent.scene.tweens.add({
                                        targets: hand_,
                                        duration: 1000,
                                        y: hand_.y + 40,
                                        delay: 1000
                                    });
                                }
                            });
                        }
                    });
                    let obj_ = new Phaser.GameObjects.Image(parent.scene, 2, 0, 'stories', 'obj_' + '0000');
                    cnt.add(obj_);
                    parent.scene.tweens.add({
                        targets: obj_,
                        duration: 1000,
                        y: -50,
                        delay: 0
                    });
                    parent.addAt(cnt, ind);
                    return cnt;
                }
            }
            stories.AnimationRunningCharacters_4 = AnimationRunningCharacters_4;
        })(stories = screen.stories || (screen.stories = {}));
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        var stories;
        (function (stories) {
            class AnimationRunningCharacters_5 extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.frame = { name: 'AnimationRunningCharacters_5' };
                    this._bg = this.scene.add.image(-500, -200, 'bg-atlas', 'bg4' + '0000');
                    this._bg.setOrigin(0, 0);
                    this._bg.setScale(1.6);
                    this.ground0_1 = this.scene.add.image(game.scale.width / 2, 325, 'stories', 'ground2' + '0000');
                    this.ground0_1.setOrigin(0.5, 1);
                    this.ground0_2 = this.scene.add.image(this.ground0_1.x + this.ground0_1.width, this.ground0_1.y, 'stories', 'ground2' + '0000');
                    this.ground0_2.setOrigin(0.5, 1);
                    this._nuget = this.scene.add.sprite(-350, 300, 'stories', '_nuget' + '0000');
                    this._nuget.setOrigin(0.5, 1);
                    this._chick = this.scene.add.sprite(-200, 302, 'stories', '_chick' + '0000');
                    this._chick.setOrigin(0.5, 1);
                    this.add([this._bg, this.ground0_1, this.ground0_2, this._chick, this._nuget]);
                    this.scene.tweens.add({
                        targets: this._bg,
                        duration: 6000,
                        x: this._bg.x - 150,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this.ground0_1,
                        duration: 6000,
                        x: this.ground0_1.x - 200,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this.ground0_2,
                        duration: 6000,
                        x: this.ground0_2.x - 200,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this._nuget,
                        duration: 4000,
                        x: this._nuget.x + 875,
                    });
                    this.scene.tweens.add({
                        targets: this._chick,
                        duration: 4000,
                        x: this._chick.x + 825,
                        delay: 150
                    });
                    let anim = nscs.gameplay.Factory.createAnimName('_nuget', 'walking');
                    if (!this.scene.anims.exists(anim)) {
                        this.scene.anims.create({
                            key: anim,
                            frames: this.scene.anims.generateFrameNames(this._nuget.texture.key, {
                                start: 0, end: 30, zeroPad: 4,
                                prefix: '_nuget', suffix: ''
                            }),
                            repeat: -1,
                            frameRate: 60
                        });
                    }
                    nscs.util.Functions.delayedCall(150, () => {
                        this._nuget.play(anim);
                    });
                    let _anim = nscs.gameplay.Factory.createAnimName('_chick', 'walking');
                    if (!this.scene.anims.exists(_anim)) {
                        this.scene.anims.create({
                            key: _anim,
                            frames: this.scene.anims.generateFrameNames(this._chick.texture.key, {
                                start: 0, end: 30, zeroPad: 4,
                                prefix: '_chick', suffix: ''
                            }),
                            repeat: -1,
                            frameRate: 60
                        });
                    }
                    this._chick.play(_anim);
                    nscs.util.Functions.delayedCall(4500, () => {
                        this.showSecondPart();
                    });
                }
                showSecondPart() {
                    AnimationRunningCharacters_5.showAngryMan(250, 325, this, 1);
                    stories.AnimationRunningCharacters_2.showDust(300, 450, this, 1);
                }
                static showAngryMan(x, y, parent, ind) {
                    let cnt = new Phaser.GameObjects.Container(parent.scene);
                    cnt.setPosition(x, y);
                    let man = new Phaser.GameObjects.Image(parent.scene, -10, 50, 'stories', 'man' + '0000');
                    cnt.add(man);
                    man.scaleX = -1;
                    parent.scene.tweens.add({
                        targets: man,
                        duration: 1000,
                        y: -75,
                        delay: 1000
                    });
                    let hand = new Phaser.GameObjects.Image(parent.scene, 25, 50, 'stories', 'hand' + '0000');
                    cnt.add(hand);
                    parent.scene.tweens.add({
                        targets: hand,
                        duration: 1200,
                        y: -100,
                        delay: 1000
                    });
                    let hand_ = new Phaser.GameObjects.Image(parent.scene, 33, -125 + 150, 'stories', 'hand_' + '0000');
                    cnt.add(hand_);
                    parent.scene.tweens.add({
                        targets: hand_,
                        duration: 1200,
                        y: -125,
                        delay: 1000
                    });
                    let mask_ = new Phaser.GameObjects.Image(parent.scene, 25, 50, 'stories', 'mask_' + '0000');
                    cnt.add(mask_);
                    mask_.scaleX = 0.1;
                    mask_.originX = 1;
                    parent.scene.tweens.add({
                        targets: mask_,
                        duration: 1200,
                        angle: 10,
                        y: -100,
                        delay: 1000
                    });
                    parent.scene.tweens.add({
                        targets: hand,
                        duration: 350,
                        angle: -10,
                        delay: 2000,
                        onComplete: () => {
                            parent.scene.tweens.add({
                                targets: mask_,
                                duration: 500,
                                scaleX: 1,
                                angle: 5,
                                x: -15,
                                y: -120,
                                onComplete: () => {
                                    parent.scene.tweens.add({
                                        targets: mask_,
                                        duration: 200,
                                        y: mask_.y + 5,
                                        yoyo: true,
                                        repeat: 2,
                                        delay: 1000,
                                        onComplete: () => {
                                            parent.scene.tweens.add({
                                                targets: man,
                                                duration: 1000,
                                                y: man.y + 95,
                                                delay: 1000
                                            });
                                            parent.scene.tweens.add({
                                                targets: hand_,
                                                duration: 800,
                                                y: hand_.y + 95,
                                                delay: 1000
                                            });
                                            parent.scene.tweens.add({
                                                targets: hand,
                                                duration: 800,
                                                y: hand.y + 95,
                                                delay: 1000
                                            });
                                            parent.scene.tweens.add({
                                                targets: mask_,
                                                duration: 1000,
                                                y: mask_.y + 95,
                                                delay: 1000
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });
                    let obj_ = new Phaser.GameObjects.Image(parent.scene, 2, 0, 'stories', 'obj_' + '0000');
                    cnt.add(obj_);
                    parent.scene.tweens.add({
                        targets: obj_,
                        duration: 1000,
                        y: -50,
                        delay: 0
                    });
                    parent.addAt(cnt, ind);
                    return cnt;
                }
            }
            stories.AnimationRunningCharacters_5 = AnimationRunningCharacters_5;
        })(stories = screen.stories || (screen.stories = {}));
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        var stories;
        (function (stories) {
            class AnimationStory_2_1 extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.frame = { name: 'AnimationStory_2_1' };
                    this._bg = this.scene.add.image(-100, -100, 'bg-atlas', 'bg2' + '0000');
                    this._bg.setOrigin(0, 0);
                    this.story_2_1_2 = this.scene.add.image(250, 30, 'stories', 'story_2_1_2' + '0000');
                    this.story_2_1_2.setOrigin(0, 0);
                    this.story_2_1_1 = this.scene.add.image(350, 275, 'stories', 'story_2_1_1' + '0000');
                    this.story_2_1_1.setOrigin(0.5, 1);
                    this.add([this._bg, this.story_2_1_2, this.story_2_1_1]);
                    this.scene.tweens.add({
                        targets: this._bg,
                        duration: 3000,
                        x: this._bg.x - 50,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this.story_2_1_2,
                        duration: 2500,
                        x: this.story_2_1_2.x - 135,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this.story_2_1_1,
                        duration: 3000,
                        x: this.story_2_1_1.x - 200,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    let r = new Phaser.GameObjects.Graphics(this.scene);
                    r.setPosition(0, 245);
                    r.fillStyle(0x0, 1);
                    r.fillRect(0, 0, game.scale.width, 200);
                    this.add(r);
                }
            }
            stories.AnimationStory_2_1 = AnimationStory_2_1;
        })(stories = screen.stories || (screen.stories = {}));
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        var stories;
        (function (stories) {
            class AnimationStory_4_1 extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.frame = { name: 'AnimationStory_4_1' };
                    this._bg = this.scene.add.image(-100, -100, 'bg-atlas', 'bg3' + '0000');
                    this._bg.setOrigin(0, 0);
                    this.story_2_1_2 = this.scene.add.image(250, 0, 'stories', 'story_4_1_2' + '0000');
                    this.story_2_1_2.setOrigin(0, 0);
                    this.story_2_1_1 = this.scene.add.image(350, 272, 'stories', 'story_2_1_1' + '0000');
                    this.story_2_1_1.setOrigin(0.5, 1);
                    this.add([this._bg, this.story_2_1_2, this.story_2_1_1]);
                    this.scene.tweens.add({
                        targets: this._bg,
                        duration: 3000,
                        x: this._bg.x - 50,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this.story_2_1_2,
                        duration: 2500,
                        x: this.story_2_1_2.x - 135,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this.story_2_1_1,
                        duration: 3000,
                        x: this.story_2_1_1.x - 200,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    let r = new Phaser.GameObjects.Graphics(this.scene);
                    r.setPosition(0, 242);
                    r.fillStyle(0x0, 1);
                    r.fillRect(0, 0, game.scale.width, 200);
                    this.add(r);
                }
            }
            stories.AnimationStory_4_1 = AnimationStory_4_1;
        })(stories = screen.stories || (screen.stories = {}));
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        var stories;
        (function (stories) {
            class AnimationStory_6_1 extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.frame = { name: 'AnimationStory_6_1' };
                    this._bg = this.scene.add.image(-100, -100, 'bg-atlas', 'bg5' + '0000');
                    this._bg.setOrigin(0, 0);
                    this._ground = this.scene.add.image(0, 320, 'stories', 'ground3' + '0000');
                    this._ground.setOrigin(0, 1);
                    this._ground1 = this.scene.add.image(this._ground.width, 320, 'stories', 'ground3' + '0000');
                    this._ground1.setOrigin(0, 1);
                    this._nuget = this.scene.add.sprite(90 - 200, 300, 'stories', '_nuget' + '0000');
                    this._nuget.setOrigin(0.5, 1);
                    this._chick = this.scene.add.sprite(135 - 200, 302, 'stories', '_chick' + '0000');
                    this._chick.setOrigin(0.5, 1);
                    this._pam = this.scene.add.sprite(385 + 200, 297, 'stories', '_pam' + '0000');
                    this._pam.setOrigin(0.5, 1);
                    this.add([this._bg, this._ground, this._ground1, this._chick, this._nuget, this._pam]);
                    this.scene.tweens.add({
                        targets: this._bg,
                        duration: 2000,
                        x: -200,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this._ground,
                        duration: 2000,
                        x: this._ground.x - 200,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this._ground1,
                        duration: 2000,
                        x: this._ground1.x - 200,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this._pam,
                        duration: 2000,
                        x: this._pam.x - 200,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this._nuget,
                        duration: 2000,
                        x: this._nuget.x + 200,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    this.scene.tweens.add({
                        targets: this._chick,
                        duration: 2000,
                        x: this._chick.x + 200,
                        ease: Phaser.Math.Easing.Cubic.Out
                    });
                    let anim = nscs.gameplay.Factory.createAnimName('_nuget', 'walk');
                    if (!this.scene.anims.exists(anim)) {
                        this.scene.anims.create({
                            key: anim,
                            frames: this.scene.anims.generateFrameNames(this._nuget.texture.key, {
                                start: 0, end: 30, zeroPad: 4,
                                prefix: '_nuget', suffix: ''
                            }),
                            repeat: 2,
                            frameRate: 60
                        });
                    }
                    this._nuget.play(anim);
                    let _anim = nscs.gameplay.Factory.createAnimName('_chick', 'walk');
                    if (!this.scene.anims.exists(_anim)) {
                        this.scene.anims.create({
                            key: _anim,
                            frames: this.scene.anims.generateFrameNames(this._chick.texture.key, {
                                start: 0, end: 30, zeroPad: 4,
                                prefix: '_chick', suffix: ''
                            }),
                            repeat: 2,
                            frameRate: 60
                        });
                    }
                    nscs.util.Functions.delayedCall(150, () => {
                        this._chick.play(_anim);
                    });
                    nscs.util.Functions.delayedCall(2000, () => {
                        this.showSpeechDialog("activist19");
                        nscs.util.Functions.delayedCall(13000, () => {
                            this.showSpeechDialog("activist20");
                            nscs.util.Functions.delayedCall(5000, () => {
                                nscs.util.Functions.delayedCall(150, () => {
                                    this._chick.play(_anim);
                                });
                                this._nuget.play(anim);
                                this.showSecondPart();
                            });
                        });
                    });
                }
                createGraphicsRect() {
                    let r = new Phaser.GameObjects.Graphics(this.scene);
                    r.setPosition(0, 0);
                    r.fillStyle(0xFFFFFF, 1);
                    r.fillRect(0, 0, game.scale.width, game.scale.height);
                    return r;
                }
                showSecondPart() {
                    let r = this.createGraphicsRect();
                    this.add(r);
                    r.alpha = 0;
                    this.scene.tweens.add({
                        targets: r,
                        alpha: 1,
                        duration: 3500,
                        onComplete: () => {
                            let s = new stories.AnimationStory_6_2(this.scene);
                            this.addAt(s, this.getIndex(r));
                            this.scene.tweens.add({
                                targets: r,
                                alpha: 0,
                                duration: 3500,
                                onComplete: () => {
                                    this.remove(r);
                                }
                            });
                        }
                    });
                }
                showSpeechDialog(textKey) {
                    this._bubblex_mc = new Phaser.GameObjects.Image(this.scene, 240, 140, 'ui-atlas', 'bubblex_mc' + '0000');
                    this._bubblex_mc.setOrigin(0.5, 1);
                    this.add(this._bubblex_mc);
                    this._mouthPiece_mc = new Phaser.GameObjects.Image(this.scene, 240, 130, 'ui-atlas', 'mouthPiece_mc' + '0000');
                    this._mouthPiece_mc.setOrigin(0.5, 1);
                    this.add(this._mouthPiece_mc);
                    this._bubblex_mc.alpha = 0.5;
                    this._bubblex_mc.scaleX = 0.75;
                    this.scene.tweens.add({
                        targets: this._bubblex_mc,
                        duration: 500,
                        scale: 1,
                        alpha: 1,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this._mouthPiece_mc.alpha = 0.5;
                    this._mouthPiece_mc.scale = 0.72;
                    this.scene.tweens.add({
                        targets: this._mouthPiece_mc,
                        duration: 500,
                        scale: 0.72,
                        alpha: 1,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.add(this._bubblex_mc);
                    this._tf = this.scene.add.text(20, 30, "", {
                        "fontFamily": "Helvetica Rounded LT Black",
                        "fontSize": 10,
                        "color": "#000000",
                        "align": 'left'
                    });
                    this._tf.setOrigin(0, 0);
                    this._tf.setWordWrapWidth(455);
                    this.add(this._tf);
                    let textTyper = new nscs.util.TextTyper(this.scene, this._tf, null);
                    textTyper.typeText(nscs.gameplay.Gameplay.getText(textKey));
                }
            }
            stories.AnimationStory_6_1 = AnimationStory_6_1;
        })(stories = screen.stories || (screen.stories = {}));
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        var stories;
        (function (stories) {
            class AnimationStory_6_2 extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.frame = { name: 'AnimationStory_6_2' };
                    this._bg = this.scene.add.image(-100, -100, 'bg-atlas', 'bg5' + '0000');
                    this._bg.setOrigin(0, 0);
                    let shine = this.scene.add.sprite(game.scale.width / 2, 300, 'stories', 'shine' + '0000');
                    shine.setOrigin(0.5, 0.5);
                    let gopam = this.scene.add.sprite(game.scale.width / 2, 75, 'stories', 'gopam' + '0000');
                    gopam.setOrigin(0.5, 0.5);
                    this._blackfg = this.scene.add.image(game.scale.width / 2, 385, 'stories', 'blackfg' + '0000');
                    this._blackfg.setOrigin(0.5, 1);
                    this.charsGoingOut_ = this.scene.add.sprite(game.scale.width / 2, 295, 'stories', 'charsGoingOut_' + '0000');
                    this.charsGoingOut_.setOrigin(0.5, 1);
                    this.add([this._bg, shine, this._blackfg, gopam, this.charsGoingOut_]);
                    this.charsGoingOut_.tint = 0xFFFFFF;
                    this.scene.tweens.add({
                        targets: this.charsGoingOut_,
                        duration: 7000,
                        scale: 0.5,
                        y: this.charsGoingOut_.y - 10,
                        tint: 0
                    });
                    this.scene.tweens.add({
                        targets: shine,
                        duration: 2500,
                        scale: 1.1,
                        alpha: 0.7,
                        repeat: -1,
                        yoyo: true
                    });
                    let anim = nscs.gameplay.Factory.createAnimName('charsGoingOut_', 'walk');
                    if (!this.scene.anims.exists(anim)) {
                        this.scene.anims.create({
                            key: anim,
                            frames: this.scene.anims.generateFrameNames(this.charsGoingOut_.texture.key, {
                                start: 0, end: 2, zeroPad: 4,
                                prefix: 'charsGoingOut_', suffix: ''
                            }),
                            repeat: -1,
                            frameRate: 8
                        });
                    }
                    this.charsGoingOut_.play(anim);
                    let chick_mc_anim = 'tinyChickMC-anim';
                    if (!this.scene.anims.exists(chick_mc_anim)) {
                        this.scene.anims.create({
                            key: chick_mc_anim,
                            frames: this.scene.anims.generateFrameNames('objects-atlas', {
                                start: 0, end: 15, zeroPad: 4,
                                prefix: 'tinyChickMC', suffix: ''
                            }),
                            frameRate: 60,
                            repeat: -1
                        });
                    }
                    for (var i = 0; i < 40; i++) {
                        let left = Math.random() > 0.5;
                        let s = this.scene.add.sprite(left ? 120 - Math.random() * 75 : 340 - Math.random() * 75, 400, 'objects-atlas', 'tinyChickMC0000');
                        this.add(s);
                        s.tint = 0;
                        s.setScale(1.25 + Math.random() * 0.5);
                        this.scene.tweens.add({
                            targets: s,
                            duration: 3500,
                            y: s.y - 350 - Math.random() * 100,
                            x: left ? s.x - 50 : s.x + 50,
                            scale: 0,
                            delay: 300 * i,
                            onStart: () => nscs.sound.SoundManager.getInstance().playSound('whistleSND', 0.25)
                        });
                        s.play(chick_mc_anim);
                    }
                }
            }
            stories.AnimationStory_6_2 = AnimationStory_6_2;
        })(stories = screen.stories || (screen.stories = {}));
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var sound;
    (function (sound) {
        class SoundManager {
            constructor(scene) {
                this.music = null;
                this.sounds = [];
                this.muted = false;
                this.currentMusic = "";
                this.scene = scene;
            }
            static getInstance() {
                if (!SoundManager._instance) {
                    SoundManager._instance = new SoundManager(game.scene.getAt(0));
                }
                return SoundManager._instance;
            }
            playMusic(filename, loop = false) {
                if (this.currentMusic == filename) {
                    return;
                }
                this.stopMusic();
                this.music = this.scene.sound.add(filename);
                this.music["filename"] = filename;
                this.music.loop = loop;
                this.music.play();
                this.music.setVolume(this.muted ? 0 : 1);
                this.currentMusic = filename;
            }
            stopMusic() {
                this.currentMusic = "";
                if (this.music)
                    this.music.stop();
            }
            mute() {
                if (this.muted) {
                    this.muted = false;
                    if (this.music)
                        this.revertMusic(1000);
                }
                else {
                    this.muted = true;
                    if (this.music)
                        this.fadeMusic(null, 1000);
                }
            }
            playSound(filename, volume = 1) {
                let snd = filename;
                try {
                    let s = this.scene.sound.add(snd);
                    s["filename"] = filename;
                    s.play();
                    if (this.muted) {
                        s.setVolume(0);
                    }
                    else {
                        s.setVolume(volume);
                    }
                    this.sounds.push(s);
                }
                catch (_a) {
                }
            }
            stopSound() {
                for (let s of this.sounds)
                    s.stop();
            }
            fadeMusic(to, time, loop = false) {
                if (this.currentMusic == to)
                    return;
                if (this.music) {
                    let _music = this.music;
                    this.scene.tweens.add({
                        targets: _music,
                        "volume": 0,
                        duration: time,
                        ease: Phaser.Math.Easing.Linear,
                        onComplete: () => {
                            if (to)
                                _music.stop();
                        }
                    });
                    if (to) {
                        this.music = null;
                        this.currentMusic = null;
                    }
                }
                if (!to)
                    return;
                this.playMusic(to, loop);
                this.music.setVolume(0);
                if (!this.muted) {
                    this.scene.tweens.add({
                        targets: this.music,
                        "volume": 1,
                        duration: time,
                        ease: Phaser.Math.Easing.Linear
                    });
                }
            }
            revertMusic(time) {
                if (this.music) {
                    let _music = this.music;
                    this.scene.tweens.add({
                        targets: _music,
                        "volume": this.muted ? 0 : 1,
                        duration: time,
                        ease: Phaser.Math.Easing.Linear
                    });
                }
            }
        }
        SoundManager._instance = null;
        sound.SoundManager = SoundManager;
    })(sound = nscs.sound || (nscs.sound = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var util;
    (function (util) {
        class Functions {
            static rewriteWordWrapping() {
                (function (setWordWrapWidth) {
                    Phaser.GameObjects.Text.prototype.setWordWrapWidth = function (t, e) {
                        if (!this.hasOwnProperty('-wordWrapWidth-')) {
                            this['-wordWrapWidth-'] = t;
                        }
                        if (typeof e === "undefined")
                            e = true;
                        // Now, call the original method
                        return setWordWrapWidth.apply(this, [t, e]);
                    };
                })(Phaser.GameObjects.Text.prototype.setWordWrapWidth);
            }
            static updateTextFieldPosition(textField, setText = null) {
                if (!textField.hasOwnProperty('-fontSize-')) {
                    let fontSize = Number(textField.style.fontSize.split('px')[0]);
                    textField["-fontSize-"] = fontSize;
                    textField.setFontSize(fontSize * Functions.SCALE_UP_TEXT_FIELDS);
                    textField.setScale(1 / Functions.SCALE_UP_TEXT_FIELDS);
                    if (textField['-wordWrapWidth-']) {
                        textField.setWordWrapWidth(textField['-wordWrapWidth-'] * Functions.SCALE_UP_TEXT_FIELDS);
                    }
                }
                if (!textField.hasOwnProperty('-strokeThickness-')) {
                    if (textField.style.stroke) {
                        textField["-strokeThickness-"] = textField.style.strokeThickness;
                        textField.setStroke(textField.style.stroke, textField.style.strokeThickness * Functions.SCALE_UP_TEXT_FIELDS);
                    }
                }
                if (!textField.hasOwnProperty('-originX-')) {
                    textField["-originX-"] = textField.originX;
                    textField.originX = 0;
                }
                if (!textField.hasOwnProperty('-originY-')) {
                    textField["-originY-"] = textField.originY;
                    textField.originY = 0;
                }
                if (!textField.hasOwnProperty('-def-x-')) {
                    textField['-def-x-'] = textField.x;
                }
                if (!textField.hasOwnProperty('-def-y-')) {
                    textField['-def-y-'] = textField.y;
                }
                if (setText) {
                    textField.setText(setText);
                }
                textField.x = Math.round(textField['-def-x-'] - textField.width * textField.scaleX * textField["-originX-"]);
                textField.y = Math.round(textField['-def-y-'] - textField.height * textField.scaleY * textField["-originY-"]);
            }
            static delayedCall(delay, callback, args, callbackScope) {
                let scene = game.scene.getAt(0);
                if (scene) {
                    let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
                    Functions.delayedCalls.push(dc);
                    return dc;
                }
                let t = setTimeout(callback, delay);
                Functions.delayedCalls.push(t);
                return t;
            }
            static pauseAllDelayedCalls() {
                for (let dc of Functions.delayedCalls) {
                    if (dc instanceof Phaser.Time.TimerEvent) {
                        dc.paused = true;
                    }
                }
            }
            static resumeAllDelayedCalls() {
                for (let dc of Functions.delayedCalls) {
                    if (dc instanceof Phaser.Time.TimerEvent) {
                        dc.paused = false;
                    }
                }
            }
            static destroyAllDelayedCalls() {
                for (let dc of Functions.delayedCalls) {
                    if (dc instanceof Phaser.Time.TimerEvent) {
                        dc.remove(false);
                    }
                    else {
                        clearTimeout(dc);
                    }
                }
                Functions.delayedCalls = [];
            }
            static destroyDelayedCall(dc) {
                let ind = Functions.delayedCalls.indexOf(dc);
                if (ind >= 0) {
                    Functions.delayedCalls.splice(ind, 1);
                }
                if (dc instanceof Phaser.Time.TimerEvent) {
                    dc.remove(false);
                }
                else {
                    clearTimeout(dc);
                }
            }
            static capitalise(str) {
                let newstr = '';
                let words = str.split(' ');
                for (let w = 0; w < words.length; w++) {
                    let word = words[w];
                    word = word.substr(0, 1).toUpperCase() + word.substr(1);
                    newstr += (newstr) ? ' ' : '';
                    newstr += word;
                }
                return newstr;
            }
            static trim(str) {
                let newline = '\n';
                while (str.substr(0, 1) == ' ') {
                    str = str.substr(1);
                }
                while (str.substr(0, 1) == newline) {
                    str = str.substr(1);
                }
                while (str.substr(0, 1) == '    ') {
                    str = str.substr(0, -1);
                }
                while (str.substr(-1, 1) == ' ') {
                    str = str.substr(0, -1);
                }
                while (str.substr(-1, 1) == newline) {
                    str = str.substr(0, -1);
                }
                while (str.substr(-1, 1) == '    ') {
                    str = str.substr(0, -1);
                }
                return str;
            }
            static DetectPhaserRenderMode() {
                // var ua = window.navigator.userAgent;
                // var isIE = ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0;
                // var isOldIPhone = (ua.indexOf('iPhone ') > -1 && window.screen.width <= 414 && window.screen.height <= 736);
                // var isFirefox = ua.toLowerCase().indexOf('firefox') > -1;
                // var isAndroid = ua.toLowerCase().indexOf("android") > -1;
                // if (isIE) return Phaser.CANVAS;
                // if (isFirefox) return Phaser.WEBGL;
                return Phaser.AUTO;
            }
            ;
            static pad(n, width, z) {
                z = z || '0';
                n = n + '';
                return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
            }
            ;
        }
        Functions.SCALE_UP_TEXT_FIELDS = 3;
        Functions.delayedCalls = [];
        util.Functions = Functions;
    })(util = nscs.util || (nscs.util = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var util;
    (function (util) {
        class TextTyper {
            constructor(scene, textField, onComplete = null) {
                this.typeCounter = 0;
                this.typeString = "";
                this.advanceLetter = () => {
                    if (!this.textField.parentContainer)
                        return;
                    var nextSpace = NaN;
                    var prevSpace = NaN;
                    var prevHeight = NaN;
                    this.typeCounter++;
                    if (this.typeCounter <= this.typeString.length) {
                        // GameWorld.soundManager.playSound("dialog");
                        nextSpace = this.typeString.indexOf(" ", this.typeCounter);
                        if (nextSpace == -1) {
                            nextSpace = this.typeString.length;
                        }
                        prevSpace = Math.max(0, this.typeString.lastIndexOf(" ", this.typeCounter));
                        nscs.util.Functions.updateTextFieldPosition(this.textField, this.typeString.substr(0, this.typeCounter));
                        prevHeight = this.textField.height;
                        nscs.util.Functions.updateTextFieldPosition(this.textField, this.typeString.substr(0, nextSpace));
                        if (prevHeight != this.textField.height && (this.typeString.indexOf("\n", prevSpace) >= nextSpace || this.typeString.indexOf("\n", prevSpace) == -1)) {
                            nscs.util.Functions.updateTextFieldPosition(this.textField, this.typeString.substr(0, prevSpace) + "\n" + this.typeString.substr(prevSpace + 1, this.typeCounter - (prevSpace + 1)));
                        }
                        else {
                            nscs.util.Functions.updateTextFieldPosition(this.textField, this.typeString.substr(0, this.typeCounter));
                        }
                    }
                    else {
                        nscs.util.Functions.updateTextFieldPosition(this.textField, this.typeString.substr(0, this.typeString.length));
                        this.stop();
                        if (this.onComplete)
                            this.onComplete();
                    }
                };
                this.scene = scene;
                this.textField = textField;
                this.onComplete = onComplete;
            }
            typeText(newString, speed = 1 / 45) {
                nscs.util.Functions.updateTextFieldPosition(this.textField, "");
                this.typeCounter = 0;
                this.typeString = newString;
                this.stop();
                this.typeTimer = this.scene.time.addEvent({
                    delay: 1 / speed,
                    callback: this.advanceLetter,
                    callbackScope: this,
                    loop: true
                });
            }
            setText(newText) {
                this.typeCounter = this.typeString.length;
                nscs.util.Functions.updateTextFieldPosition(this.textField, newText);
                this.stop();
            }
            isDone() {
                return /*this.lines.length == 0 && */ this.typeCounter >= this.typeString.length;
            }
            stop() {
                if (this.typeTimer) {
                    this.typeTimer.remove();
                    this.typeTimer = null;
                }
            }
        }
        util.TextTyper = TextTyper;
    })(util = nscs.util || (nscs.util = {}));
})(nscs || (nscs = {}));
